<template>
  <div class="area">
    <div class="areatext" @click="showAddress">
      {{ navData.length === 0 ? "请点击" : navData.map(m => m.name).join("/") }}
    </div>

    <div class="hoverarea" v-if="isHover">
      <div class="navtab">
        <div class="nav" v-if="navData.length === 0">请选择</div>
        <div class="nav" v-else v-for="(item, index) in navData" :key="index">
          {{ item.name }}
        </div>
      </div>
      <div class="list">
        <div
          class="areaitem"
          @click="
            chooseAddress(
              item.name,
              nowData.idx === 2 ? item.id : key,
              nowData.idx
            )
          "
          v-for="(item, key, index) in nowData.data"
          :key="index"
        >
          {{ item.name }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from 'vue'
export default {
  props: {
    parentData: Array
  },
  setup (props, context) {
    const provinceData = {
      1: { name: '北京市' },
      2: { name: '上海市' },
      3: { name: '天津市' },
      4: { name: '重庆市' },
      5: { name: '河北省' },
      6: { name: '山西省' },
      7: { name: '河南省' },
      8: { name: '辽宁省' },
      9: { name: '吉林省' },
      10: { name: '黑龙江省' },
      11: { name: '内蒙古省' },
      12: { name: '江苏省' },
      13: { name: '山东省' },
      14: { name: '安徽省' },
      15: { name: '浙江省' },
      16: { name: '福建省' },
      17: { name: '湖北省' },
      18: { name: '湖南省' },
      19: { name: '广东省' },
      20: { name: '广西省' },
      21: { name: '江西省' },
      22: { name: '四川省' },
      23: { name: '海南省' },
      24: { name: '贵州省' },
      25: { name: '云南省' },
      26: { name: '西藏省' },
      27: { name: '陕西省' },
      28: { name: '甘肃省' },
      29: { name: '青海省' },
      30: { name: '宁夏省' },
      31: { name: '新疆省' },
      32: { name: '台湾' },
      84: { name: '钓鱼岛' },
      52993: { name: '港澳' }
    }

    const cityData = {
      1: [
        { id: '2816', name: '密云区' },
        { id: '72', name: '朝阳区' },
        { id: '2901', name: '昌平区' },
        { id: '2953', name: '平谷区' },
        { id: '2800', name: '海淀区' },
        { id: '2801', name: '西城区' },
        { id: '2802', name: '东城区' },
        { id: '2803', name: '崇文区' },
        { id: '2804', name: '宣武区' },
        { id: '2805', name: '丰台区' },
        { id: '2806', name: '石景山区' },
        { id: '2807', name: '门头沟' },
        { id: '2808', name: '房山区' },
        { id: '2809', name: '通州区' },
        { id: '3065', name: '延庆县' },
        { id: '2810', name: '大兴区' },
        { id: '2812', name: '顺义区' },
        { id: '2814', name: '怀柔区' }
      ],
      2: [
        { id: '2817', name: '静安区' },
        { id: '2820', name: '闸北区' },
        { id: '2822', name: '虹口区' },
        { id: '2823', name: '杨浦区' },
        { id: '2824', name: '宝山区' },
        { id: '2825', name: '闵行区' },
        { id: '2826', name: '嘉定区' },
        { id: '2830', name: '浦东新区' },
        { id: '2833', name: '青浦区' },
        { id: '2834', name: '松江区' },
        { id: '2835', name: '金山区' },
        { id: '2837', name: '奉贤区' },
        { id: '2841', name: '普陀区' },
        { id: '78', name: '黄浦区' },
        { id: '2919', name: '崇明县' },
        { id: '2813', name: '徐汇区' },
        { id: '2815', name: '长宁区' }
      ],
      3: [
        { id: '51035', name: '东丽区' },
        { id: '51036', name: '和平区' },
        { id: '51037', name: '河北区' },
        { id: '51038', name: '河东区' },
        { id: '51039', name: '河西区' },
        { id: '51040', name: '红桥区' },
        { id: '51041', name: '蓟县' },
        { id: '51042', name: '静海县' },
        { id: '51043', name: '南开区' },
        { id: '51044', name: '塘沽区' },
        { id: '51045', name: '西青区' },
        { id: '51046', name: '武清区' },
        { id: '51047', name: '津南区' },
        { id: '51048', name: '汉沽区' },
        { id: '51049', name: '大港区' },
        { id: '51050', name: '北辰区' },
        { id: '51051', name: '宝坻区' },
        { id: '51052', name: '宁河县' }
      ],
      4: [
        { id: '48131', name: '璧山县' },
        { id: '48132', name: '荣昌县' },
        { id: '48133', name: '铜梁县' },
        { id: '50950', name: '江北区' },
        { id: '50951', name: '南岸区' },
        { id: '50952', name: '九龙坡区' },
        { id: '50953', name: '沙坪坝区' },
        { id: '50954', name: '大渡口区' },
        { id: '50995', name: '綦江区' },
        { id: '48201', name: '合川区' },
        { id: '48202', name: '巴南区' },
        { id: '48203', name: '北碚区' },
        { id: '48204', name: '江津区' },
        { id: '48205', name: '渝北区' },
        { id: '48206', name: '长寿区' },
        { id: '48207', name: '永川区' },
        { id: '51026', name: '渝中区' },
        { id: '51027', name: '高新区' },
        { id: '51028', name: '北部新区' },
        { id: '126', name: '大足区' },
        { id: '113', name: '万州区' },
        { id: '114', name: '涪陵区' },
        { id: '115', name: '梁平县' },
        { id: '119', name: '南川区' },
        { id: '123', name: '潼南县' },
        { id: '128', name: '黔江区' },
        { id: '132', name: '开县' },
        { id: '133', name: '云阳县' },
        { id: '134', name: '忠县' },
        { id: '139', name: '垫江县' },
        { id: '4164', name: '城口县' },
        { id: '129', name: '武隆县' },
        { id: '130', name: '丰都县' },
        { id: '131', name: '奉节县' },
        { id: '135', name: '巫溪县' },
        { id: '136', name: '巫山县' },
        { id: '137', name: '石柱县' },
        { id: '138', name: '彭水县' },
        { id: '140', name: '酉阳县' },
        { id: '141', name: '秀山县' }
      ],
      5: [
        { id: '258', name: '唐山市' },
        { id: '264', name: '沧州市' },
        { id: '274', name: '廊坊市' },
        { id: '275', name: '衡水市' },
        { id: '142', name: '石家庄市' },
        { id: '148', name: '邯郸市' },
        { id: '164', name: '邢台市' },
        { id: '199', name: '保定市' },
        { id: '224', name: '张家口市' },
        { id: '239', name: '承德市' },
        { id: '248', name: '秦皇岛市' }
      ],
      6: [
        { id: '3074', name: '长治市' },
        { id: '303', name: '太原市' },
        { id: '309', name: '大同市' },
        { id: '318', name: '阳泉市' },
        { id: '325', name: '晋城市' },
        { id: '330', name: '朔州市' },
        { id: '336', name: '晋中市' },
        { id: '350', name: '忻州市' },
        { id: '368', name: '吕梁市' },
        { id: '379', name: '临汾市' },
        { id: '398', name: '运城市' }
      ],
      7: [
        { id: '517', name: '商丘市' },
        { id: '527', name: '周口市' },
        { id: '538', name: '驻马店市' },
        { id: '549', name: '信阳市' },
        { id: '412', name: '郑州市' },
        { id: '420', name: '开封市' },
        { id: '427', name: '洛阳市' },
        { id: '438', name: '平顶山市' },
        { id: '446', name: '焦作市' },
        { id: '454', name: '鹤壁市' },
        { id: '458', name: '新乡市' },
        { id: '468', name: '安阳市' },
        { id: '475', name: '濮阳市' },
        { id: '2780', name: '济源市' },
        { id: '482', name: '许昌市' },
        { id: '489', name: '漯河市' },
        { id: '495', name: '三门峡市' },
        { id: '502', name: '南阳市' }
      ],
      8: [
        { id: '560', name: '沈阳市' },
        { id: '573', name: '大连市' },
        { id: '579', name: '鞍山市' },
        { id: '584', name: '抚顺市' },
        { id: '589', name: '本溪市' },
        { id: '593', name: '丹东市' },
        { id: '598', name: '锦州市' },
        { id: '604', name: '葫芦岛市' },
        { id: '609', name: '营口市' },
        { id: '613', name: '盘锦市' },
        { id: '617', name: '阜新市' },
        { id: '621', name: '辽阳市' },
        { id: '632', name: '朝阳市' },
        { id: '6858', name: '铁岭市' }
      ],
      9: [
        { id: '639', name: '长春市' },
        { id: '644', name: '吉林市' },
        { id: '651', name: '四平市' },
        { id: '657', name: '通化市' },
        { id: '664', name: '白山市' },
        { id: '674', name: '松原市' },
        { id: '681', name: '白城市' },
        { id: '687', name: '延边州' },
        { id: '2992', name: '辽源市' }
      ],
      10: [
        { id: '773', name: '七台河市' },
        { id: '776', name: '黑河市' },
        { id: '782', name: '绥化市' },
        { id: '793', name: '大兴安岭地区' },
        { id: '698', name: '哈尔滨市' },
        { id: '712', name: '齐齐哈尔市' },
        { id: '727', name: '鹤岗市' },
        { id: '731', name: '双鸭山市' },
        { id: '737', name: '鸡西市' },
        { id: '742', name: '大庆市' },
        { id: '753', name: '伊春市' },
        { id: '757', name: '牡丹江市' },
        { id: '765', name: '佳木斯市' }
      ],
      11: [
        { id: '799', name: '呼和浩特市' },
        { id: '805', name: '包头市' },
        { id: '810', name: '乌海市' },
        { id: '812', name: '赤峰市' },
        { id: '823', name: '乌兰察布市' },
        { id: '835', name: '锡林郭勒盟' },
        { id: '848', name: '呼伦贝尔市' },
        { id: '870', name: '鄂尔多斯市' },
        { id: '880', name: '巴彦淖尔市' },
        { id: '891', name: '阿拉善盟' },
        { id: '895', name: '兴安盟' },
        { id: '902', name: '通辽市' }
      ],
      12: [
        { id: '904', name: '南京市' },
        { id: '911', name: '徐州市' },
        { id: '919', name: '连云港市' },
        { id: '925', name: '淮安市' },
        { id: '933', name: '宿迁市' },
        { id: '939', name: '盐城市' },
        { id: '951', name: '扬州市' },
        { id: '959', name: '泰州市' },
        { id: '965', name: '南通市' },
        { id: '972', name: '镇江市' },
        { id: '978', name: '常州市' },
        { id: '984', name: '无锡市' },
        { id: '988', name: '苏州市' }
      ],
      13: [
        { id: '1025', name: '东营市' },
        { id: '1032', name: '潍坊市' },
        { id: '1042', name: '烟台市' },
        { id: '1053', name: '威海市' },
        { id: '1058', name: '莱芜市' },
        { id: '1060', name: '德州市' },
        { id: '1072', name: '临沂市' },
        { id: '1081', name: '聊城市' },
        { id: '1090', name: '滨州市' },
        { id: '1099', name: '菏泽市' },
        { id: '1108', name: '日照市' },
        { id: '2900', name: '济宁市' },
        { id: '1112', name: '泰安市' },
        { id: '1000', name: '济南市' },
        { id: '1007', name: '青岛市' },
        { id: '1016', name: '淄博市' },
        { id: '1022', name: '枣庄市' }
      ],
      14: [
        { id: '1114', name: '铜陵市' },
        { id: '1116', name: '合肥市' },
        { id: '1121', name: '淮南市' },
        { id: '1124', name: '淮北市' },
        { id: '1127', name: '芜湖市' },
        { id: '1132', name: '蚌埠市' },
        { id: '1137', name: '马鞍山市' },
        { id: '1140', name: '安庆市' },
        { id: '1151', name: '黄山市' },
        { id: '1159', name: '滁州市' },
        { id: '1167', name: '阜阳市' },
        { id: '1174', name: '亳州市' },
        { id: '2971', name: '宣城市' },
        { id: '1180', name: '宿州市' },
        { id: '1201', name: '池州市' },
        { id: '1206', name: '六安市' }
      ],
      15: [
        { id: '1280', name: '丽水市' },
        { id: '1290', name: '台州市' },
        { id: '1298', name: '舟山市' },
        { id: '1158', name: '宁波市' },
        { id: '1213', name: '杭州市' },
        { id: '1233', name: '温州市' },
        { id: '1243', name: '嘉兴市' },
        { id: '1250', name: '湖州市' },
        { id: '1255', name: '绍兴市' },
        { id: '1262', name: '金华市' },
        { id: '1273', name: '衢州市' }
      ],
      16: [
        { id: '1303', name: '福州市' },
        { id: '1315', name: '厦门市' },
        { id: '1317', name: '三明市' },
        { id: '1329', name: '莆田市' },
        { id: '1332', name: '泉州市' },
        { id: '1341', name: '漳州市' },
        { id: '1352', name: '南平市' },
        { id: '1362', name: '龙岩市' },
        { id: '1370', name: '宁德市' }
      ],
      17: [
        { id: '3154', name: '神农架林区' },
        { id: '1381', name: '武汉市' },
        { id: '2922', name: '潜江市' },
        { id: '1387', name: '黄石市' },
        { id: '1396', name: '襄阳市' },
        { id: '1405', name: '十堰市' },
        { id: '1413', name: '荆州市' },
        { id: '1421', name: '宜昌市' },
        { id: '1432', name: '孝感市' },
        { id: '1441', name: '黄冈市' },
        { id: '2980', name: '天门市' },
        { id: '2983', name: '仙桃市' },
        { id: '1458', name: '咸宁市' },
        { id: '1466', name: '恩施州' },
        { id: '1475', name: '鄂州市' },
        { id: '1477', name: '荆门市' },
        { id: '1479', name: '随州市' }
      ],
      18: [
        { id: '1540', name: '张家界市' },
        { id: '1544', name: '郴州市' },
        { id: '1555', name: '益阳市' },
        { id: '1560', name: '永州市' },
        { id: '1574', name: '怀化市' },
        { id: '1586', name: '娄底市' },
        { id: '1592', name: '湘西州' },
        { id: '1482', name: '长沙市' },
        { id: '1488', name: '株洲市' },
        { id: '1495', name: '湘潭市' },
        { id: '1501', name: '衡阳市' },
        { id: '1511', name: '邵阳市' },
        { id: '1522', name: '岳阳市' },
        { id: '1530', name: '常德市' }
      ],
      19: [
        { id: '1601', name: '广州市' },
        { id: '1607', name: '深圳市' },
        { id: '1609', name: '珠海市' },
        { id: '1611', name: '汕头市' },
        { id: '1617', name: '韶关市' },
        { id: '1627', name: '河源市' },
        { id: '1634', name: '梅州市' },
        { id: '1643', name: '惠州市' },
        { id: '1650', name: '汕尾市' },
        { id: '1655', name: '东莞市' },
        { id: '1657', name: '中山市' },
        { id: '1659', name: '江门市' },
        { id: '1666', name: '佛山市' },
        { id: '1672', name: '阳江市' },
        { id: '1677', name: '湛江市' },
        { id: '1684', name: '茂名市' },
        { id: '1690', name: '肇庆市' },
        { id: '1698', name: '云浮市' },
        { id: '1704', name: '清远市' },
        { id: '1705', name: '潮州市' },
        { id: '1709', name: '揭阳市' }
      ],
      20: [
        { id: '1792', name: '贺州市' },
        { id: '1806', name: '百色市' },
        { id: '1818', name: '河池市' },
        { id: '3168', name: '崇左市' },
        { id: '1715', name: '南宁市' },
        { id: '1720', name: '柳州市' },
        { id: '1726', name: '桂林市' },
        { id: '1740', name: '梧州市' },
        { id: '1746', name: '北海市' },
        { id: '1749', name: '防城港市' },
        { id: '1753', name: '钦州市' },
        { id: '1757', name: '贵港市' },
        { id: '1761', name: '玉林市' },
        { id: '3044', name: '来宾市' }
      ],
      21: [
        { id: '1827', name: '南昌市' },
        { id: '1832', name: '景德镇市' },
        { id: '1836', name: '萍乡市' },
        { id: '1842', name: '新余市' },
        { id: '1845', name: '九江市' },
        { id: '1857', name: '鹰潭市' },
        { id: '1861', name: '上饶市' },
        { id: '1874', name: '宜春市' },
        { id: '1885', name: '抚州市' },
        { id: '1898', name: '吉安市' },
        { id: '1911', name: '赣州市' }
      ],
      22: [
        { id: '2058', name: '眉山市' },
        { id: '2065', name: '资阳市' },
        { id: '2070', name: '阿坝州' },
        { id: '2084', name: '甘孜州' },
        { id: '2103', name: '凉山州' },
        { id: '1930', name: '成都市' },
        { id: '1946', name: '自贡市' },
        { id: '1950', name: '攀枝花市' },
        { id: '1954', name: '泸州市' },
        { id: '1960', name: '绵阳市' },
        { id: '1962', name: '德阳市' },
        { id: '1977', name: '广元市' },
        { id: '1983', name: '遂宁市' },
        { id: '1988', name: '内江市' },
        { id: '1993', name: '乐山市' },
        { id: '2005', name: '宜宾市' },
        { id: '2016', name: '广安市' },
        { id: '2022', name: '南充市' },
        { id: '2033', name: '达州市' },
        { id: '2042', name: '巴中市' },
        { id: '2047', name: '雅安市' }
      ],
      23: [
        { id: '3115', name: '琼海市' },
        { id: '3137', name: '万宁市' },
        { id: '2121', name: '海口市' },
        { id: '3173', name: '东方市' },
        { id: '3690', name: '三亚市' },
        { id: '3698', name: '文昌市' },
        { id: '3699', name: '五指山市' },
        { id: '3701', name: '临高县' },
        { id: '3702', name: '澄迈县' },
        { id: '3703', name: '定安县' },
        { id: '3704', name: '屯昌县' },
        { id: '3705', name: '昌江县' },
        { id: '3706', name: '白沙县' },
        { id: '3707', name: '琼中县' },
        { id: '3708', name: '陵水县' },
        { id: '3709', name: '保亭县' },
        { id: '3710', name: '乐东县' },
        { id: '3711', name: '三沙市' },
        { id: '3034', name: '儋州市' }
      ],
      24: [
        { id: '2144', name: '贵阳市' },
        { id: '2150', name: '六盘水市' },
        { id: '2155', name: '遵义市' },
        { id: '2169', name: '铜仁市' },
        { id: '2180', name: '毕节市' },
        { id: '2189', name: '安顺市' },
        { id: '2196', name: '黔西南州' },
        { id: '2205', name: '黔东南州' },
        { id: '2222', name: '黔南州' }
      ],
      25: [
        { id: '2304', name: '丽江市' },
        { id: '2309', name: '文山州' },
        { id: '4108', name: '迪庆州' },
        { id: '2318', name: '红河州' },
        { id: '2332', name: '西双版纳州' },
        { id: '2336', name: '楚雄州' },
        { id: '2347', name: '大理州' },
        { id: '2360', name: '德宏州' },
        { id: '2366', name: '怒江州' },
        { id: '2235', name: '昆明市' },
        { id: '2247', name: '曲靖市' },
        { id: '2258', name: '玉溪市' },
        { id: '2270', name: '昭通市' },
        { id: '2281', name: '普洱市' },
        { id: '2291', name: '临沧市' },
        { id: '2298', name: '保山市' }
      ],
      26: [
        { id: '3107', name: '那曲地区' },
        { id: '3129', name: '山南地区' },
        { id: '3138', name: '昌都地区' },
        { id: '3144', name: '日喀则地区' },
        { id: '3970', name: '阿里地区' },
        { id: '3971', name: '林芝地区' },
        { id: '2951', name: '拉萨市' }
      ],
      27: [
        { id: '2376', name: '西安市' },
        { id: '2386', name: '铜川市' },
        { id: '2390', name: '宝鸡市' },
        { id: '2402', name: '咸阳市' },
        { id: '2416', name: '渭南市' },
        { id: '2428', name: '延安市' },
        { id: '2442', name: '汉中市' },
        { id: '2454', name: '榆林市' },
        { id: '2468', name: '商洛市' },
        { id: '2476', name: '安康市' }
      ],
      28: [
        { id: '2564', name: '甘南州' },
        { id: '3080', name: '定西市' },
        { id: '2573', name: '临夏州' },
        { id: '2487', name: '兰州市' },
        { id: '2492', name: '金昌市' },
        { id: '2495', name: '白银市' },
        { id: '2501', name: '天水市' },
        { id: '2509', name: '嘉峪关市' },
        { id: '2518', name: '平凉市' },
        { id: '2525', name: '庆阳市' },
        { id: '2534', name: '陇南市' },
        { id: '2544', name: '武威市' },
        { id: '2549', name: '张掖市' },
        { id: '2556', name: '酒泉市' }
      ],
      29: [
        { id: '2580', name: '西宁市' },
        { id: '2585', name: '海东地区' },
        { id: '2592', name: '海北州' },
        { id: '2597', name: '黄南州' },
        { id: '2603', name: '海南州' },
        { id: '2605', name: '果洛州' },
        { id: '2612', name: '玉树州' },
        { id: '2620', name: '海西州' }
      ],
      30: [
        { id: '2628', name: '银川市' },
        { id: '2632', name: '石嘴山市' },
        { id: '2637', name: '吴忠市' },
        { id: '2644', name: '固原市' },
        { id: '3071', name: '中卫市' }
      ],
      31: [
        { id: '4110', name: '五家渠市' },
        { id: '15945', name: '阿拉尔市' },
        { id: '15946', name: '图木舒克市' },
        { id: '2652', name: '乌鲁木齐市' },
        { id: '2654', name: '克拉玛依市' },
        { id: '2656', name: '石河子市' },
        { id: '2658', name: '吐鲁番地区' },
        { id: '53090', name: '铁门关市' },
        { id: '2662', name: '哈密地区' },
        { id: '2666', name: '和田地区' },
        { id: '2675', name: '阿克苏地区' },
        { id: '2686', name: '喀什地区' },
        { id: '2699', name: '克孜勒苏柯尔克孜自治州' },
        { id: '2704', name: '巴音郭楞州' },
        { id: '2714', name: '昌吉州' },
        { id: '2723', name: '博尔塔拉州' },
        { id: '2727', name: '伊犁州' },
        { id: '2736', name: '塔城地区' },
        { id: '2744', name: '阿勒泰地区' }
      ],
      32: [{ id: '2768', name: '台湾' }],
      84: [{ id: '1310', name: '钓鱼岛' }],
      52993: [
        { id: '52994', name: '香港特别行政区' },
        { id: '52995', name: '澳门特别行政区' }
      ]
    }

    const distData = {
      2816: [
        { id: '6667', name: '城区' },
        { id: '2862', name: '城区以外' }
      ],
      72: [
        { id: '2819', name: '三环到四环之间' },
        { id: '2839', name: '四环到五环之间' },
        { id: '2840', name: '五环到六环之间' },
        { id: '4137', name: '管庄' },
        { id: '4139', name: '北苑' },
        { id: '4211', name: '定福庄' },
        { id: '2799', name: '三环以内' }
      ],
      2901: [
        { id: '4135', name: '六环以内' },
        { id: '4136', name: '城区' },
        { id: '2906', name: '城区以外' }
      ],
      2953: [
        { id: '6666', name: '城区' },
        { id: '2954', name: '城区以外' }
      ],
      2800: [
        { id: '2848', name: '三环以内' },
        { id: '2849', name: '三环到四环之间' },
        { id: '2850', name: '四环到五环之间' },
        { id: '2851', name: '五环到六环之间' },
        { id: '2852', name: '六环以外' },
        { id: '4134', name: '西三旗' },
        { id: '4209', name: '西二旗' }
      ],
      2801: [
        { id: '2827', name: '内环到二环里' },
        { id: '2853', name: '二环到三环' }
      ],
      2802: [{ id: '2821', name: '内环到三环里' }],
      2803: [
        { id: '2829', name: '一环到二环' },
        { id: '2842', name: '二环到三环' }
      ],
      2804: [{ id: '2828', name: '内环到三环里' }],
      2805: [
        { id: '2832', name: '四环到五环之间' },
        { id: '2854', name: '二环到三环' },
        { id: '2855', name: '三环到四环之间' },
        { id: '34544', name: '五环到六环之间' },
        { id: '34545', name: '六环之外' }
      ],
      2806: [
        { id: '2831', name: '四环到五环内' },
        { id: '4187', name: '石景山城区' },
        { id: '4188', name: '八大处科技园区' }
      ],
      2807: [
        { id: '51552', name: '城区' },
        { id: '51553', name: '龙泉镇' },
        { id: '51554', name: '永定镇' },
        { id: '51555', name: '大台镇' },
        { id: '51556', name: '潭柘寺镇' },
        { id: '51557', name: '王平镇' },
        { id: '51558', name: '军庄镇' },
        { id: '51559', name: '妙峰山镇' },
        { id: '51560', name: '雁翅镇' },
        { id: '51561', name: '斋堂镇' },
        { id: '51562', name: '清水镇' }
      ],
      2808: [
        { id: '51529', name: '大安山乡' },
        { id: '51530', name: '大石窝镇' },
        { id: '51531', name: '窦店镇' },
        { id: '51532', name: '佛子庄乡' },
        { id: '51534', name: '韩村河镇' },
        { id: '51535', name: '河北镇' },
        { id: '51536', name: '良乡镇' },
        { id: '51537', name: '琉璃河镇' },
        { id: '51538', name: '南窖乡' },
        { id: '51539', name: '蒲洼乡' },
        { id: '51540', name: '青龙湖镇' },
        { id: '51541', name: '十渡镇' },
        { id: '51542', name: '石楼镇' },
        { id: '51543', name: '史家营乡' },
        { id: '51544', name: '霞云岭乡' },
        { id: '51545', name: '新镇' },
        { id: '51546', name: '阎村镇' },
        { id: '51547', name: '燕山地区' },
        { id: '51548', name: '张坊镇' },
        { id: '51549', name: '长沟镇' },
        { id: '51550', name: '长阳镇' },
        { id: '51551', name: '周口店镇' },
        { id: '51528', name: '城区' }
      ],
      2809: [
        { id: '51216', name: '六环内（马驹桥镇）' },
        { id: '51228', name: '中仓街道' },
        { id: '51229', name: '新华街道' },
        { id: '51230', name: '玉桥街道' },
        { id: '51231', name: '北苑街道' },
        { id: '51217', name: '六环外（马驹桥镇）' },
        { id: '51218', name: '永顺镇' },
        { id: '51219', name: '梨园镇' },
        { id: '51220', name: '宋庄镇' },
        { id: '51221', name: '漷县镇' },
        { id: '51222', name: '张家湾镇' },
        { id: '51223', name: '西集镇' },
        { id: '51224', name: '永乐店镇' },
        { id: '51225', name: '潞城镇' },
        { id: '51226', name: '台湖镇' },
        { id: '51227', name: '于家务乡' },
        { id: '51232', name: '次渠镇' }
      ],
      3065: [
        { id: '51505', name: '延庆镇' },
        { id: '51506', name: '城区' },
        { id: '51507', name: '康庄镇' },
        { id: '51508', name: '八达岭镇' },
        { id: '51509', name: '永宁镇' },
        { id: '51510', name: '旧县镇' },
        { id: '51511', name: '张山营镇' },
        { id: '51512', name: '四海镇' },
        { id: '51513', name: '千家店镇' },
        { id: '51514', name: '沈家营镇' },
        { id: '51515', name: '大榆树镇' },
        { id: '51516', name: '井庄镇' },
        { id: '51517', name: '大庄科乡' },
        { id: '51518', name: '刘斌堡乡' },
        { id: '51519', name: '香营乡' },
        { id: '51520', name: '珍珠泉乡' }
      ],
      2810: [
        { id: '4194', name: '四环至五环之间' },
        { id: '6501', name: '五环至六环之间' },
        { id: '4205', name: '六环以外' },
        { id: '51081', name: '亦庄经济开发区' }
      ],
      2812: [
        { id: '51125', name: '北石槽镇' },
        { id: '51126', name: '北务镇' },
        { id: '51127', name: '北小营镇' },
        { id: '51128', name: '大孙各庄镇' },
        { id: '51129', name: '高丽营镇' },
        { id: '51130', name: '光明街道' },
        { id: '51131', name: '后沙峪地区' },
        { id: '51132', name: '空港街道' },
        { id: '51133', name: '李桥镇' },
        { id: '51134', name: '李遂镇' },
        { id: '51135', name: '龙湾屯镇' },
        { id: '51136', name: '马坡地区' },
        { id: '51137', name: '木林镇' },
        { id: '51138', name: '南彩镇' },
        { id: '51139', name: '南法信地区' },
        { id: '51140', name: '牛栏山地区' },
        { id: '51141', name: '仁和地区' },
        { id: '51142', name: '胜利街道' },
        { id: '51143', name: '石园街道' },
        { id: '51144', name: '双丰街道' },
        { id: '51145', name: '天竺地区' },
        { id: '51146', name: '旺泉街道' },
        { id: '51147', name: '杨镇地区' },
        { id: '51148', name: '张镇' },
        { id: '51149', name: '赵全营镇' }
      ],
      2814: [
        { id: '6115', name: '城区以内' },
        { id: '2847', name: '郊区' }
      ],
      2817: [{ id: '51973', name: '城区' }],
      2820: [{ id: '51972', name: '城区' }],
      2822: [{ id: '51979', name: '城区' }],
      2823: [{ id: '51974', name: '城区' }],
      2824: [
        { id: '51911', name: '罗店镇' },
        { id: '51921', name: '城区' },
        { id: '51912', name: '大场镇' },
        { id: '51913', name: '杨行镇' },
        { id: '51914', name: '月浦镇' },
        { id: '51915', name: '罗泾镇' },
        { id: '51916', name: '顾村镇' },
        { id: '51917', name: '高境镇' },
        { id: '51918', name: '庙行镇' },
        { id: '51919', name: '淞南镇' },
        { id: '51920', name: '宝山城市工业园区' }
      ],
      2825: [
        { id: '51931', name: '城区' },
        { id: '51932', name: '莘庄镇' },
        { id: '51933', name: '七宝镇' },
        { id: '51934', name: '浦江镇' },
        { id: '51935', name: '梅陇镇' },
        { id: '51936', name: '虹桥镇' },
        { id: '51937', name: '马桥镇' },
        { id: '51938', name: '吴泾镇' },
        { id: '51939', name: '华漕镇' },
        { id: '51940', name: '颛桥镇' }
      ],
      2826: [
        { id: '51941', name: '城区' },
        { id: '51942', name: '南翔镇' },
        { id: '51943', name: '马陆镇' },
        { id: '51944', name: '华亭镇' },
        { id: '51945', name: '江桥镇' },
        { id: '51946', name: '菊园新区' },
        { id: '51947', name: '安亭镇' },
        { id: '51948', name: '徐行镇' },
        { id: '51949', name: '外冈镇' },
        { id: '51950', name: '嘉定工业区' }
      ],
      2830: [
        { id: '51800', name: '城区' },
        { id: '51801', name: '川沙新镇' },
        { id: '51822', name: '祝桥镇' },
        { id: '51823', name: '新场镇' },
        { id: '51802', name: '高桥镇' },
        { id: '51824', name: '惠南镇' },
        { id: '51803', name: '北蔡镇' },
        { id: '51804', name: '合庆镇' },
        { id: '51805', name: '唐镇' },
        { id: '51806', name: '曹路镇' },
        { id: '51807', name: '金桥镇' },
        { id: '51808', name: '高行镇' },
        { id: '51809', name: '高东镇' },
        { id: '51810', name: '张江镇' },
        { id: '51811', name: '三林镇' },
        { id: '51812', name: '南汇新城镇' },
        { id: '51825', name: '康桥镇' },
        { id: '51826', name: '宣桥镇' },
        { id: '51827', name: '书院镇' },
        { id: '51828', name: '大团镇' },
        { id: '51829', name: '周浦镇' },
        { id: '51830', name: '芦潮港镇' },
        { id: '51831', name: '泥城镇' },
        { id: '51832', name: '航头镇' },
        { id: '51833', name: '万祥镇' },
        { id: '51834', name: '老港镇' }
      ],
      2833: [
        { id: '51959', name: '城区' },
        { id: '51952', name: '赵巷镇' },
        { id: '51953', name: '徐泾镇' },
        { id: '51954', name: '华新镇' },
        { id: '51955', name: '重固镇' },
        { id: '51956', name: '白鹤镇' },
        { id: '51957', name: '练塘镇' },
        { id: '51958', name: '金泽镇' },
        { id: '51951', name: '朱家角镇' }
      ],
      2834: [
        { id: '51982', name: '城区' },
        { id: '51983', name: '泗泾镇' },
        { id: '51984', name: '佘山镇' },
        { id: '51985', name: '车墩镇' },
        { id: '51986', name: '新桥镇' },
        { id: '51987', name: '洞泾镇' },
        { id: '51988', name: '九亭镇' },
        { id: '51989', name: '泖港镇' },
        { id: '51990', name: '石湖荡镇' },
        { id: '51991', name: '新浜镇' },
        { id: '51992', name: '叶榭镇' },
        { id: '51993', name: '小昆山镇' }
      ],
      2835: [
        { id: '51960', name: '城区' },
        { id: '51961', name: '金山工业区' },
        { id: '51962', name: '朱泾镇' },
        { id: '51963', name: '枫泾镇' },
        { id: '51964', name: '张堰镇' },
        { id: '51965', name: '亭林镇' },
        { id: '51966', name: '吕巷镇' },
        { id: '51967', name: '廊下镇' },
        { id: '51968', name: '金山卫镇' },
        { id: '51970', name: '漕泾镇' },
        { id: '51971', name: '山阳镇' }
      ],
      2837: [
        { id: '51928', name: '南桥镇' },
        { id: '51929', name: '奉城镇' },
        { id: '51930', name: '四团镇' },
        { id: '51994', name: '柘林镇' },
        { id: '51995', name: '庄行镇' },
        { id: '51996', name: '金汇镇' },
        { id: '51997', name: '青村镇' },
        { id: '51998', name: '海湾镇' }
      ],
      2841: [{ id: '51980', name: '城区' }],
      78: [{ id: '51978', name: '城区' }],
      2919: [
        { id: '50779', name: '堡镇' },
        { id: '50780', name: '庙镇' },
        { id: '50781', name: '陈家镇' },
        { id: '50782', name: '城桥镇' },
        { id: '50783', name: '东平镇' },
        { id: '50784', name: '港西镇' },
        { id: '50785', name: '港沿镇' },
        { id: '50786', name: '建设镇' },
        { id: '50787', name: '绿华镇' },
        { id: '50788', name: '三星镇' },
        { id: '50789', name: '竖新镇' },
        { id: '50790', name: '向化镇' },
        { id: '50791', name: '新海镇' },
        { id: '50792', name: '新河镇' },
        { id: '50793', name: '中兴镇' },
        { id: '50794', name: '长兴乡' },
        { id: '50795', name: '横沙乡' },
        { id: '50796', name: '新村乡' }
      ],
      2813: [{ id: '51976', name: '城区' }],
      2815: [{ id: '51975', name: '城区' }],
      51035: [{ id: '39620', name: '全境' }],
      51036: [{ id: '2984', name: '全境' }],
      51037: [{ id: '2987', name: '全境' }],
      51038: [{ id: '3000', name: '全境' }],
      51039: [{ id: '2985', name: '全境' }],
      51040: [{ id: '2986', name: '全境' }],
      51041: [{ id: '98', name: '全境' }],
      51042: [{ id: '36157', name: '全境' }],
      51043: [{ id: '2907', name: '全境' }],
      51044: [{ id: '25708', name: '全境' }],
      51045: [
        { id: '25712', name: '杨柳青,中北,精武,大寺镇,环外海泰及外环内' },
        { id: '25711', name: '其它地区' }
      ],
      51046: [
        { id: '22846', name: '杨村镇、下朱庄内' },
        { id: '22847', name: '其它地区' }
      ],
      51047: [
        { id: '36171', name: '双港，辛庄' },
        { id: '25704', name: '咸水沽镇、海河教育园，海河科技园' },
        { id: '36172', name: '其他地区' }
      ],
      51048: [
        { id: '23672', name: '汉沽区街里、汉沽开发区' },
        { id: '23673', name: '其它地区' }
      ],
      51049: [
        { id: '8545', name: '大港油田' },
        { id: '8546', name: '主城区内' },
        { id: '8547', name: '主城区外' }
      ],
      51050: [
        { id: '36167', name: '外环外双街镇，河北工大新校，屈店工业园' },
        { id: '6646', name: '外环内' },
        { id: '36168', name: '外环外其它地区' }
      ],
      51051: [
        { id: '22848', name: '城关镇、马家店开发区、天宝工业园' },
        { id: '22849', name: '其它地区' }
      ],
      51052: [
        { id: '23674', name: '芦台镇、经济开发区、贸易开发区' },
        { id: '23675', name: '其它地区' }
      ],
      48131: [
        { id: '48185', name: '县城内' },
        { id: '48188', name: '青杠镇' },
        { id: '48189', name: '来凤镇' },
        { id: '48190', name: '丁家镇' },
        { id: '48191', name: '大路镇' },
        { id: '48192', name: '八塘镇' },
        { id: '48193', name: '七塘镇' },
        { id: '48194', name: '河边镇' },
        { id: '48195', name: '福禄镇' },
        { id: '48196', name: '大兴镇' },
        { id: '48197', name: '正兴镇' },
        { id: '48198', name: '广普镇' },
        { id: '48199', name: '三合镇' },
        { id: '48200', name: '健龙镇' }
      ],
      48132: [
        { id: '48163', name: '县城内' },
        { id: '48166', name: '广顺镇' },
        { id: '48167', name: '安富镇' },
        { id: '48168', name: '峰高镇' },
        { id: '48169', name: '双河镇' },
        { id: '48170', name: '直升镇' },
        { id: '48171', name: '路孔镇' },
        { id: '48172', name: '清江镇' },
        { id: '48173', name: '仁义镇' },
        { id: '48174', name: '河包镇' },
        { id: '48175', name: '古昌镇' },
        { id: '48176', name: '吴家镇' },
        { id: '48177', name: '观胜镇' },
        { id: '48178', name: '铜鼓镇' },
        { id: '48179', name: '清流镇' },
        { id: '48180', name: '盘龙镇' },
        { id: '48181', name: '远觉镇' },
        { id: '48182', name: '清升镇' },
        { id: '48183', name: '荣隆镇' },
        { id: '48184', name: '龙集镇' }
      ],
      48133: [
        { id: '48134', name: '县城内' },
        { id: '48138', name: '土桥镇' },
        { id: '48139', name: '二坪镇' },
        { id: '48140', name: '水口镇' },
        { id: '48141', name: '安居镇' },
        { id: '48142', name: '白羊镇' },
        { id: '48143', name: '平滩镇' },
        { id: '48144', name: '石鱼镇' },
        { id: '48145', name: '福果镇' },
        { id: '48146', name: '维新镇' },
        { id: '48147', name: '高楼镇' },
        { id: '48148', name: '大庙镇' },
        { id: '48149', name: '围龙镇' },
        { id: '48150', name: '华兴镇' },
        { id: '48151', name: '永嘉镇' },
        { id: '48152', name: '安溪镇' },
        { id: '48153', name: '西河镇' },
        { id: '48154', name: '太平镇' },
        { id: '48155', name: '旧县镇' },
        { id: '48156', name: '虎峰镇' },
        { id: '48157', name: '少云镇' },
        { id: '48158', name: '蒲吕镇' },
        { id: '48159', name: '侣俸镇' },
        { id: '48160', name: '小林乡' },
        { id: '48161', name: '双山乡' },
        { id: '48162', name: '庆隆乡' }
      ],
      50950: [
        { id: '88', name: '内环以内' },
        { id: '50957', name: '寸滩镇' },
        { id: '50958', name: '郭家沱镇' },
        { id: '50959', name: '铁山坪镇' },
        { id: '50960', name: '鱼嘴镇' },
        { id: '50961', name: '复盛镇' },
        { id: '50962', name: '五宝镇' },
        { id: '51198', name: '大石坝镇' }
      ],
      50951: [
        { id: '52496', name: '城区' },
        { id: '4298', name: '内环以内' },
        { id: '50963', name: '茶园新区' },
        { id: '50964', name: '鸡冠石镇' },
        { id: '50965', name: '长生桥镇' },
        { id: '50966', name: '峡口镇' },
        { id: '50967', name: '广阳镇' },
        { id: '50968', name: '迎龙镇' }
      ],
      50952: [
        { id: '106', name: '内环以内' },
        { id: '50969', name: '白市驿镇' },
        { id: '50970', name: '铜罐驿镇' },
        { id: '50971', name: '华岩镇' },
        { id: '50972', name: '巴福镇' },
        { id: '50973', name: '含谷镇' },
        { id: '50974', name: '金凤镇' },
        { id: '50975', name: '石板镇' },
        { id: '50976', name: '陶家镇' },
        { id: '50977', name: '西彭镇' },
        { id: '50978', name: '走马镇' }
      ],
      50953: [
        { id: '50979', name: '内环以内' },
        { id: '50980', name: '陈家桥镇' },
        { id: '50981', name: '歌乐山镇' },
        { id: '50982', name: '青木关镇' },
        { id: '50983', name: '回龙坝镇' },
        { id: '50984', name: '大学城' },
        { id: '50985', name: '虎溪镇' },
        { id: '50986', name: '西永镇' },
        { id: '50987', name: '土主镇' },
        { id: '50988', name: '井口镇' },
        { id: '50989', name: '曾家镇' },
        { id: '50990', name: '凤凰镇' },
        { id: '50991', name: '中梁镇' }
      ],
      50954: [
        { id: '50992', name: '茄子溪镇' },
        { id: '50993', name: '建胜镇' },
        { id: '50994', name: '跳磴镇' },
        { id: '111', name: '内环以内' }
      ],
      50995: [
        { id: '52497', name: '城区' },
        { id: '51000', name: '三江镇' },
        { id: '51001', name: '安稳镇' },
        { id: '51002', name: '打通镇' },
        { id: '51003', name: '丁山镇' },
        { id: '51004', name: '东溪镇' },
        { id: '51005', name: '扶欢镇' },
        { id: '51006', name: '赶水镇' },
        { id: '51007', name: '郭扶镇' },
        { id: '51008', name: '横山镇' },
        { id: '51009', name: '隆盛镇' },
        { id: '51010', name: '三角镇' },
        { id: '51011', name: '石壕镇' },
        { id: '51012', name: '石角镇' },
        { id: '51013', name: '新盛镇' },
        { id: '51014', name: '永城镇' },
        { id: '51015', name: '永新镇' },
        { id: '51016', name: '中峰镇' },
        { id: '51017', name: '篆塘镇' },
        { id: '51018', name: '丛林镇' },
        { id: '51019', name: '关坝镇' },
        { id: '51020', name: '黑山镇' },
        { id: '51021', name: '金桥镇' },
        { id: '51022', name: '南桐镇' },
        { id: '51023', name: '青年镇' },
        { id: '51024', name: '石林镇' },
        { id: '51025', name: '万东镇' }
      ],
      48201: [
        { id: '52489', name: '城区' },
        { id: '48298', name: '草街镇' },
        { id: '48299', name: '盐井镇' },
        { id: '48300', name: '云门镇' },
        { id: '48301', name: '大石镇' },
        { id: '48302', name: '沙鱼镇' },
        { id: '48303', name: '官渡镇' },
        { id: '48304', name: '涞滩镇' },
        { id: '48305', name: '肖家镇' },
        { id: '48306', name: '古楼镇' },
        { id: '48307', name: '三庙镇' },
        { id: '48308', name: '二郎镇' },
        { id: '48309', name: '龙凤镇' },
        { id: '48310', name: '隆兴镇' },
        { id: '48311', name: '铜溪镇' },
        { id: '48312', name: '双凤镇' },
        { id: '48313', name: '狮滩镇' },
        { id: '48314', name: '清平镇' },
        { id: '48315', name: '土场镇' },
        { id: '48316', name: '小沔镇' },
        { id: '48317', name: '三汇镇' },
        { id: '48318', name: '香龙镇' },
        { id: '48319', name: '钱塘镇' },
        { id: '48320', name: '龙市镇' },
        { id: '48321', name: '燕窝镇' },
        { id: '48322', name: '太和镇' },
        { id: '48323', name: '渭沱镇' },
        { id: '48324', name: '双槐镇' }
      ],
      48202: [
        { id: '52490', name: '城区' },
        { id: '48355', name: '南泉镇' },
        { id: '48356', name: '一品镇' },
        { id: '48357', name: '南彭镇' },
        { id: '48358', name: '惠民镇' },
        { id: '48359', name: '麻柳嘴镇' },
        { id: '48360', name: '天星寺镇' },
        { id: '48361', name: '双河口镇' },
        { id: '48362', name: '界石镇' },
        { id: '48363', name: '安澜镇' },
        { id: '48364', name: '跳石镇' },
        { id: '48365', name: '木洞镇' },
        { id: '48366', name: '丰盛镇' },
        { id: '48367', name: '二圣镇' },
        { id: '48368', name: '东泉镇' },
        { id: '48369', name: '姜家镇' },
        { id: '48370', name: '接龙镇' },
        { id: '48371', name: '石滩镇' },
        { id: '48372', name: '石龙镇' }
      ],
      48203: [
        { id: '52491', name: '城区' },
        { id: '48240', name: '东阳镇' },
        { id: '48242', name: '蔡家岗镇' },
        { id: '48243', name: '童家溪镇' },
        { id: '48244', name: '施家梁镇' },
        { id: '48245', name: '金刀峡镇' },
        { id: '48246', name: '澄江镇' },
        { id: '48247', name: '水土镇' },
        { id: '48248', name: '歇马镇' },
        { id: '48249', name: '天府镇' },
        { id: '48250', name: '复兴镇' },
        { id: '48251', name: '静观镇' },
        { id: '48252', name: '柳荫镇' },
        { id: '48253', name: '三圣镇' }
      ],
      48204: [
        { id: '52492', name: '城区' },
        { id: '53556', name: '双福镇' },
        { id: '48213', name: '四面山镇' },
        { id: '48214', name: '支坪镇' },
        { id: '48215', name: '白沙镇' },
        { id: '48216', name: '珞璜镇' },
        { id: '48217', name: '柏林镇' },
        { id: '48218', name: '蔡家镇' },
        { id: '48219', name: '慈云镇' },
        { id: '48220', name: '杜市镇' },
        { id: '48221', name: '广兴镇' },
        { id: '48222', name: '嘉平镇' },
        { id: '48223', name: '贾嗣镇' },
        { id: '48224', name: '李市镇' },
        { id: '48225', name: '龙华镇' },
        { id: '48226', name: '石蟆镇' },
        { id: '48227', name: '石门镇' },
        { id: '48228', name: '塘河镇' },
        { id: '48229', name: '吴滩镇' },
        { id: '48230', name: '西湖镇' },
        { id: '48231', name: '夏坝镇' },
        { id: '48232', name: '先锋镇' },
        { id: '48233', name: '永兴镇' },
        { id: '48234', name: '油溪镇' },
        { id: '48235', name: '中山镇' },
        { id: '48236', name: '朱杨镇' }
      ],
      48205: [
        { id: '52493', name: '城区' },
        { id: '48332', name: '礼嘉镇' },
        { id: '48337', name: '两路镇' },
        { id: '48338', name: '王家镇' },
        { id: '48339', name: '悦来镇' },
        { id: '48340', name: '玉峰山镇' },
        { id: '48341', name: '茨竹镇' },
        { id: '48342', name: '大盛镇' },
        { id: '48343', name: '大塆镇' },
        { id: '48344', name: '古路镇' },
        { id: '48345', name: '龙兴镇' },
        { id: '48346', name: '洛碛镇' },
        { id: '48347', name: '木耳镇' },
        { id: '48348', name: '石船镇' },
        { id: '48349', name: '统景镇' },
        { id: '48350', name: '兴隆镇' }
      ],
      48206: [
        { id: '52494', name: '城区' },
        { id: '48281', name: '长寿湖镇' },
        { id: '48282', name: '邻封镇' },
        { id: '48283', name: '但渡镇' },
        { id: '48284', name: '云集镇' },
        { id: '48285', name: '双龙镇' },
        { id: '48286', name: '龙河镇' },
        { id: '48287', name: '石堰镇' },
        { id: '48288', name: '云台镇' },
        { id: '48289', name: '海棠镇' },
        { id: '48290', name: '葛兰镇' },
        { id: '48291', name: '新市镇' },
        { id: '48292', name: '八颗镇' },
        { id: '48293', name: '洪湖镇' },
        { id: '48294', name: '万顺镇' }
      ],
      48207: [
        { id: '52495', name: '城区' },
        { id: '48257', name: '双竹镇' },
        { id: '48258', name: '三教镇' },
        { id: '48259', name: '大安镇' },
        { id: '48260', name: '陈食镇' },
        { id: '48261', name: '板桥镇' },
        { id: '48262', name: '宝峰镇' },
        { id: '48263', name: '临江镇' },
        { id: '48264', name: '红炉镇' },
        { id: '48265', name: '吉安镇' },
        { id: '48266', name: '金龙镇' },
        { id: '48267', name: '来苏镇' },
        { id: '48268', name: '青峰镇' },
        { id: '48270', name: '双石镇' },
        { id: '48271', name: '松溉镇' },
        { id: '48272', name: '五间镇' },
        { id: '48273', name: '仙龙镇' },
        { id: '48274', name: '永荣镇' },
        { id: '48275', name: '朱沱镇' },
        { id: '48276', name: '何埂镇' }
      ],
      51026: [{ id: '103', name: '全境' }],
      51027: [{ id: '50956', name: '全境' }],
      51028: [{ id: '50955', name: '全境' }],
      126: [
        { id: '52487', name: '城区' },
        { id: '13520', name: '龙滩子镇' },
        { id: '13521', name: '龙水镇' },
        { id: '13522', name: '智凤镇' },
        { id: '13523', name: '宝顶镇' },
        { id: '13524', name: '中敖镇' },
        { id: '13525', name: '三驱镇' },
        { id: '13526', name: '宝兴镇' },
        { id: '13527', name: '玉龙镇' },
        { id: '13528', name: '石马镇' },
        { id: '13529', name: '拾万镇' },
        { id: '13530', name: '回龙镇' },
        { id: '13531', name: '金山镇' },
        { id: '13532', name: '万古镇' },
        { id: '13533', name: '国梁镇' },
        { id: '13534', name: '雍溪镇' },
        { id: '13535', name: '珠溪镇' },
        { id: '13536', name: '龙石镇' },
        { id: '13537', name: '邮亭镇' },
        { id: '13538', name: '铁山镇' },
        { id: '13539', name: '高升镇' },
        { id: '13540', name: '季家镇' },
        { id: '13541', name: '古龙镇' },
        { id: '13542', name: '高坪镇' },
        { id: '13543', name: '双路镇' },
        { id: '13544', name: '通桥镇' }
      ],
      113: [
        { id: '52484', name: '城区' },
        { id: '9786', name: '白土镇' },
        { id: '9787', name: '白羊镇' },
        { id: '9788', name: '大周镇' },
        { id: '9789', name: '弹子镇' },
        { id: '9790', name: '分水镇' },
        { id: '9791', name: '甘宁镇' },
        { id: '9792', name: '高峰镇' },
        { id: '9793', name: '高梁镇' },
        { id: '9794', name: '后山镇' },
        { id: '9795', name: '李河镇' },
        { id: '9796', name: '龙驹镇' },
        { id: '9797', name: '龙沙镇' },
        { id: '9798', name: '罗田镇' },
        { id: '9799', name: '孙家镇' },
        { id: '9800', name: '太安镇' },
        { id: '9801', name: '太龙镇' },
        { id: '9802', name: '天城镇' },
        { id: '9803', name: '武陵镇' },
        { id: '9804', name: '响水镇' },
        { id: '9805', name: '小周镇' },
        { id: '9806', name: '新田镇' },
        { id: '9807', name: '新乡镇' },
        { id: '9808', name: '熊家镇' },
        { id: '9809', name: '余家镇' },
        { id: '9810', name: '长岭镇' },
        { id: '9811', name: '长坪镇' },
        { id: '9812', name: '长滩镇' },
        { id: '9813', name: '走马镇' },
        { id: '9814', name: '瀼渡镇' },
        { id: '9815', name: '茨竹乡' },
        { id: '9816', name: '柱山乡' },
        { id: '9817', name: '燕山乡' },
        { id: '9818', name: '溪口乡' },
        { id: '9819', name: '普子乡' },
        { id: '9820', name: '地宝乡' },
        { id: '9821', name: '铁峰乡' },
        { id: '9822', name: '黄柏乡' },
        { id: '9823', name: '九池乡' },
        { id: '9824', name: '梨树乡' },
        { id: '9825', name: '郭村乡' },
        { id: '9826', name: '恒合乡' }
      ],
      114: [
        { id: '52485', name: '城区' },
        { id: '9898', name: '李渡镇' },
        { id: '9899', name: '白涛镇' },
        { id: '9900', name: '百胜镇' },
        { id: '9901', name: '堡子镇' },
        { id: '9902', name: '焦石镇' },
        { id: '9903', name: '蔺市镇' },
        { id: '9904', name: '龙桥镇' },
        { id: '9905', name: '龙潭镇' },
        { id: '9906', name: '马武镇' },
        { id: '9907', name: '南沱镇' },
        { id: '9908', name: '青羊镇' },
        { id: '9909', name: '清溪镇' },
        { id: '9910', name: '石沱镇' },
        { id: '9911', name: '新妙镇' },
        { id: '9912', name: '义和镇' },
        { id: '9913', name: '增福乡' },
        { id: '9914', name: '珍溪镇' },
        { id: '9915', name: '镇安镇' },
        { id: '9916', name: '致韩镇' },
        { id: '9917', name: '土地坡乡' },
        { id: '9918', name: '武陵山乡' },
        { id: '9919', name: '中峰乡' },
        { id: '9920', name: '梓里乡' },
        { id: '9921', name: '丛林乡' },
        { id: '9922', name: '大木乡' },
        { id: '9923', name: '惠民乡' },
        { id: '9924', name: '酒店乡' },
        { id: '9925', name: '聚宝乡' },
        { id: '9926', name: '卷洞乡' },
        { id: '9927', name: '两汇乡' },
        { id: '9928', name: '罗云乡' },
        { id: '9929', name: '明家乡' },
        { id: '9930', name: '仁义乡' },
        { id: '9931', name: '山窝乡' },
        { id: '9932', name: '石和乡' },
        { id: '9933', name: '石龙乡' },
        { id: '9934', name: '太和乡' },
        { id: '9935', name: '天台乡' },
        { id: '9936', name: '同乐乡' },
        { id: '9937', name: '新村乡' }
      ],
      115: [
        { id: '39680', name: '县城内' },
        { id: '9938', name: '梁山镇' },
        { id: '9939', name: '柏家镇' },
        { id: '9940', name: '碧山镇' },
        { id: '9941', name: '大观镇' },
        { id: '9942', name: '福禄镇' },
        { id: '9943', name: '合兴镇' },
        { id: '9944', name: '和林镇' },
        { id: '9945', name: '虎城镇' },
        { id: '9946', name: '回龙镇' },
        { id: '9947', name: '金带镇' },
        { id: '9948', name: '聚奎镇' },
        { id: '9949', name: '礼让镇' },
        { id: '9950', name: '龙门镇' },
        { id: '9951', name: '明达镇' },
        { id: '9952', name: '蟠龙镇' },
        { id: '9953', name: '屏锦镇' },
        { id: '9954', name: '仁贤镇' },
        { id: '9955', name: '石安镇' },
        { id: '9956', name: '文化镇' },
        { id: '9957', name: '新盛镇' },
        { id: '9958', name: '荫平镇' },
        { id: '9959', name: '袁驿镇' },
        { id: '9960', name: '云龙镇' },
        { id: '9961', name: '竹山镇' },
        { id: '9962', name: '安胜乡' },
        { id: '9963', name: '铁门乡' },
        { id: '9964', name: '紫照乡' },
        { id: '9965', name: '曲水乡' },
        { id: '9966', name: '龙胜乡' },
        { id: '9967', name: '城北乡' },
        { id: '9968', name: '城东乡' },
        { id: '9969', name: '复平乡' }
      ],
      119: [
        { id: '52486', name: '城区' },
        { id: '9984', name: '头渡镇' },
        { id: '9985', name: '兴隆镇' },
        { id: '9986', name: '冷水关乡' },
        { id: '9987', name: '德隆乡' },
        { id: '9988', name: '峰岩乡' },
        { id: '9989', name: '福寿乡' },
        { id: '9990', name: '古花乡' },
        { id: '9991', name: '河图乡' },
        { id: '9992', name: '民主乡' },
        { id: '9993', name: '木凉乡' },
        { id: '9994', name: '乾丰乡' },
        { id: '9995', name: '庆元乡' },
        { id: '9996', name: '石莲乡' },
        { id: '9997', name: '石溪乡' },
        { id: '9998', name: '铁村乡' },
        { id: '9999', name: '土溪乡' },
        { id: '10000', name: '鱼泉乡' },
        { id: '10001', name: '中桥乡' },
        { id: '9973', name: '太平场镇' },
        { id: '9974', name: '大观镇' },
        { id: '9975', name: '大有镇' },
        { id: '9976', name: '合溪镇' },
        { id: '9977', name: '金山镇' },
        { id: '9978', name: '鸣玉镇' },
        { id: '9979', name: '南平镇' },
        { id: '9980', name: '三泉镇' },
        { id: '9981', name: '神童镇' },
        { id: '9982', name: '石墙镇' },
        { id: '9983', name: '水江镇' }
      ],
      123: [
        { id: '39688', name: '县城内' },
        { id: '9756', name: '柏梓镇' },
        { id: '9757', name: '宝龙镇' },
        { id: '9758', name: '崇龛镇' },
        { id: '9759', name: '古溪镇' },
        { id: '9760', name: '龙形镇' },
        { id: '9761', name: '米心镇' },
        { id: '9762', name: '群力镇' },
        { id: '9763', name: '上和镇' },
        { id: '9764', name: '双江镇' },
        { id: '9765', name: '太安镇' },
        { id: '9766', name: '塘坝镇' },
        { id: '9767', name: '卧佛镇' },
        { id: '9768', name: '五桂镇' },
        { id: '9769', name: '小渡镇' },
        { id: '9770', name: '新胜镇' },
        { id: '9771', name: '玉溪镇' },
        { id: '9772', name: '别口乡' },
        { id: '9773', name: '田家乡' },
        { id: '9774', name: '寿桥乡' }
      ],
      128: [
        { id: '52488', name: '城区' },
        { id: '10005', name: '正阳镇' },
        { id: '10006', name: '舟白镇' },
        { id: '10007', name: '阿蓬江镇' },
        { id: '10008', name: '小南海镇' },
        { id: '10009', name: '鹅池镇' },
        { id: '10010', name: '冯家镇' },
        { id: '10011', name: '黑溪镇' },
        { id: '10012', name: '黄溪镇' },
        { id: '10013', name: '金溪镇' },
        { id: '10014', name: '黎水镇' },
        { id: '10015', name: '邻鄂镇' },
        { id: '10016', name: '马喇镇' },
        { id: '10017', name: '石会镇' },
        { id: '10018', name: '石家镇' },
        { id: '10019', name: '濯水镇' },
        { id: '10020', name: '白石乡' },
        { id: '10021', name: '白土乡' },
        { id: '10022', name: '金洞乡' },
        { id: '10023', name: '蓬东乡' },
        { id: '10024', name: '沙坝乡' },
        { id: '10025', name: '杉岭乡' },
        { id: '10026', name: '水市乡' },
        { id: '10027', name: '水田乡' },
        { id: '10028', name: '太极乡' },
        { id: '10029', name: '五里乡' },
        { id: '10030', name: '新华乡' },
        { id: '10031', name: '中塘乡' }
      ],
      132: [
        { id: '51202', name: '白桥镇' },
        { id: '51203', name: '大德镇' },
        { id: '51204', name: '金峰镇' },
        { id: '51205', name: '谭家镇' },
        { id: '51206', name: '天和镇' },
        { id: '51207', name: '白泉乡' },
        { id: '39699', name: '县城内' },
        { id: '9831', name: '九龙山镇' },
        { id: '9832', name: '大进镇' },
        { id: '9833', name: '敦好镇' },
        { id: '9834', name: '高桥镇' },
        { id: '9835', name: '郭家镇' },
        { id: '9836', name: '和谦镇' },
        { id: '9837', name: '河堰镇' },
        { id: '9838', name: '厚坝镇' },
        { id: '9839', name: '临江镇' },
        { id: '9840', name: '南门镇' },
        { id: '9841', name: '南雅镇' },
        { id: '9842', name: '渠口镇' },
        { id: '9843', name: '铁桥镇' },
        { id: '52083', name: '岳溪镇' },
        { id: '9844', name: '温泉镇' },
        { id: '9845', name: '义和镇' },
        { id: '9846', name: '长沙镇' },
        { id: '9847', name: '赵家镇' },
        { id: '9848', name: '镇安镇' },
        { id: '9849', name: '中和镇' },
        { id: '9850', name: '竹溪镇' },
        { id: '9851', name: '三汇口乡' },
        { id: '9852', name: '白桥乡' },
        { id: '9853', name: '大德乡' },
        { id: '9854', name: '关面乡' },
        { id: '9855', name: '金峰乡' },
        { id: '9856', name: '麻柳乡' },
        { id: '9857', name: '满月乡' },
        { id: '9858', name: '谭家乡' },
        { id: '9859', name: '天和乡' },
        { id: '9860', name: '巫山镇' },
        { id: '9861', name: '五通乡' },
        { id: '9862', name: '紫水乡' }
      ],
      133: [
        { id: '39701', name: '县城内' },
        { id: '10091', name: '云阳镇' },
        { id: '10092', name: '巴阳镇' },
        { id: '10093', name: '凤鸣镇' },
        { id: '10094', name: '高阳镇' },
        { id: '10095', name: '故陵镇' },
        { id: '10096', name: '红狮镇' },
        { id: '10097', name: '黄石镇' },
        { id: '10098', name: '江口镇' },
        { id: '10099', name: '龙角镇' },
        { id: '10100', name: '路阳镇' },
        { id: '10101', name: '南溪镇' },
        { id: '10102', name: '农坝镇' },
        { id: '10103', name: '盘龙镇' },
        { id: '10104', name: '平安镇' },
        { id: '10105', name: '渠马镇' },
        { id: '10106', name: '人和镇' },
        { id: '10107', name: '桑坪镇' },
        { id: '10108', name: '沙市镇' },
        { id: '10109', name: '双土镇' },
        { id: '10110', name: '鱼泉镇' },
        { id: '10111', name: '云安镇' },
        { id: '10112', name: '洞鹿乡' },
        { id: '10113', name: '后叶乡' },
        { id: '10114', name: '龙洞乡' },
        { id: '10115', name: '毛坝乡' },
        { id: '10116', name: '泥溪乡' },
        { id: '10117', name: '票草乡' },
        { id: '10118', name: '普安乡' },
        { id: '10119', name: '栖霞乡' },
        { id: '10120', name: '清水乡' },
        { id: '10121', name: '上坝乡' },
        { id: '10122', name: '石门乡' },
        { id: '10123', name: '双龙乡' },
        { id: '10124', name: '水口乡' },
        { id: '10125', name: '外郎乡' },
        { id: '10126', name: '新津乡' },
        { id: '10127', name: '堰坪乡' },
        { id: '10128', name: '养鹿乡' },
        { id: '10129', name: '耀灵乡' },
        { id: '10130', name: '云硐乡' }
      ],
      134: [
        { id: '39702', name: '县城内' },
        { id: '10131', name: '忠州镇' },
        { id: '10132', name: '拔山镇' },
        { id: '10133', name: '白石镇' },
        { id: '10134', name: '东溪镇' },
        { id: '10135', name: '复兴镇' },
        { id: '10136', name: '官坝镇' },
        { id: '10137', name: '花桥镇' },
        { id: '10138', name: '黄金镇' },
        { id: '10139', name: '金鸡镇' },
        { id: '10140', name: '马灌镇' },
        { id: '10141', name: '任家镇' },
        { id: '10142', name: '汝溪镇' },
        { id: '10143', name: '三汇镇' },
        { id: '10144', name: '石宝镇' },
        { id: '10145', name: '石黄镇' },
        { id: '10146', name: '双桂镇' },
        { id: '10147', name: '乌杨镇' },
        { id: '10148', name: '新生镇' },
        { id: '10149', name: '洋渡镇' },
        { id: '10150', name: '野鹤镇' },
        { id: '10151', name: '永丰镇' },
        { id: '10152', name: '金声乡' },
        { id: '10153', name: '磨子乡' },
        { id: '10154', name: '善广乡' },
        { id: '10155', name: '石子乡' },
        { id: '10156', name: '涂井乡' },
        { id: '10157', name: '兴峰乡' },
        { id: '19915', name: '新立镇' }
      ],
      139: [
        { id: '39712', name: '县城内' },
        { id: '10283', name: '桂溪镇' },
        { id: '10284', name: '澄溪镇' },
        { id: '10285', name: '高安镇' },
        { id: '10286', name: '高峰镇' },
        { id: '10287', name: '鹤游镇' },
        { id: '10288', name: '普顺镇' },
        { id: '10289', name: '沙坪镇' },
        { id: '10290', name: '太平镇' },
        { id: '10291', name: '五洞镇' },
        { id: '10292', name: '新民镇' },
        { id: '10293', name: '砚台镇' },
        { id: '10294', name: '永安镇' },
        { id: '10295', name: '周嘉镇' },
        { id: '10296', name: '白家乡' },
        { id: '10297', name: '包家乡' },
        { id: '10298', name: '曹回乡' },
        { id: '10299', name: '大石乡' },
        { id: '10300', name: '杠家乡' },
        { id: '32060', name: '坪山镇' },
        { id: '10301', name: '黄沙乡' },
        { id: '10302', name: '裴兴乡' },
        { id: '10303', name: '三溪乡' },
        { id: '10304', name: '沙河乡' },
        { id: '10305', name: '永平乡' },
        { id: '10306', name: '长龙乡' }
      ],
      4164: [
        { id: '39717', name: '县城内' },
        { id: '10406', name: '葛城镇' },
        { id: '10407', name: '巴山镇' },
        { id: '10408', name: '高观镇' },
        { id: '10409', name: '庙坝镇' },
        { id: '10410', name: '明通镇' },
        { id: '10411', name: '坪坝镇' },
        { id: '10412', name: '修齐镇' },
        { id: '10413', name: '北屏乡' },
        { id: '10414', name: '东安乡' },
        { id: '10415', name: '高楠乡' },
        { id: '10416', name: '高燕乡' },
        { id: '10417', name: '河鱼乡' },
        { id: '10418', name: '厚坪乡' },
        { id: '10419', name: '鸡鸣乡' },
        { id: '10420', name: '岚天乡' },
        { id: '10421', name: '蓼子乡' },
        { id: '10422', name: '龙田乡' },
        { id: '10423', name: '明中乡' },
        { id: '10424', name: '双河乡' },
        { id: '10425', name: '咸宜乡' },
        { id: '10426', name: '沿河乡' },
        { id: '10427', name: '治平乡' },
        { id: '10428', name: '周溪乡' },
        { id: '10429', name: '左岚乡' }
      ],
      129: [
        { id: '39692', name: '县城内' },
        { id: '10032', name: '仙女山镇' },
        { id: '10033', name: '巷口镇' },
        { id: '10034', name: '白马镇' },
        { id: '10035', name: '火炉镇' },
        { id: '10036', name: '江口镇' },
        { id: '10037', name: '平桥镇' },
        { id: '10038', name: '桐梓镇' },
        { id: '10039', name: '土坎镇' },
        { id: '10040', name: '鸭江镇' },
        { id: '10041', name: '羊角镇' },
        { id: '10042', name: '长坝镇' },
        { id: '10043', name: '白云乡' },
        { id: '10044', name: '沧沟乡' },
        { id: '10045', name: '凤来乡' },
        { id: '10046', name: '浩口乡' },
        { id: '10047', name: '和顺乡' },
        { id: '10048', name: '后坪乡' },
        { id: '10049', name: '黄莺乡' },
        { id: '10050', name: '接龙乡' },
        { id: '10051', name: '庙垭乡' },
        { id: '10052', name: '石桥乡' },
        { id: '10053', name: '双河乡' },
        { id: '10054', name: '铁矿乡' },
        { id: '10055', name: '土地乡' },
        { id: '10056', name: '文复乡' },
        { id: '10057', name: '赵家乡' }
      ],
      130: [
        { id: '39694', name: '县城内' },
        { id: '10059', name: '南天湖镇' },
        { id: '10060', name: '许明寺镇' },
        { id: '10061', name: '包鸾镇' },
        { id: '10062', name: '董家镇' },
        { id: '10063', name: '高家镇' },
        { id: '10064', name: '虎威镇' },
        { id: '10065', name: '江池镇' },
        { id: '10066', name: '龙河镇' },
        { id: '10067', name: '名山镇' },
        { id: '10068', name: '三元镇' },
        { id: '10069', name: '社坛镇' },
        { id: '10070', name: '十直镇' },
        { id: '10071', name: '树人镇' },
        { id: '10072', name: '双路镇' },
        { id: '10073', name: '武平镇' },
        { id: '10074', name: '兴义镇' },
        { id: '10075', name: '湛普镇' },
        { id: '10076', name: '镇江镇' },
        { id: '10077', name: '太平坝乡' },
        { id: '10078', name: '双龙场乡' },
        { id: '10079', name: '保合乡' },
        { id: '10080', name: '崇兴乡' },
        { id: '10081', name: '都督乡' },
        { id: '10082', name: '暨龙乡' },
        { id: '10083', name: '栗子乡' },
        { id: '10084', name: '龙孔乡' },
        { id: '10085', name: '青龙乡' },
        { id: '10086', name: '仁沙乡' },
        { id: '10087', name: '三坝乡' },
        { id: '10088', name: '三建乡' }
      ],
      131: [
        { id: '51706', name: '永乐镇' },
        { id: '39698', name: '县城内' },
        { id: '10377', name: '永安镇' },
        { id: '10378', name: '白帝镇' },
        { id: '10379', name: '草堂镇' },
        { id: '10380', name: '大树镇' },
        { id: '10381', name: '汾河镇' },
        { id: '10382', name: '公平镇' },
        { id: '10383', name: '甲高镇' },
        { id: '10384', name: '康乐镇' },
        { id: '10385', name: '青龙镇' },
        { id: '10386', name: '吐祥镇' },
        { id: '10387', name: '新民镇' },
        { id: '10388', name: '兴隆镇' },
        { id: '10389', name: '羊市镇' },
        { id: '10390', name: '朱衣镇' },
        { id: '10391', name: '竹园镇' },
        { id: '10392', name: '安坪乡' },
        { id: '10393', name: '冯坪乡' },
        { id: '10394', name: '鹤峰乡' },
        { id: '10395', name: '红土乡' },
        { id: '10396', name: '康坪乡' },
        { id: '10397', name: '龙桥乡' },
        { id: '10398', name: '平安乡' },
        { id: '10399', name: '石岗乡' },
        { id: '10400', name: '太和乡' },
        { id: '10401', name: '五马乡' },
        { id: '10402', name: '新政乡' },
        { id: '10403', name: '岩湾乡' },
        { id: '10404', name: '云雾乡' },
        { id: '10405', name: '长安乡' }
      ],
      135: [
        { id: '39704', name: '县城内' },
        { id: '10158', name: '城厢镇' },
        { id: '10159', name: '凤凰镇' },
        { id: '10160', name: '古路镇' },
        { id: '10161', name: '尖山镇' },
        { id: '10162', name: '宁厂镇' },
        { id: '10163', name: '上磺镇' },
        { id: '10164', name: '文峰镇' },
        { id: '10165', name: '下堡镇' },
        { id: '10166', name: '徐家镇' },
        { id: '10167', name: '朝阳洞乡' },
        { id: '10168', name: '大河乡' },
        { id: '10169', name: '峰灵乡' },
        { id: '10170', name: '花台乡' },
        { id: '10171', name: '兰英乡' },
        { id: '10172', name: '菱角乡' },
        { id: '10173', name: '蒲莲乡' },
        { id: '10174', name: '胜利乡' },
        { id: '10175', name: '双阳乡' },
        { id: '10176', name: '塘坊乡' },
        { id: '10177', name: '天星乡' },
        { id: '10178', name: '天元乡' },
        { id: '10179', name: '田坝乡' },
        { id: '10180', name: '通城乡' },
        { id: '10181', name: '土城乡' },
        { id: '10182', name: '乌龙乡' },
        { id: '10183', name: '鱼鳞乡' },
        { id: '10184', name: '长桂乡' },
        { id: '10185', name: '中岗乡' },
        { id: '10186', name: '中梁乡' }
      ],
      136: [
        { id: '39706', name: '县城内' },
        { id: '10187', name: '巫峡镇' },
        { id: '10188', name: '大昌镇' },
        { id: '10189', name: '福田镇' },
        { id: '10190', name: '官渡镇' },
        { id: '10191', name: '官阳镇' },
        { id: '10192', name: '龙溪镇' },
        { id: '10193', name: '骡坪镇' },
        { id: '10194', name: '庙堂乡' },
        { id: '10195', name: '庙宇镇' },
        { id: '10196', name: '双龙镇' },
        { id: '10197', name: '铜鼓镇' },
        { id: '10198', name: '抱龙镇' },
        { id: '10199', name: '大溪乡' },
        { id: '10200', name: '当阳乡' },
        { id: '10201', name: '邓家乡' },
        { id: '10202', name: '笃坪乡' },
        { id: '10203', name: '红椿乡' },
        { id: '10204', name: '建平乡' },
        { id: '10205', name: '金坪乡' },
        { id: '10206', name: '两坪乡' },
        { id: '10207', name: '龙井乡' },
        { id: '10208', name: '培石乡' },
        { id: '10209', name: '平河乡' },
        { id: '10210', name: '曲尺乡' },
        { id: '10211', name: '三溪乡' },
        { id: '10212', name: '竹贤乡' }
      ],
      137: [
        { id: '10240', name: '王家乡' },
        { id: '10241', name: '洗新乡' },
        { id: '10242', name: '新乐乡' },
        { id: '10243', name: '中益乡' },
        { id: '39710', name: '县城内' },
        { id: '10213', name: '南宾镇' },
        { id: '10214', name: '黄水镇' },
        { id: '10215', name: '临溪镇' },
        { id: '10216', name: '龙沙镇' },
        { id: '10217', name: '马武镇' },
        { id: '10218', name: '沙子镇' },
        { id: '10219', name: '王场镇' },
        { id: '10220', name: '西沱镇' },
        { id: '10221', name: '下路镇' },
        { id: '10222', name: '沿溪镇' },
        { id: '10223', name: '渔池镇' },
        { id: '10224', name: '悦崃镇' },
        { id: '10225', name: '大歇乡' },
        { id: '10226', name: '枫木乡' },
        { id: '10227', name: '河嘴乡' },
        { id: '10228', name: '黄鹤乡' },
        { id: '10229', name: '金铃乡' },
        { id: '10230', name: '金竹乡' },
        { id: '10231', name: '冷水乡' },
        { id: '10232', name: '黎场乡' },
        { id: '10233', name: '六塘乡' },
        { id: '10234', name: '龙潭乡' },
        { id: '10235', name: '桥头乡' },
        { id: '10236', name: '三河乡' },
        { id: '10237', name: '三益乡' },
        { id: '10238', name: '石家乡' },
        { id: '10239', name: '万朝乡' }
      ],
      138: [
        { id: '10245', name: '保家镇' },
        { id: '10246', name: '高谷镇' },
        { id: '10247', name: '黄家镇' },
        { id: '10248', name: '连湖镇' },
        { id: '10249', name: '龙射镇' },
        { id: '10250', name: '鹿角镇' },
        { id: '10251', name: '普子镇' },
        { id: '10252', name: '桑柘镇' },
        { id: '10253', name: '万足镇' },
        { id: '10254', name: '郁山镇' },
        { id: '10255', name: '梅子垭乡' },
        { id: '10256', name: '鞍子乡' },
        { id: '10257', name: '大垭乡' },
        { id: '10258', name: '棣棠乡' },
        { id: '10259', name: '靛水乡' },
        { id: '10260', name: '朗溪乡' },
        { id: '10261', name: '联合乡' },
        { id: '10262', name: '龙塘乡' },
        { id: '10263', name: '龙溪乡' },
        { id: '10264', name: '芦塘乡' },
        { id: '10265', name: '鹿鸣乡' },
        { id: '10266', name: '平安乡' },
        { id: '10267', name: '迁乔乡' },
        { id: '10268', name: '乔梓乡' },
        { id: '10269', name: '润溪乡' },
        { id: '10270', name: '三义乡' },
        { id: '10271', name: '善感乡' },
        { id: '39711', name: '县城内' },
        { id: '10272', name: '石柳乡' },
        { id: '10273', name: '石盘乡' },
        { id: '10274', name: '双龙乡' },
        { id: '10275', name: '太原乡' },
        { id: '10276', name: '桐楼乡' },
        { id: '10277', name: '小厂乡' },
        { id: '10278', name: '新田乡' },
        { id: '10279', name: '岩东乡' },
        { id: '10280', name: '长滩乡' },
        { id: '10281', name: '诸佛乡' },
        { id: '10282', name: '走马乡' }
      ],
      140: [
        { id: '39714', name: '县城内' },
        { id: '10307', name: '钟多镇' },
        { id: '10308', name: '苍岭镇' },
        { id: '10309', name: '车田乡' },
        { id: '10310', name: '大溪镇' },
        { id: '10311', name: '丁市镇' },
        { id: '10312', name: '泔溪镇' },
        { id: '10313', name: '龚滩镇' },
        { id: '10314', name: '黑水镇' },
        { id: '10315', name: '后溪镇' },
        { id: '10316', name: '李溪镇' },
        { id: '10317', name: '龙潭镇' },
        { id: '10318', name: '麻旺镇' },
        { id: '10319', name: '小河镇' },
        { id: '10320', name: '兴隆镇' },
        { id: '10321', name: '酉酬镇' },
        { id: '10322', name: '南腰界乡' },
        { id: '10323', name: '后坪坝乡' },
        { id: '10324', name: '板溪乡' },
        { id: '10325', name: '官清乡' },
        { id: '10326', name: '花田乡' },
        { id: '10327', name: '江丰乡' },
        { id: '10328', name: '可大乡' },
        { id: '10329', name: '浪坪乡' },
        { id: '10330', name: '两罾乡' },
        { id: '10331', name: '毛坝乡' },
        { id: '10332', name: '庙溪乡' },
        { id: '10333', name: '木叶乡' },
        { id: '10334', name: '楠木乡' },
        { id: '10335', name: '偏柏乡' },
        { id: '10336', name: '清泉乡' },
        { id: '10337', name: '双泉乡' },
        { id: '10338', name: '天馆乡' },
        { id: '10339', name: '铜鼓乡' },
        { id: '10340', name: '涂市乡' },
        { id: '10341', name: '万木乡' },
        { id: '10342', name: '五福乡' },
        { id: '10343', name: '宜居乡' },
        { id: '10344', name: '腴地乡' },
        { id: '10345', name: '板桥乡' }
      ],
      141: [
        { id: '39716', name: '县城内' },
        { id: '10346', name: '清溪场镇' },
        { id: '10347', name: '中和镇' },
        { id: '10348', name: '隘口镇' },
        { id: '10349', name: '峨溶镇' },
        { id: '10350', name: '官庄镇' },
        { id: '10351', name: '洪安镇' },
        { id: '10352', name: '兰桥镇' },
        { id: '10353', name: '龙池镇' },
        { id: '10354', name: '梅江镇' },
        { id: '10355', name: '平凯镇' },
        { id: '10356', name: '溶溪镇' },
        { id: '10357', name: '石堤镇' },
        { id: '10358', name: '石耶镇' },
        { id: '10359', name: '雅江镇' },
        { id: '10360', name: '巴家乡' },
        { id: '10361', name: '保安乡' },
        { id: '10362', name: '岑溪乡' },
        { id: '10363', name: '大溪乡' },
        { id: '10364', name: '干川乡' },
        { id: '10365', name: '膏田乡' },
        { id: '10366', name: '官舟乡' },
        { id: '10367', name: '海洋乡' },
        { id: '10368', name: '里仁乡' },
        { id: '10369', name: '妙泉乡' },
        { id: '10370', name: '平马乡' },
        { id: '10371', name: '宋农乡' },
        { id: '10372', name: '溪口乡' },
        { id: '10373', name: '孝溪乡' },
        { id: '10374', name: '涌洞乡' },
        { id: '10375', name: '中平乡' },
        { id: '10376', name: '钟灵乡' }
      ],
      258: [
        { id: '41497', name: '路北区' },
        { id: '41499', name: '路南区' },
        { id: '41500', name: '迁安市' },
        { id: '41502', name: '丰润区' },
        { id: '3202', name: '古冶区' },
        { id: '3203', name: '开平区' },
        { id: '2756', name: '遵化市' },
        { id: '2757', name: '丰南区' },
        { id: '2759', name: '迁西县' },
        { id: '2760', name: '滦南县' },
        { id: '2762', name: '玉田县' },
        { id: '2763', name: '曹妃甸区' },
        { id: '2764', name: '乐亭县' },
        { id: '2765', name: '滦县' }
      ],
      264: [
        { id: '265', name: '沧县' },
        { id: '266', name: '泊头市' },
        { id: '268', name: '河间市' },
        { id: '269', name: '献县' },
        { id: '270', name: '肃宁县' },
        { id: '271', name: '青县' },
        { id: '272', name: '东光县' },
        { id: '273', name: '吴桥县' },
        { id: '276', name: '南皮县' },
        { id: '277', name: '盐山县' },
        { id: '278', name: '海兴县' },
        { id: '279', name: '孟村县' },
        { id: '49576', name: '运河区' },
        { id: '49577', name: '新华区' },
        { id: '49578', name: '任丘市' },
        { id: '49579', name: '黄骅市' }
      ],
      274: [
        { id: '49707', name: '三河市' },
        { id: '3207', name: '广阳区' },
        { id: '4097', name: '开发区' },
        { id: '284', name: '固安县' },
        { id: '3206', name: '安次区' },
        { id: '285', name: '永清县' },
        { id: '286', name: '香河县' },
        { id: '287', name: '大城县' },
        { id: '288', name: '文安县' },
        { id: '289', name: '大厂县' },
        { id: '49708', name: '霸州市' }
      ],
      275: [
        { id: '291', name: '冀州市' },
        { id: '292', name: '深州市' },
        { id: '293', name: '饶阳县' },
        { id: '294', name: '枣强县' },
        { id: '41510', name: '桃城区' },
        { id: '295', name: '故城县' },
        { id: '296', name: '阜城县' },
        { id: '297', name: '安平县' },
        { id: '298', name: '武邑县' },
        { id: '299', name: '景县' },
        { id: '300', name: '武强县' }
      ],
      142: [
        { id: '42540', name: '藁城市' },
        { id: '42541', name: '鹿泉市' },
        { id: '42542', name: '正定县' },
        { id: '42543', name: '新华区' },
        { id: '42544', name: '桥西区' },
        { id: '42545', name: '桥东区' },
        { id: '42546', name: '裕华区' },
        { id: '42547', name: '长安区' },
        { id: '143', name: '辛集市' },
        { id: '145', name: '晋州市' },
        { id: '146', name: '新乐市' },
        { id: '4158', name: '平山县' },
        { id: '3182', name: '井陉矿区' },
        { id: '153', name: '井陉县' },
        { id: '154', name: '栾城县' },
        { id: '156', name: '行唐县' },
        { id: '157', name: '灵寿县' },
        { id: '158', name: '高邑县' },
        { id: '159', name: '赵县' },
        { id: '160', name: '赞皇县' },
        { id: '161', name: '深泽县' },
        { id: '162', name: '无极县' },
        { id: '163', name: '元氏县' }
      ],
      148: [
        { id: '34049', name: '丛台区' },
        { id: '34050', name: '邯山区' },
        { id: '34051', name: '复兴区' },
        { id: '34052', name: '武安市' },
        { id: '3077', name: '临漳县' },
        { id: '3187', name: '永年县' },
        { id: '167', name: '邯郸县' },
        { id: '168', name: '峰峰矿区' },
        { id: '169', name: '曲周县' },
        { id: '170', name: '馆陶县' },
        { id: '171', name: '魏县' },
        { id: '172', name: '成安县' },
        { id: '173', name: '大名县' },
        { id: '174', name: '涉县' },
        { id: '175', name: '鸡泽县' },
        { id: '176', name: '邱县' },
        { id: '177', name: '广平县' },
        { id: '178', name: '肥乡县' },
        { id: '180', name: '磁县' }
      ],
      164: [
        { id: '257', name: '宁晋县' },
        { id: '3098', name: '威县' },
        { id: '47712', name: '桥西区' },
        { id: '47713', name: '桥东区' },
        { id: '183', name: '邢台县' },
        { id: '184', name: '南宫市' },
        { id: '185', name: '沙河市' },
        { id: '186', name: '柏乡县' },
        { id: '187', name: '任县' },
        { id: '188', name: '清河县' },
        { id: '189', name: '隆尧县' },
        { id: '190', name: '临城县' },
        { id: '191', name: '广宗县' },
        { id: '192', name: '临西县' },
        { id: '193', name: '内丘县' },
        { id: '194', name: '平乡县' },
        { id: '195', name: '巨鹿县' },
        { id: '196', name: '新河县' },
        { id: '197', name: '南和县' }
      ],
      199: [
        { id: '47213', name: '涿州市' },
        { id: '47214', name: '定州市' },
        { id: '47215', name: '徐水县' },
        { id: '47216', name: '高碑店市' },
        { id: '3190', name: '新市区' },
        { id: '3191', name: '北市区' },
        { id: '3192', name: '南市区' },
        { id: '203', name: '安国市' },
        { id: '3193', name: '安新县' },
        { id: '205', name: '满城县' },
        { id: '206', name: '清苑县' },
        { id: '207', name: '涞水县' },
        { id: '208', name: '阜平县' },
        { id: '210', name: '定兴县' },
        { id: '211', name: '唐县' },
        { id: '212', name: '高阳县' },
        { id: '213', name: '容城县' },
        { id: '214', name: '涞源县' },
        { id: '215', name: '望都县' },
        { id: '217', name: '易县' },
        { id: '218', name: '曲阳县' },
        { id: '219', name: '蠡县' },
        { id: '220', name: '顺平县' },
        { id: '221', name: '博野县' },
        { id: '222', name: '雄县' }
      ],
      224: [
        { id: '230', name: '怀安县' },
        { id: '3156', name: '沽源县' },
        { id: '4046', name: '宣化区' },
        { id: '225', name: '宣化县' },
        { id: '226', name: '康保县' },
        { id: '227', name: '张北县' },
        { id: '228', name: '阳原县' },
        { id: '229', name: '赤城县' },
        { id: '232', name: '崇礼县' },
        { id: '233', name: '尚义县' },
        { id: '234', name: '蔚县' },
        { id: '235', name: '涿鹿县' },
        { id: '236', name: '万全县' },
        { id: '238', name: '下花园区' },
        { id: '34298', name: '桥西区' },
        { id: '34299', name: '桥东区' },
        { id: '231', name: '怀来县' }
      ],
      239: [
        { id: '3197', name: '双滦区' },
        { id: '3198', name: '鹰手营子矿区' },
        { id: '2767', name: '隆化县' },
        { id: '241', name: '兴隆县' },
        { id: '242', name: '平泉市' },
        { id: '243', name: '滦平县' },
        { id: '245', name: '丰宁县' },
        { id: '246', name: '围场县' },
        { id: '247', name: '宽城县' },
        { id: '48379', name: '双桥区' },
        { id: '3092', name: '承德县' }
      ],
      248: [
        { id: '261', name: '卢龙县' },
        { id: '262', name: '青龙县' },
        { id: '263', name: '昌黎县' },
        { id: '2990', name: '北戴河区' },
        { id: '48377', name: '海港区' },
        { id: '48378', name: '山海关区' },
        { id: '4093', name: '抚宁县' }
      ],
      3074: [
        { id: '3075', name: '长治县' },
        { id: '3109', name: '潞城市' },
        { id: '3222', name: '郊区' },
        { id: '3223', name: '襄垣县' },
        { id: '3224', name: '屯留县' },
        { id: '3225', name: '平顺县' },
        { id: '3226', name: '黎城县' },
        { id: '3227', name: '壶关县' },
        { id: '3228', name: '长子县' },
        { id: '3229', name: '武乡县' },
        { id: '3230', name: '沁县' },
        { id: '3231', name: '沁源县' },
        { id: '32505', name: '城区' }
      ],
      303: [
        { id: '36780', name: '小店区' },
        { id: '36781', name: '迎泽区' },
        { id: '36782', name: '晋源区' },
        { id: '36783', name: '万柏林区' },
        { id: '36784', name: '尖草坪区' },
        { id: '36785', name: '杏花岭区' },
        { id: '305', name: '古交市' },
        { id: '304', name: '阳曲县' },
        { id: '306', name: '娄烦县' },
        { id: '307', name: '清徐县' }
      ],
      309: [
        { id: '310', name: '大同县' },
        { id: '311', name: '天镇县' },
        { id: '312', name: '灵丘县' },
        { id: '313', name: '阳高县' },
        { id: '314', name: '左云县' },
        { id: '315', name: '浑源县' },
        { id: '316', name: '广灵县' },
        { id: '32061', name: '城区' },
        { id: '3214', name: '新荣区' },
        { id: '3216', name: '南郊区' },
        { id: '3217', name: '矿区' }
      ],
      318: [
        { id: '319', name: '盂县' },
        { id: '320', name: '平定县' },
        { id: '321', name: '郊区' },
        { id: '44144', name: '城区' },
        { id: '3219', name: '矿区' }
      ],
      325: [
        { id: '3073', name: '城区' },
        { id: '326', name: '高平市' },
        { id: '327', name: '阳城县' },
        { id: '328', name: '沁水县' },
        { id: '329', name: '陵川县' },
        { id: '2967', name: '泽州县' }
      ],
      330: [
        { id: '3118', name: '平鲁区' },
        { id: '331', name: '山阴县' },
        { id: '332', name: '右玉县' },
        { id: '333', name: '应县' },
        { id: '334', name: '怀仁县' },
        { id: '335', name: '朔城区' }
      ],
      336: [
        { id: '338', name: '介休市' },
        { id: '339', name: '昔阳县' },
        { id: '341', name: '祁县' },
        { id: '342', name: '左权县' },
        { id: '343', name: '寿阳县' },
        { id: '344', name: '太谷县' },
        { id: '345', name: '和顺县' },
        { id: '346', name: '灵石县' },
        { id: '347', name: '平遥县' },
        { id: '348', name: '榆社县' },
        { id: '44145', name: '榆次区' }
      ],
      350: [
        { id: '351', name: '原平市' },
        { id: '352', name: '代县' },
        { id: '353', name: '神池县' },
        { id: '354', name: '五寨县' },
        { id: '358', name: '五台县' },
        { id: '359', name: '偏关县' },
        { id: '360', name: '宁武县' },
        { id: '361', name: '静乐县' },
        { id: '362', name: '繁峙县' },
        { id: '363', name: '河曲县' },
        { id: '364', name: '保德县' },
        { id: '365', name: '定襄县' },
        { id: '366', name: '忻府区' },
        { id: '367', name: '岢岚县' }
      ],
      368: [
        { id: '369', name: '离石区' },
        { id: '370', name: '孝义市' },
        { id: '371', name: '汾阳市' },
        { id: '372', name: '文水县' },
        { id: '373', name: '中阳县' },
        { id: '374', name: '兴县' },
        { id: '375', name: '临县' },
        { id: '376', name: '方山县' },
        { id: '377', name: '柳林县' },
        { id: '378', name: '岚县' },
        { id: '3235', name: '交口县' },
        { id: '3236', name: '交城县' },
        { id: '3237', name: '石楼县' }
      ],
      379: [
        { id: '3136', name: '曲沃县' },
        { id: '380', name: '侯马市' },
        { id: '381', name: '霍州市' },
        { id: '382', name: '汾西县' },
        { id: '383', name: '吉县' },
        { id: '384', name: '安泽县' },
        { id: '386', name: '浮山县' },
        { id: '387', name: '大宁县' },
        { id: '388', name: '古县' },
        { id: '389', name: '隰县' },
        { id: '390', name: '襄汾县' },
        { id: '391', name: '翼城县' },
        { id: '392', name: '永和县' },
        { id: '393', name: '乡宁县' },
        { id: '395', name: '洪洞县' },
        { id: '396', name: '蒲县' },
        { id: '32206', name: '尧都区' }
      ],
      398: [
        { id: '32360', name: '盐湖区' },
        { id: '399', name: '河津市' },
        { id: '400', name: '永济市' },
        { id: '402', name: '新绛县' },
        { id: '403', name: '平陆县' },
        { id: '404', name: '垣曲县' },
        { id: '405', name: '绛县' },
        { id: '406', name: '稷山县' },
        { id: '407', name: '芮城县' },
        { id: '408', name: '夏县' },
        { id: '409', name: '临猗县' },
        { id: '410', name: '万荣县' },
        { id: '3233', name: '闻喜县' }
      ],
      517: [
        { id: '518', name: '永城市' },
        { id: '519', name: '宁陵县' },
        { id: '520', name: '虞城县' },
        { id: '521', name: '民权县' },
        { id: '522', name: '夏邑县' },
        { id: '523', name: '柘城县' },
        { id: '524', name: '睢县' },
        { id: '34751', name: '睢阳区' },
        { id: '34752', name: '梁园区' }
      ],
      527: [
        { id: '529', name: '项城市' },
        { id: '530', name: '商水县' },
        { id: '531', name: '淮阳县' },
        { id: '532', name: '太康县' },
        { id: '533', name: '鹿邑县' },
        { id: '534', name: '西华县' },
        { id: '535', name: '扶沟县' },
        { id: '536', name: '沈丘县' },
        { id: '537', name: '郸城县' },
        { id: '35108', name: '川汇区' },
        { id: '34926', name: '东新区' },
        { id: '34927', name: '经济开发区' }
      ],
      538: [
        { id: '540', name: '确山县' },
        { id: '541', name: '新蔡县' },
        { id: '542', name: '上蔡县' },
        { id: '543', name: '泌阳县' },
        { id: '544', name: '西平县' },
        { id: '545', name: '遂平县' },
        { id: '546', name: '汝南县' },
        { id: '547', name: '平舆县' },
        { id: '548', name: '正阳县' },
        { id: '35189', name: '驿城区' }
      ],
      549: [
        { id: '551', name: '潢川县' },
        { id: '552', name: '淮滨县' },
        { id: '553', name: '息县' },
        { id: '554', name: '新县' },
        { id: '556', name: '固始县' },
        { id: '557', name: '罗山县' },
        { id: '558', name: '光山县' },
        { id: '3119', name: '商城县' },
        { id: '34548', name: '平桥区' },
        { id: '34549', name: '浉河区' }
      ],
      412: [
        { id: '3547', name: '二七区' },
        { id: '3548', name: '中原区' },
        { id: '4337', name: '郑东新区' },
        { id: '3546', name: '管城区' },
        { id: '3545', name: '金水区' },
        { id: '47300', name: '经济开发区' },
        { id: '47301', name: '高新技术开发区' },
        { id: '46820', name: '新郑市' },
        { id: '46821', name: '巩义市' },
        { id: '46822', name: '荥阳市' },
        { id: '46823', name: '中牟县' },
        { id: '415', name: '新密市' },
        { id: '416', name: '登封市' },
        { id: '3544', name: '惠济区' },
        { id: '2782', name: '上街区' }
      ],
      420: [
        { id: '45533', name: '金明区' },
        { id: '45534', name: '龙亭区' },
        { id: '45535', name: '顺河区' },
        { id: '45536', name: '鼓楼区' },
        { id: '45537', name: '禹王台区' },
        { id: '3127', name: '通许县' },
        { id: '421', name: '开封县' },
        { id: '422', name: '杞县' },
        { id: '423', name: '兰考县' },
        { id: '425', name: '尉氏县' }
      ],
      427: [
        { id: '3556', name: '涧西区' },
        { id: '3559', name: '西工区' },
        { id: '45532', name: '洛龙区' },
        { id: '4150', name: '嵩县' },
        { id: '428', name: '偃师市' },
        { id: '429', name: '孟津县' },
        { id: '430', name: '汝阳县' },
        { id: '431', name: '伊川县' },
        { id: '432', name: '洛宁县' },
        { id: '434', name: '宜阳县' },
        { id: '435', name: '栾川县' },
        { id: '436', name: '新安县' },
        { id: '45531', name: '伊滨区' },
        { id: '3555', name: '吉利区' },
        { id: '3557', name: '瀍河区' },
        { id: '3558', name: '老城区' }
      ],
      438: [
        { id: '35965', name: '湛河区' },
        { id: '35966', name: '卫东区' },
        { id: '35967', name: '新华区' },
        { id: '439', name: '汝州市' },
        { id: '440', name: '舞钢市' },
        { id: '441', name: '郏县' },
        { id: '442', name: '叶县' },
        { id: '443', name: '鲁山县' },
        { id: '444', name: '宝丰县' },
        { id: '3560', name: '石龙区' }
      ],
      446: [
        { id: '447', name: '沁阳市' },
        { id: '448', name: '孟州市' },
        { id: '449', name: '修武县' },
        { id: '450', name: '温县' },
        { id: '451', name: '武陟县' },
        { id: '452', name: '博爱县' },
        { id: '453', name: '山阳区' },
        { id: '3566', name: '解放区' },
        { id: '37371', name: '马村区' },
        { id: '37372', name: '中站区' }
      ],
      454: [
        { id: '35591', name: '淇滨区' },
        { id: '455', name: '浚县' },
        { id: '456', name: '淇县' },
        { id: '457', name: '鹤山区' },
        { id: '3567', name: '山城区' }
      ],
      458: [
        { id: '37456', name: '牧野区' },
        { id: '37457', name: '红旗区' },
        { id: '37458', name: '卫滨区' },
        { id: '459', name: '卫辉市' },
        { id: '460', name: '辉县市' },
        { id: '461', name: '新乡县' },
        { id: '462', name: '获嘉县' },
        { id: '463', name: '原阳县' },
        { id: '464', name: '长垣县' },
        { id: '465', name: '延津县' },
        { id: '466', name: '封丘县' },
        { id: '3570', name: '凤泉区' }
      ],
      468: [
        { id: '35470', name: '龙安区' },
        { id: '35471', name: '殷都区' },
        { id: '35472', name: '文峰区' },
        { id: '35473', name: '开发区' },
        { id: '35474', name: '北关区' },
        { id: '469', name: '林州市' },
        { id: '470', name: '安阳县' },
        { id: '471', name: '滑县' },
        { id: '472', name: '汤阴县' },
        { id: '473', name: '内黄县' }
      ],
      475: [
        { id: '476', name: '濮阳县' },
        { id: '477', name: '南乐县' },
        { id: '478', name: '台前县' },
        { id: '479', name: '清丰县' },
        { id: '480', name: '范县' },
        { id: '481', name: '华龙区' }
      ],
      2780: [
        { id: '52305', name: '城区' },
        { id: '35178', name: '五龙口镇' },
        { id: '35179', name: '下冶镇' },
        { id: '35180', name: '轵城镇' },
        { id: '35181', name: '王屋镇' },
        { id: '35182', name: '思礼镇' },
        { id: '35183', name: '邵原镇' },
        { id: '35184', name: '坡头镇' },
        { id: '35185', name: '梨林镇' },
        { id: '35186', name: '克井镇' },
        { id: '35187', name: '大峪镇' },
        { id: '35188', name: '承留镇' }
      ],
      482: [
        { id: '488', name: '魏都区' },
        { id: '483', name: '禹州市' },
        { id: '484', name: '长葛市' },
        { id: '485', name: '建安区' },
        { id: '486', name: '鄢陵县' },
        { id: '487', name: '襄城县' }
      ],
      489: [
        { id: '490', name: '郾城区' },
        { id: '492', name: '临颍县' },
        { id: '493', name: '召陵区' },
        { id: '494', name: '舞阳县' },
        { id: '3576', name: '源汇区' }
      ],
      495: [
        { id: '3113', name: '渑池县' },
        { id: '35637', name: '湖滨区' },
        { id: '496', name: '义马市' },
        { id: '497', name: '灵宝市' },
        { id: '498', name: '陕县' },
        { id: '499', name: '卢氏县' }
      ],
      502: [
        { id: '512', name: '社旗县' },
        { id: '515', name: '西峡县' },
        { id: '35751', name: '卧龙区' },
        { id: '35752', name: '宛城区' },
        { id: '503', name: '邓州市' },
        { id: '504', name: '桐柏县' },
        { id: '505', name: '方城县' },
        { id: '506', name: '淅川县' },
        { id: '507', name: '镇平县' },
        { id: '508', name: '唐河县' },
        { id: '509', name: '南召县' },
        { id: '510', name: '内乡县' },
        { id: '511', name: '新野县' }
      ],
      560: [
        { id: '567', name: '苏家屯区' },
        { id: '569', name: '新民市' },
        { id: '570', name: '法库县' },
        { id: '571', name: '辽中县' },
        { id: '572', name: '康平县' },
        { id: '50819', name: '皇姑区' },
        { id: '50820', name: '铁西区' },
        { id: '50821', name: '大东区' },
        { id: '50822', name: '沈河区' },
        { id: '50823', name: '东陵区' },
        { id: '50824', name: '于洪区' },
        { id: '50825', name: '和平区' },
        { id: '50826', name: '浑南新区' },
        { id: '50827', name: '沈北新区' }
      ],
      573: [
        { id: '4468', name: '中山区' },
        { id: '3261', name: '沙河口区' },
        { id: '3263', name: '西岗区' },
        { id: '5909', name: '甘井子区' },
        { id: '6561', name: '高新园区' },
        { id: '6627', name: '大连开发区' },
        { id: '46824', name: '金州区' },
        { id: '46825', name: '旅顺口区' },
        { id: '574', name: '普兰店市' },
        { id: '575', name: '瓦房店市' },
        { id: '576', name: '庄河市' },
        { id: '577', name: '长海县' }
      ],
      579: [
        { id: '3264', name: '铁东区' },
        { id: '3266', name: '立山区' },
        { id: '580', name: '台安县' },
        { id: '581', name: '海城市' },
        { id: '583', name: '岫岩县' },
        { id: '37581', name: '铁西区' },
        { id: '37582', name: '千山区' }
      ],
      584: [
        { id: '3268', name: '望花区' },
        { id: '3269', name: '东洲区' },
        { id: '3270', name: '新抚区' },
        { id: '3271', name: '顺城区' },
        { id: '585', name: '抚顺县' },
        { id: '586', name: '新宾县' },
        { id: '587', name: '清原县' }
      ],
      589: [
        { id: '591', name: '桓仁县' },
        { id: '41341', name: '本溪县' },
        { id: '41342', name: '平山区' },
        { id: '41343', name: '溪湖区' },
        { id: '41344', name: '明山区' },
        { id: '3275', name: '南芬区' }
      ],
      593: [
        { id: '20171', name: '元宝区' },
        { id: '20172', name: '振兴区' },
        { id: '20173', name: '振安区' },
        { id: '20174', name: '东港市' },
        { id: '20175', name: '凤城市' },
        { id: '596', name: '宽甸县' }
      ],
      598: [
        { id: '4913', name: '凌河区' },
        { id: '4912', name: '古塔区' },
        { id: '4914', name: '太和区' },
        { id: '599', name: '义县' },
        { id: '600', name: '凌海市' },
        { id: '601', name: '北镇市' },
        { id: '602', name: '黑山县' },
        { id: '6790', name: '经济技术开发区' }
      ],
      604: [
        { id: '3300', name: '龙港区' },
        { id: '20524', name: '连山区' },
        { id: '20525', name: '兴城市' },
        { id: '606', name: '绥中县' },
        { id: '607', name: '建昌县' },
        { id: '608', name: '南票区' }
      ],
      609: [
        { id: '3283', name: '西市区' },
        { id: '6628', name: '站前区' },
        { id: '610', name: '大石桥市' },
        { id: '611', name: '盖州市' },
        { id: '3282', name: '老边区' },
        { id: '20183', name: '鲅鱼圈区' }
      ],
      613: [
        { id: '614', name: '盘山县' },
        { id: '615', name: '大洼县' },
        { id: '20661', name: '兴隆台区' },
        { id: '20662', name: '双台子区' }
      ],
      617: [
        { id: '618', name: '阜新县' },
        { id: '619', name: '彰武县' },
        { id: '20658', name: '海州区' },
        { id: '20659', name: '太平区' },
        { id: '20660', name: '细河区' },
        { id: '3286', name: '清河门区' },
        { id: '3288', name: '新邱区' }
      ],
      621: [
        { id: '623', name: '辽阳县' },
        { id: '43963', name: '白塔区' },
        { id: '43964', name: '文圣区' },
        { id: '43965', name: '灯塔市' },
        { id: '3290', name: '太子河区' },
        { id: '3291', name: '弓长岭区' },
        { id: '3292', name: '宏伟区' }
      ],
      632: [
        { id: '633', name: '凌源市' },
        { id: '634', name: '北票市' },
        { id: '635', name: '喀喇沁左翼县' },
        { id: '636', name: '朝阳县' },
        { id: '20348', name: '双塔区' },
        { id: '637', name: '建平县' },
        { id: '3299', name: '龙城区' }
      ],
      6858: [
        { id: '6859', name: '银州区' },
        { id: '6860', name: '清河区' },
        { id: '6862', name: '开原市' },
        { id: '6863', name: '铁岭县' },
        { id: '6864', name: '西丰县' },
        { id: '6865', name: '昌图县' },
        { id: '44027', name: '调兵山市' }
      ],
      639: [
        { id: '3172', name: '德惠市' },
        { id: '640', name: '榆树市' },
        { id: '641', name: '九台市' },
        { id: '642', name: '农安县' },
        { id: '38630', name: '朝阳区' },
        { id: '38631', name: '南关区' },
        { id: '38632', name: '宽城区' },
        { id: '38633', name: '二道区' },
        { id: '3306', name: '双阳区' },
        { id: '38634', name: '绿园区' },
        { id: '38635', name: '净月区' },
        { id: '38636', name: '汽车产业开发区' },
        { id: '38637', name: '高新技术开发区' },
        { id: '38638', name: '经济技术开发区' }
      ],
      644: [
        { id: '24069', name: '昌邑区' },
        { id: '24070', name: '龙潭区' },
        { id: '24071', name: '船营区' },
        { id: '24072', name: '丰满区' },
        { id: '645', name: '舒兰市' },
        { id: '646', name: '桦甸市' },
        { id: '647', name: '蛟河市' },
        { id: '648', name: '磐石市' },
        { id: '649', name: '永吉县' }
      ],
      651: [
        { id: '6641', name: '铁东区' },
        { id: '6642', name: '铁西区' },
        { id: '652', name: '公主岭市' },
        { id: '653', name: '双辽市' },
        { id: '654', name: '梨树县' },
        { id: '656', name: '伊通县' }
      ],
      657: [
        { id: '3311', name: '东昌区' },
        { id: '658', name: '梅河口市' },
        { id: '659', name: '集安市' },
        { id: '660', name: '通化县' },
        { id: '661', name: '辉南县' },
        { id: '662', name: '柳河县' },
        { id: '663', name: '二道江区' }
      ],
      664: [
        { id: '24074', name: '浑江区' },
        { id: '665', name: '临江市' },
        { id: '669', name: '江源区' },
        { id: '671', name: '靖宇县' },
        { id: '672', name: '抚松县' },
        { id: '673', name: '长白县' }
      ],
      674: [
        { id: '24075', name: '宁江区' },
        { id: '24076', name: '前郭县' },
        { id: '675', name: '乾安县' },
        { id: '676', name: '长岭县' },
        { id: '677', name: '扶余县' }
      ],
      681: [
        { id: '682', name: '大安市' },
        { id: '683', name: '洮南市' },
        { id: '684', name: '通榆县' },
        { id: '685', name: '镇赉县' },
        { id: '686', name: '洮北区' }
      ],
      687: [
        { id: '24073', name: '延吉市' },
        { id: '3312', name: '图们市' },
        { id: '3313', name: '敦化市' },
        { id: '3314', name: '珲春市' },
        { id: '3315', name: '龙井市' },
        { id: '3316', name: '和龙市' },
        { id: '3317', name: '汪清县' },
        { id: '3318', name: '安图县' }
      ],
      2992: [
        { id: '2993', name: '龙山区' },
        { id: '2994', name: '西安区' },
        { id: '2995', name: '东丰县' },
        { id: '2996', name: '东辽县' }
      ],
      773: [
        { id: '774', name: '勃利县' },
        { id: '3364', name: '桃山区' },
        { id: '3365', name: '新兴区' },
        { id: '3366', name: '茄子河区' },
        { id: '53287', name: '金沙新区' }
      ],
      776: [
        { id: '777', name: '北安市' },
        { id: '778', name: '五大连池市' },
        { id: '779', name: '逊克县' },
        { id: '780', name: '孙吴县' },
        { id: '3096', name: '嫩江县' },
        { id: '3371', name: '爱辉区' }
      ],
      782: [
        { id: '6712', name: '北林区' },
        { id: '784', name: '安达市' },
        { id: '785', name: '肇东市' },
        { id: '786', name: '海伦市' },
        { id: '787', name: '绥棱县' },
        { id: '788', name: '兰西县' },
        { id: '789', name: '明水县' },
        { id: '790', name: '青冈县' },
        { id: '791', name: '庆安县' },
        { id: '792', name: '望奎县' }
      ],
      793: [
        { id: '4114', name: '加格达奇区' },
        { id: '4115', name: '松岭区' },
        { id: '4116', name: '呼中区' },
        { id: '794', name: '呼玛县' },
        { id: '795', name: '塔河县' },
        { id: '796', name: '漠河县' },
        { id: '11432', name: '新林区' }
      ],
      698: [
        { id: '699', name: '阿城区' },
        { id: '700', name: '尚志市' },
        { id: '701', name: '双城市' },
        { id: '702', name: '五常市' },
        { id: '704', name: '方正县' },
        { id: '705', name: '宾县' },
        { id: '706', name: '依兰县' },
        { id: '707', name: '巴彦县' },
        { id: '708', name: '通河县' },
        { id: '709', name: '木兰县' },
        { id: '710', name: '延寿县' },
        { id: '45814', name: '呼兰区' },
        { id: '45815', name: '松北区' },
        { id: '45816', name: '道里区' },
        { id: '45817', name: '南岗区' },
        { id: '45818', name: '道外区' },
        { id: '45819', name: '香坊区' },
        { id: '45820', name: '平房区' }
      ],
      712: [
        { id: '33404', name: '建华区' },
        { id: '33405', name: '龙沙区' },
        { id: '33406', name: '铁锋区' },
        { id: '713', name: '梅里斯区' },
        { id: '714', name: '昂昂溪区' },
        { id: '715', name: '富拉尔基区' },
        { id: '716', name: '碾子山区' },
        { id: '717', name: '讷河市' },
        { id: '718', name: '富裕县' },
        { id: '719', name: '拜泉县' },
        { id: '720', name: '甘南县' },
        { id: '721', name: '依安县' },
        { id: '722', name: '克山县' },
        { id: '723', name: '龙江县' },
        { id: '724', name: '克东县' },
        { id: '725', name: '泰来县' }
      ],
      727: [
        { id: '3334', name: '兴山区' },
        { id: '3335', name: '向阳区' },
        { id: '3336', name: '工农区' },
        { id: '3337', name: '南山区' },
        { id: '3338', name: '兴安区' },
        { id: '3339', name: '东山区' },
        { id: '728', name: '萝北县' },
        { id: '729', name: '绥滨县' }
      ],
      731: [
        { id: '3340', name: '尖山区' },
        { id: '3341', name: '岭东区' },
        { id: '3342', name: '四方台区' },
        { id: '3343', name: '宝山区' },
        { id: '733', name: '集贤县' },
        { id: '734', name: '宝清县' },
        { id: '735', name: '友谊县' },
        { id: '736', name: '饶河县' }
      ],
      737: [
        { id: '3329', name: '恒山区' },
        { id: '3330', name: '滴道区' },
        { id: '3331', name: '梨树区' },
        { id: '3332', name: '城子河区' },
        { id: '3333', name: '麻山区' },
        { id: '33163', name: '鸡冠区' },
        { id: '739', name: '密山市' },
        { id: '740', name: '虎林市' },
        { id: '741', name: '鸡东县' }
      ],
      742: [
        { id: '744', name: '萨尔图区' },
        { id: '745', name: '龙凤区' },
        { id: '746', name: '让胡路区' },
        { id: '747', name: '红岗区' },
        { id: '748', name: '大同区' },
        { id: '749', name: '林甸县' },
        { id: '750', name: '肇州县' },
        { id: '751', name: '肇源县' },
        { id: '752', name: '杜尔伯特县' }
      ],
      753: [
        { id: '3344', name: '伊春区' },
        { id: '3345', name: '南岔区' },
        { id: '3346', name: '友好区' },
        { id: '3347', name: '西林区' },
        { id: '3348', name: '翠峦区' },
        { id: '3349', name: '新青区' },
        { id: '3350', name: '美溪区' },
        { id: '3351', name: '金山屯区' },
        { id: '3352', name: '五营区' },
        { id: '3353', name: '乌马河区' },
        { id: '3354', name: '汤旺河区' },
        { id: '3355', name: '带岭区' },
        { id: '3356', name: '乌伊岭区' },
        { id: '3357', name: '红星区' },
        { id: '3358', name: '上甘岭区' },
        { id: '754', name: '铁力市' },
        { id: '755', name: '嘉荫县' }
      ],
      757: [
        { id: '3367', name: '爱民区' },
        { id: '3368', name: '东安区' },
        { id: '3369', name: '阳明区' },
        { id: '3370', name: '西安区' },
        { id: '4148', name: '绥芬河市' },
        { id: '758', name: '海林市' },
        { id: '760', name: '宁安市' },
        { id: '761', name: '穆棱市' },
        { id: '762', name: '林口县' },
        { id: '763', name: '东宁县' }
      ],
      765: [
        { id: '768', name: '桦川县' },
        { id: '769', name: '抚远县' },
        { id: '770', name: '桦南县' },
        { id: '771', name: '汤原县' },
        { id: '33269', name: '前进区' },
        { id: '33270', name: '向阳区' },
        { id: '33271', name: '东风区' },
        { id: '33272', name: '郊区' },
        { id: '766', name: '同江市' },
        { id: '767', name: '富锦市' }
      ],
      799: [
        { id: '3240', name: '玉泉区' },
        { id: '3241', name: '赛罕区' },
        { id: '801', name: '土默特左旗' },
        { id: '802', name: '和林格尔县' },
        { id: '803', name: '武川县' },
        { id: '804', name: '托克托县' },
        { id: '3133', name: '清水河县' },
        { id: '32652', name: '回民区' },
        { id: '32653', name: '新城区' }
      ],
      805: [
        { id: '807', name: '固阳县' },
        { id: '808', name: '土默特右旗' },
        { id: '809', name: '达茂联合旗' },
        { id: '38251', name: '东河区' },
        { id: '38252', name: '九原区' },
        { id: '38253', name: '青山区' },
        { id: '38254', name: '昆都仑区' },
        { id: '3245', name: '石拐区' },
        { id: '3246', name: '白云矿区' }
      ],
      810: [
        { id: '811', name: '海勃湾区' },
        { id: '3248', name: '海南区' },
        { id: '3249', name: '乌达区' }
      ],
      812: [
        { id: '814', name: '宁城县' },
        { id: '815', name: '敖汉旗' },
        { id: '816', name: '喀喇沁旗' },
        { id: '817', name: '翁牛特旗' },
        { id: '818', name: '巴林右旗' },
        { id: '819', name: '林西县' },
        { id: '820', name: '克什克腾旗' },
        { id: '821', name: '巴林左旗' },
        { id: '822', name: '阿鲁科尔沁旗' },
        { id: '3199', name: '元宝山区' },
        { id: '32937', name: '红山区' },
        { id: '3251', name: '松山区' }
      ],
      823: [
        { id: '824', name: '集宁区' },
        { id: '825', name: '丰镇市' },
        { id: '826', name: '兴和县' },
        { id: '827', name: '卓资县' },
        { id: '828', name: '商都县' },
        { id: '829', name: '凉城县' },
        { id: '830', name: '化德县' },
        { id: '831', name: '察哈尔右翼前旗' },
        { id: '832', name: '察哈尔右翼中旗' },
        { id: '833', name: '察哈尔右翼后旗' },
        { id: '834', name: '四子王旗' }
      ],
      835: [
        { id: '836', name: '锡林浩特市' },
        { id: '837', name: '二连浩特市' },
        { id: '838', name: '多伦县' },
        { id: '839', name: '阿巴嘎旗' },
        { id: '840', name: '西乌珠穆沁旗' },
        { id: '841', name: '东乌珠穆沁旗' },
        { id: '842', name: '苏尼特右旗' },
        { id: '843', name: '苏尼特左旗' },
        { id: '844', name: '太仆寺旗' },
        { id: '845', name: '正镶白旗' },
        { id: '846', name: '正蓝旗' },
        { id: '847', name: '镶黄旗' }
      ],
      848: [
        { id: '849', name: '海拉尔区' },
        { id: '850', name: '满洲里市' },
        { id: '851', name: '牙克石市' },
        { id: '852', name: '扎兰屯市' },
        { id: '853', name: '根河市' },
        { id: '854', name: '额尔古纳市' },
        { id: '855', name: '陈巴尔虎旗' },
        { id: '856', name: '阿荣旗' },
        { id: '857', name: '新巴尔虎左旗' },
        { id: '858', name: '新巴尔虎右旗' },
        { id: '859', name: '鄂伦春旗' },
        { id: '860', name: '莫力达瓦旗' },
        { id: '861', name: '鄂温克族旗' }
      ],
      870: [
        { id: '871', name: '东胜区' },
        { id: '872', name: '准格尔旗' },
        { id: '874', name: '伊金霍洛旗' },
        { id: '875', name: '乌审旗' },
        { id: '876', name: '杭锦旗' },
        { id: '877', name: '鄂托克旗' },
        { id: '878', name: '鄂托克前旗' },
        { id: '879', name: '达拉特旗' },
        { id: '18374', name: '康巴什新区' }
      ],
      880: [
        { id: '881', name: '临河区' },
        { id: '882', name: '五原县' },
        { id: '883', name: '磴口县' },
        { id: '884', name: '杭锦后旗' },
        { id: '885', name: '乌拉特中旗' },
        { id: '888', name: '乌拉特后旗 ' },
        { id: '890', name: '乌拉特前旗' }
      ],
      891: [
        { id: '892', name: '阿拉善右旗' },
        { id: '893', name: '阿拉善左旗' },
        { id: '894', name: '额济纳旗' }
      ],
      895: [
        { id: '896', name: '乌兰浩特市' },
        { id: '897', name: '阿尔山市' },
        { id: '898', name: '突泉县' },
        { id: '899', name: '扎赉特旗' },
        { id: '900', name: '科尔沁右翼前旗' },
        { id: '901', name: '科尔沁右翼中旗' }
      ],
      902: [
        { id: '32769', name: '科尔沁区' },
        { id: '3142', name: '霍林郭勒市' },
        { id: '3252', name: '开鲁县' },
        { id: '3253', name: '库伦旗' },
        { id: '3254', name: '奈曼旗' },
        { id: '3255', name: '扎鲁特旗' },
        { id: '3256', name: '科尔沁左翼中旗' },
        { id: '3258', name: '科尔沁左翼后旗' }
      ],
      904: [
        { id: '3373', name: '玄武区' },
        { id: '3375', name: '秦淮区' },
        { id: '3376', name: '建邺区' },
        { id: '3377', name: '鼓楼区' },
        { id: '3378', name: '栖霞区' },
        { id: '905', name: '江宁区' },
        { id: '908', name: '六合区' },
        { id: '3379', name: '雨花台区' },
        { id: '907', name: '高淳区' },
        { id: '3024', name: '溧水区' },
        { id: '50647', name: '浦口区' }
      ],
      911: [
        { id: '3388', name: '贾汪区' },
        { id: '4223', name: '金山桥开发区' },
        { id: '4224', name: '铜山经济技术开发区' },
        { id: '4228', name: '八段工业园区' },
        { id: '23686', name: '鼓楼区' },
        { id: '23687', name: '邳州市' },
        { id: '23688', name: '泉山区' },
        { id: '23689', name: '新沂市' },
        { id: '23690', name: '云龙区' },
        { id: '914', name: '铜山区' },
        { id: '915', name: '睢宁县' },
        { id: '916', name: '沛县' },
        { id: '917', name: '丰县' }
      ],
      919: [
        { id: '23684', name: '海州区' },
        { id: '920', name: '赣榆区' },
        { id: '4248', name: '连云区' },
        { id: '921', name: '灌云县' },
        { id: '922', name: '东海县' },
        { id: '923', name: '灌南县' }
      ],
      925: [
        { id: '4305', name: '经济开发区' },
        { id: '926', name: '楚州区' },
        { id: '929', name: '洪泽县' },
        { id: '930', name: '金湖县' },
        { id: '931', name: '盱眙县' },
        { id: '36560', name: '清河区' },
        { id: '36561', name: '淮阴区' },
        { id: '36562', name: '清浦区' },
        { id: '36563', name: '涟水县' }
      ],
      933: [
        { id: '3407', name: '宿城区' },
        { id: '8558', name: '沭阳县' },
        { id: '8559', name: '泗阳县' },
        { id: '934', name: '宿豫区' },
        { id: '937', name: '泗洪县' },
        { id: '40649', name: '宿迁经济开发区' }
      ],
      939: [
        { id: '23681', name: '射阳县' },
        { id: '23682', name: '亭湖区' },
        { id: '23683', name: '盐都区' },
        { id: '940', name: '东台市' },
        { id: '941', name: '大丰区' },
        { id: '945', name: '建湖县' },
        { id: '946', name: '响水县' },
        { id: '948', name: '阜宁县' },
        { id: '949', name: '滨海县' }
      ],
      951: [
        { id: '955', name: '广陵区' },
        { id: '956', name: '邗江区' },
        { id: '957', name: '宝应县' },
        { id: '42218', name: '仪征市' },
        { id: '42219', name: '高邮市' },
        { id: '42220', name: '江都区' }
      ],
      959: [
        { id: '3406', name: '海陵区' },
        { id: '3405', name: '高港区' },
        { id: '960', name: '泰兴市' },
        { id: '962', name: '靖江市' },
        { id: '963', name: '兴化市' },
        { id: '40174', name: '姜堰区' }
      ],
      965: [
        { id: '3394', name: '港闸区' },
        { id: '3395', name: '崇川区' },
        { id: '967', name: '通州区' },
        { id: '4385', name: '南通经济技术开发区' },
        { id: '970', name: '如东县' },
        { id: '2774', name: '海安县' },
        { id: '38364', name: '如皋市' },
        { id: '38365', name: '海门市' },
        { id: '38366', name: '启东市' }
      ],
      972: [
        { id: '3403', name: '润州区' },
        { id: '3404', name: '京口区' },
        { id: '976', name: '丹徒区' },
        { id: '4916', name: '镇江新区' },
        { id: '38517', name: '丹阳市' },
        { id: '38518', name: '句容市' },
        { id: '973', name: '扬中市' },
        { id: '51180', name: '丹徒新区' }
      ],
      978: [
        { id: '3392', name: '钟楼区' },
        { id: '3393', name: '天宁区' },
        { id: '4459', name: '武进区' },
        { id: '2927', name: '新北区' },
        { id: '980', name: '金坛区' },
        { id: '981', name: '溧阳市' }
      ],
      984: [
        { id: '3381', name: '崇安区' },
        { id: '3382', name: '南长区' },
        { id: '3383', name: '北塘区' },
        { id: '3384', name: '锡山区' },
        { id: '3385', name: '惠山区' },
        { id: '4029', name: '新区' },
        { id: '13989', name: '江阴市' },
        { id: '15943', name: '宜兴市' },
        { id: '40035', name: '滨湖区' },
        { id: '53561', name: '新吴区' },
        { id: '53562', name: '梁溪区' }
      ],
      988: [
        { id: '993', name: '常熟市' },
        { id: '994', name: '张家港市' },
        { id: '4346', name: '太仓市' },
        { id: '3082', name: '相城区' },
        { id: '3083', name: '金阊区' },
        { id: '3085', name: '虎丘区' },
        { id: '3087', name: '平江区' },
        { id: '3088', name: '沧浪区' },
        { id: '3444', name: '工业园区' },
        { id: '3742', name: '高新区' },
        { id: '39628', name: '吴江区' },
        { id: '40034', name: '吴中区' },
        { id: '53563', name: '姑苏区' },
        { id: '47821', name: '昆山市' }
      ],
      1025: [
        { id: '1026', name: '河口区' },
        { id: '1027', name: '广饶县' },
        { id: '1028', name: '利津县' },
        { id: '1029', name: '垦利区' },
        { id: '36884', name: '东营区' }
      ],
      1032: [
        { id: '28921', name: '潍城区' },
        { id: '28922', name: '奎文区' },
        { id: '28923', name: '高新区' },
        { id: '28924', name: '寒亭区' },
        { id: '28925', name: '寿光市' },
        { id: '1033', name: '青州市' },
        { id: '1034', name: '诸城市' },
        { id: '1036', name: '安丘市' },
        { id: '1037', name: '高密市' },
        { id: '1038', name: '昌邑市' },
        { id: '1039', name: '昌乐县' },
        { id: '1041', name: '临朐县' },
        { id: '3530', name: '坊子区' }
      ],
      1042: [
        { id: '3528', name: '莱山区' },
        { id: '3126', name: '芝罘区' },
        { id: '51029', name: '开发区' },
        { id: '46504', name: '福山区' },
        { id: '46505', name: '牟平区' },
        { id: '46506', name: '龙口市' },
        { id: '46507', name: '莱州市' },
        { id: '1044', name: '莱阳市' },
        { id: '1047', name: '招远市' },
        { id: '1048', name: '蓬莱市' },
        { id: '1049', name: '栖霞市' },
        { id: '1050', name: '海阳市' },
        { id: '1051', name: '长岛县' }
      ],
      1053: [
        { id: '28928', name: '荣成市' },
        { id: '28929', name: '文登市' },
        { id: '1054', name: '乳山市' },
        { id: '28926', name: '环翠区' }
      ],
      1058: [
        { id: '1059', name: '莱城区' },
        { id: '3539', name: '钢城区' }
      ],
      1060: [
        { id: '3542', name: '德城区' },
        { id: '1069', name: '临邑县' },
        { id: '25879', name: '齐河县' },
        { id: '1061', name: '乐陵市' },
        { id: '1062', name: '禹城市' },
        { id: '1063', name: '陵县' },
        { id: '1064', name: '宁津县' },
        { id: '1066', name: '武城县' },
        { id: '1067', name: '庆云县' },
        { id: '1068', name: '平原县' },
        { id: '1071', name: '夏津县' }
      ],
      1072: [
        { id: '52023', name: '兰陵县' },
        { id: '28930', name: '兰山区' },
        { id: '28931', name: '河东区' },
        { id: '1073', name: '沂南县' },
        { id: '1074', name: '沂水县' },
        { id: '1076', name: '费县' },
        { id: '1077', name: '平邑县' },
        { id: '1078', name: '蒙阴县' },
        { id: '1079', name: '临沭县' },
        { id: '2926', name: '莒南县' },
        { id: '2974', name: '郯城县' },
        { id: '3540', name: '罗庄区' }
      ],
      1081: [
        { id: '25880', name: '东昌府区' },
        { id: '1082', name: '临清市' },
        { id: '1084', name: '阳谷县' },
        { id: '1085', name: '茌平县' },
        { id: '1086', name: '莘县' },
        { id: '1087', name: '东阿县' },
        { id: '1088', name: '冠县' },
        { id: '4043', name: '高唐县' }
      ],
      1090: [
        { id: '25877', name: '北海新区' },
        { id: '25878', name: '滨城区' },
        { id: '1092', name: '邹平县' },
        { id: '1093', name: '沾化县' },
        { id: '1094', name: '惠民县' },
        { id: '1095', name: '博兴县' },
        { id: '1096', name: '阳信县' },
        { id: '2772', name: '无棣县' }
      ],
      1099: [
        { id: '3543', name: '牡丹区' },
        { id: '1101', name: '单县' },
        { id: '1102', name: '曹县' },
        { id: '1103', name: '定陶县' },
        { id: '1104', name: '巨野县' },
        { id: '1105', name: '成武县' },
        { id: '1106', name: '东明县' },
        { id: '1107', name: '郓城县' },
        { id: '2773', name: '鄄城县' }
      ],
      1108: [
        { id: '4113', name: '岚山区' },
        { id: '4196', name: '新市区' },
        { id: '2934', name: '五莲县' },
        { id: '28920', name: '东港区' },
        { id: '3068', name: '莒县' }
      ],
      2900: [
        { id: '2908', name: '梁山县' },
        { id: '2910', name: '兖州市' },
        { id: '2912', name: '微山县' },
        { id: '2913', name: '汶上县' },
        { id: '2914', name: '泗水县' },
        { id: '2915', name: '嘉祥县' },
        { id: '2916', name: '鱼台县' },
        { id: '2917', name: '金乡县' },
        { id: '25713', name: '邹城市' },
        { id: '25714', name: '市中区' },
        { id: '25715', name: '曲阜市' },
        { id: '25728', name: '高新区' },
        { id: '3533', name: '任城区' }
      ],
      1112: [
        { id: '3132', name: '东平县' },
        { id: '46665', name: '岱岳区' },
        { id: '46666', name: '泰山区' },
        { id: '46667', name: '肥城市' },
        { id: '46668', name: '新泰市' },
        { id: '3535', name: '宁阳县' }
      ],
      1000: [
        { id: '4277', name: '高新区' },
        { id: '1002', name: '长清区' },
        { id: '40488', name: '历城区' },
        { id: '40489', name: '天桥区' },
        { id: '40490', name: '槐荫区' },
        { id: '40491', name: '历下区' },
        { id: '40492', name: '市中区' },
        { id: '40493', name: '章丘市' },
        { id: '1003', name: '平阴县' },
        { id: '1004', name: '济阳县' },
        { id: '1005', name: '商河县' }
      ],
      1007: [
        { id: '3519', name: '四方区' },
        { id: '3520', name: '市北区' },
        { id: '3521', name: '市南区' },
        { id: '5505', name: '黄岛区' },
        { id: '4909', name: '李沧区' },
        { id: '37916', name: '即墨市' },
        { id: '37917', name: '城阳区' },
        { id: '37918', name: '崂山区' },
        { id: '37919', name: '胶州市' },
        { id: '37920', name: '平度市' },
        { id: '1014', name: '莱西市' }
      ],
      1016: [
        { id: '2969', name: '临淄区' },
        { id: '47166', name: '张店区' },
        { id: '2924', name: '周村区' },
        { id: '2962', name: '淄川区' },
        { id: '2968', name: '博山区' },
        { id: '1019', name: '高青县' },
        { id: '1020', name: '沂源县' },
        { id: '1021', name: '桓台县' }
      ],
      1022: [
        { id: '28932', name: '滕州市' },
        { id: '3522', name: '山亭区' },
        { id: '3523', name: '台儿庄区' },
        { id: '3524', name: '峄城区' },
        { id: '3525', name: '薛城区' },
        { id: '3526', name: '市中区' }
      ],
      1114: [
        { id: '52830', name: '铜官区' },
        { id: '52832', name: '枞阳县' },
        { id: '19784', name: '郊区' },
        { id: '19786', name: '义安区' }
      ],
      1116: [
        { id: '3431', name: '包河区' },
        { id: '3432', name: '蜀山区' },
        { id: '3433', name: '瑶海区' },
        { id: '3434', name: '庐阳区' },
        { id: '6118', name: '滨湖新区' },
        { id: '4173', name: '经济技术开发区' },
        { id: '4192', name: '高新技术开发区' },
        { id: '6120', name: '新站综合开发试验区' },
        { id: '36173', name: '肥西县' },
        { id: '6119', name: '政务文化新区' },
        { id: '49709', name: '巢湖市' },
        { id: '49710', name: '长丰县' },
        { id: '1119', name: '肥东县' },
        { id: '1190', name: '庐江县' },
        { id: '6117', name: '北城新区' }
      ],
      1121: [
        { id: '4960', name: '淮南高新技术开发区' },
        { id: '3447', name: '田家庵区' },
        { id: '3448', name: '大通区' },
        { id: '3449', name: '谢家集区' },
        { id: '3450', name: '八公山区' },
        { id: '52831', name: '寿县' },
        { id: '1122', name: '凤台县' },
        { id: '3451', name: '潘集区' }
      ],
      1124: [
        { id: '19223', name: '杜集区' },
        { id: '19224', name: '烈山区' },
        { id: '19225', name: '濉溪县' },
        { id: '19226', name: '相山区' }
      ],
      1127: [
        { id: '3438', name: '镜湖区' },
        { id: '4172', name: '弋江区' },
        { id: '1189', name: '无为县' },
        { id: '1128', name: '芜湖县' },
        { id: '1129', name: '繁昌县' },
        { id: '1130', name: '南陵县' },
        { id: '49137', name: '鸠江区' },
        { id: '49138', name: '三山区' }
      ],
      1132: [
        { id: '3442', name: '蚌山区' },
        { id: '1133', name: '怀远县' },
        { id: '1134', name: '固镇县' },
        { id: '1135', name: '五河县' },
        { id: '18549', name: '淮上区' },
        { id: '18550', name: '龙子湖区' },
        { id: '18551', name: '禹会区' }
      ],
      1137: [
        { id: '6963', name: '博望区' },
        { id: '49253', name: '花山区' },
        { id: '49254', name: '雨山区' },
        { id: '1138', name: '当涂县' },
        { id: '1187', name: '含山县' },
        { id: '1188', name: '和县' }
      ],
      1140: [
        { id: '1141', name: '桐城市' },
        { id: '1142', name: '宿松县' },
        { id: '1144', name: '太湖县' },
        { id: '1145', name: '怀宁县' },
        { id: '1146', name: '岳西县' },
        { id: '1147', name: '望江县' },
        { id: '1148', name: '潜山县' },
        { id: '18375', name: '大观区' },
        { id: '18376', name: '宜秀区' },
        { id: '18377', name: '迎江区' }
      ],
      1151: [
        { id: '19227', name: '徽州区' },
        { id: '19228', name: '屯溪区' },
        { id: '1153', name: '休宁县' },
        { id: '1154', name: '歙县' },
        { id: '1155', name: '黟县' },
        { id: '1156', name: '祁门县' },
        { id: '3464', name: '黄山区' }
      ],
      1159: [
        { id: '18715', name: '琅琊区' },
        { id: '18716', name: '天长市' },
        { id: '1161', name: '明光市' },
        { id: '1162', name: '全椒县' },
        { id: '1163', name: '来安县' },
        { id: '3467', name: '南谯区' },
        { id: '1164', name: '定远县' },
        { id: '1165', name: '凤阳县' }
      ],
      1167: [
        { id: '4832', name: '经济开发区' },
        { id: '1168', name: '界首市' },
        { id: '1169', name: '太和县' },
        { id: '1170', name: '阜南县' },
        { id: '1171', name: '颍上县' },
        { id: '1172', name: '临泉县' },
        { id: '19158', name: '颍泉区' },
        { id: '19159', name: '颍州区' },
        { id: '19160', name: '颍东区' }
      ],
      1174: [
        { id: '1176', name: '利辛县' },
        { id: '1177', name: '蒙城县' },
        { id: '1178', name: '涡阳县' },
        { id: '18627', name: '谯城区' }
      ],
      2971: [
        { id: '3128', name: '旌德县' },
        { id: '3147', name: '宁国市' },
        { id: '3477', name: '郎溪县' },
        { id: '3478', name: '广德县' },
        { id: '3479', name: '绩溪县' },
        { id: '2972', name: '泾县' },
        { id: '19684', name: '宣州区' }
      ],
      1180: [
        { id: '6006', name: '经济开发区' },
        { id: '19575', name: '埇桥区' },
        { id: '1181', name: '灵璧县' },
        { id: '1182', name: '泗县' },
        { id: '1183', name: '萧县' },
        { id: '1184', name: '砀山县' }
      ],
      1201: [
        { id: '18714', name: '贵池区' },
        { id: '1202', name: '东至县' },
        { id: '1203', name: '石台县' },
        { id: '1204', name: '青阳县' }
      ],
      1206: [
        { id: '1208', name: '霍山县' },
        { id: '1209', name: '金寨县' },
        { id: '1210', name: '霍邱县' },
        { id: '1211', name: '舒城县' },
        { id: '18912', name: '金安区' },
        { id: '18913', name: '裕安区' }
      ],
      1280: [
        { id: '1281', name: '龙泉市' },
        { id: '1282', name: '缙云县' },
        { id: '1283', name: '遂昌县' },
        { id: '1284', name: '松阳县' },
        { id: '1285', name: '景宁县' },
        { id: '1286', name: '云和县' },
        { id: '1288', name: '青田县' },
        { id: '22043', name: '莲都区' },
        { id: '3045', name: '庆元县' }
      ],
      1290: [
        { id: '1291', name: '临海市' },
        { id: '1294', name: '三门县' },
        { id: '1295', name: '天台县' },
        { id: '1296', name: '仙居县' },
        { id: '22046', name: '黄岩区' },
        { id: '22047', name: '椒江区' },
        { id: '22048', name: '路桥区' },
        { id: '22049', name: '温岭市' },
        { id: '22050', name: '玉环县' }
      ],
      1298: [
        { id: '1300', name: '岱山县' },
        { id: '1301', name: '嵊泗县' },
        { id: '42565', name: '普陀区' },
        { id: '42566', name: '定海区' }
      ],
      1158: [
        { id: '3412', name: '海曙区' },
        { id: '3413', name: '江东区' },
        { id: '4253', name: '高新科技开发区' },
        { id: '1224', name: '慈溪市' },
        { id: '46341', name: '北仑区' },
        { id: '46342', name: '镇海区' },
        { id: '46343', name: '鄞州区' },
        { id: '46344', name: '江北区' },
        { id: '46345', name: '余姚市' },
        { id: '1226', name: '奉化市' },
        { id: '1227', name: '宁海县' },
        { id: '1228', name: '象山县' }
      ],
      1213: [
        { id: '3408', name: '上城区' },
        { id: '3409', name: '下城区' },
        { id: '3410', name: '拱墅区' },
        { id: '3411', name: '西湖区' },
        { id: '2963', name: '江干区' },
        { id: '4285', name: '下沙区' },
        { id: '1214', name: '余杭区' },
        { id: '1215', name: '萧山区' },
        { id: '3038', name: '滨江区' },
        { id: '49711', name: '临安市' },
        { id: '1217', name: '富阳区' },
        { id: '1218', name: '桐庐县' },
        { id: '1219', name: '建德市' },
        { id: '1220', name: '淳安县' }
      ],
      1233: [
        { id: '3416', name: '龙湾区' },
        { id: '4342', name: '茶山高教园区' },
        { id: '42321', name: '瑞安市' },
        { id: '42322', name: '乐清市' },
        { id: '42323', name: '鹿城区' },
        { id: '42324', name: '瓯海区' },
        { id: '42325', name: '永嘉县' },
        { id: '1237', name: '文成县' },
        { id: '1238', name: '平阳县' },
        { id: '1239', name: '泰顺县' },
        { id: '1240', name: '洞头区' },
        { id: '1241', name: '苍南县' }
      ],
      1243: [
        { id: '4429', name: '桐乡市' },
        { id: '4430', name: '平湖市' },
        { id: '4431', name: '嘉善县' },
        { id: '3418', name: '南湖区' },
        { id: '3419', name: '秀洲区' },
        { id: '1244', name: '海宁市' },
        { id: '1248', name: '海盐县' }
      ],
      1250: [
        { id: '4130', name: '南浔区' },
        { id: '44189', name: '吴兴区' },
        { id: '1251', name: '长兴县' },
        { id: '1252', name: '德清县' },
        { id: '1253', name: '安吉县' }
      ],
      1255: [
        { id: '15944', name: '柯桥区' },
        { id: '44188', name: '越城区' },
        { id: '1257', name: '诸暨市' },
        { id: '1258', name: '上虞区' },
        { id: '1259', name: '嵊州市' },
        { id: '1260', name: '新昌县' }
      ],
      1262: [
        { id: '1263', name: '金东区' },
        { id: '1265', name: '婺城区' },
        { id: '1264', name: '兰溪市' },
        { id: '1269', name: '武义县' },
        { id: '1270', name: '浦江县' },
        { id: '1271', name: '磐安县' },
        { id: '1266', name: '义乌市' },
        { id: '1268', name: '永康市' },
        { id: '1267', name: '东阳市' }
      ],
      1273: [
        { id: '22044', name: '柯城区' },
        { id: '22045', name: '衢江区' },
        { id: '1275', name: '江山市' },
        { id: '1276', name: '常山县' },
        { id: '1277', name: '开化县' },
        { id: '1278', name: '龙游县' }
      ],
      1303: [
        { id: '3483', name: '台江区' },
        { id: '3484', name: '鼓楼区' },
        { id: '48712', name: '晋安区' },
        { id: '48713', name: '仓山区' },
        { id: '48714', name: '马尾区' },
        { id: '48715', name: '福清市' },
        { id: '48716', name: '闽侯县' },
        { id: '1305', name: '长乐市' },
        { id: '1308', name: '平潭县' },
        { id: '1309', name: '连江县' },
        { id: '1312', name: '罗源县' },
        { id: '1313', name: '永泰县' },
        { id: '1314', name: '闽清县' }
      ],
      1315: [
        { id: '1316', name: '思明区' },
        { id: '3486', name: '湖里区' },
        { id: '3489', name: '翔安区' },
        { id: '46763', name: '海沧区' },
        { id: '46764', name: '集美区' },
        { id: '46765', name: '同安区' }
      ],
      1317: [
        { id: '1319', name: '永安市' },
        { id: '1320', name: '明溪县' },
        { id: '1321', name: '将乐县' },
        { id: '1322', name: '大田县' },
        { id: '1323', name: '宁化县' },
        { id: '1324', name: '建宁县' },
        { id: '1325', name: '沙县' },
        { id: '1326', name: '尤溪县' },
        { id: '1327', name: '清流县' },
        { id: '1328', name: '泰宁县' },
        { id: '22463', name: '梅列区' },
        { id: '22464', name: '三元区' }
      ],
      1329: [
        { id: '1331', name: '仙游县' },
        { id: '46146', name: '城厢区' },
        { id: '46147', name: '荔城区' },
        { id: '3492', name: '秀屿区' },
        { id: '3022', name: '涵江区' }
      ],
      1332: [
        { id: '3117', name: '泉港区' },
        { id: '1334', name: '石狮市' },
        { id: '1336', name: '南安市' },
        { id: '1337', name: '惠安县' },
        { id: '1338', name: '安溪县' },
        { id: '1339', name: '德化县' },
        { id: '1340', name: '永春县' },
        { id: '3495', name: '金门县' },
        { id: '3498', name: '洛江区' },
        { id: '42930', name: '鲤城区' },
        { id: '42931', name: '丰泽区' },
        { id: '42932', name: '晋江市' }
      ],
      1341: [
        { id: '3499', name: '芗城区' },
        { id: '3500', name: '龙文区' },
        { id: '1343', name: '龙海市' },
        { id: '1344', name: '平和县' },
        { id: '1345', name: '南靖县' },
        { id: '1346', name: '诏安县' },
        { id: '1347', name: '漳浦县' },
        { id: '1348', name: '华安县' },
        { id: '1349', name: '云霄县' },
        { id: '1350', name: '东山县' },
        { id: '1351', name: '长泰县' }
      ],
      1352: [
        { id: '1354', name: '建瓯市' },
        { id: '1355', name: '邵武市' },
        { id: '1356', name: '武夷山市' },
        { id: '1357', name: '建阳市' },
        { id: '1358', name: '松溪县' },
        { id: '1359', name: '顺昌县' },
        { id: '1360', name: '浦城县' },
        { id: '1361', name: '政和县' },
        { id: '2956', name: '光泽县' },
        { id: '22465', name: '延平区' }
      ],
      1362: [
        { id: '44319', name: '新罗区' },
        { id: '1364', name: '漳平市' },
        { id: '1365', name: '长汀县' },
        { id: '1366', name: '武平县' },
        { id: '1367', name: '永定县' },
        { id: '1368', name: '上杭县' },
        { id: '1369', name: '连城县' }
      ],
      1370: [
        { id: '46145', name: '蕉城区' },
        { id: '46164', name: '东侨开发区' },
        { id: '1372', name: '福安市' },
        { id: '1373', name: '福鼎市' },
        { id: '1374', name: '寿宁县' },
        { id: '1375', name: '霞浦县' },
        { id: '1376', name: '柘荣县' },
        { id: '1377', name: '屏南县' },
        { id: '1378', name: '古田县' },
        { id: '1379', name: '周宁县' }
      ],
      3154: [
        { id: '23610', name: '松柏镇' },
        { id: '23611', name: '阳日镇' },
        { id: '23612', name: '木鱼镇' },
        { id: '23613', name: '红坪镇' },
        { id: '23614', name: '新华镇' },
        { id: '23615', name: '宋洛乡' },
        { id: '23616', name: '九湖乡' },
        { id: '23617', name: '下谷坪乡' }
      ],
      1381: [
        { id: '3583', name: '硚口区' },
        { id: '3079', name: '武昌区' },
        { id: '4424', name: '武汉经济技术开发区' },
        { id: '1386', name: '江岸区' },
        { id: '3582', name: '江汉区' },
        { id: '50712', name: '蔡甸区' },
        { id: '50713', name: '江夏区' },
        { id: '50714', name: '新洲区' },
        { id: '50715', name: '黄陂区' },
        { id: '50716', name: '汉阳区' },
        { id: '50717', name: '青山区' },
        { id: '50718', name: '洪山区' },
        { id: '50719', name: '汉南区' },
        { id: '50720', name: '东西湖区' }
      ],
      2922: [
        { id: '23585', name: '园林' },
        { id: '23586', name: '杨市' },
        { id: '23587', name: '周矶' },
        { id: '23588', name: '广华' },
        { id: '23589', name: '泰丰' },
        { id: '23590', name: '竹根滩镇' },
        { id: '23591', name: '高石碑镇' },
        { id: '23592', name: '积玉口镇' },
        { id: '23593', name: '渔洋镇' },
        { id: '23594', name: '王场镇' },
        { id: '23595', name: '熊口镇' },
        { id: '23596', name: '老新镇' },
        { id: '23597', name: '浩口镇' },
        { id: '23598', name: '张金镇' },
        { id: '23599', name: '龙湾镇' },
        { id: '23600', name: '江汉石油管理局' },
        { id: '23601', name: '潜江经济开发区' },
        { id: '23602', name: '西大垸管理区' },
        { id: '23603', name: '运粮湖管理区' },
        { id: '23604', name: '周矶管理区' },
        { id: '23605', name: '后湖管理区' },
        { id: '23606', name: '熊口管理区' },
        { id: '23607', name: '总口管理区' },
        { id: '23608', name: '高场原种场' },
        { id: '23609', name: '浩口原种场' }
      ],
      1387: [
        { id: '1389', name: '黄石港区' },
        { id: '43272', name: '下陆区' },
        { id: '43273', name: '西塞山区' },
        { id: '1392', name: '铁山区' },
        { id: '1393', name: '大冶市' },
        { id: '1394', name: '阳新县' },
        { id: '43291', name: '经济技术开发区' }
      ],
      1396: [
        { id: '1397', name: '老河口市' },
        { id: '1398', name: '枣阳市' },
        { id: '1399', name: '宜城市' },
        { id: '1401', name: '南漳县' },
        { id: '1402', name: '保康县' },
        { id: '1403', name: '谷城县' },
        { id: '23282', name: '樊城区' },
        { id: '23283', name: '襄城区' },
        { id: '23284', name: '襄州区' }
      ],
      1405: [
        { id: '1406', name: '丹江口市' },
        { id: '1407', name: '房县' },
        { id: '1408', name: '竹山县' },
        { id: '1409', name: '竹溪县' },
        { id: '1410', name: '郧县' },
        { id: '1411', name: '郧西县' },
        { id: '23429', name: '茅箭区' },
        { id: '23430', name: '张湾区' }
      ],
      1413: [
        { id: '3593', name: '沙市区' },
        { id: '4078', name: '荆州区' },
        { id: '1414', name: '江陵县' },
        { id: '1415', name: '洪湖市' },
        { id: '1416', name: '石首市' },
        { id: '1417', name: '松滋市' },
        { id: '1418', name: '监利县' },
        { id: '1419', name: '公安县' }
      ],
      1421: [
        { id: '3597', name: '伍家岗区' },
        { id: '3598', name: '西陵区' },
        { id: '3594', name: '宜都市' },
        { id: '3595', name: '猇亭区' },
        { id: '3596', name: '点军区' },
        { id: '1423', name: '当阳市' },
        { id: '1424', name: '枝江市' },
        { id: '1425', name: '夷陵区' },
        { id: '1426', name: '秭归县' },
        { id: '1427', name: '兴山县' },
        { id: '1428', name: '远安县' },
        { id: '1429', name: '五峰土家族自治县' },
        { id: '1430', name: '长阳土家族自治县' }
      ],
      1432: [
        { id: '1435', name: '汉川市' },
        { id: '1437', name: '云梦县' },
        { id: '1438', name: '大悟县' },
        { id: '1439', name: '孝昌县' },
        { id: '45215', name: '孝南区' },
        { id: '45216', name: '应城市' },
        { id: '45217', name: '安陆市' }
      ],
      1441: [
        { id: '41908', name: '黄州区' },
        { id: '41909', name: '蕲春县' },
        { id: '41910', name: '麻城市' },
        { id: '41911', name: '武穴市' },
        { id: '41912', name: '浠水县' },
        { id: '1444', name: '红安县' },
        { id: '1445', name: '罗田县' },
        { id: '1447', name: '黄梅县' },
        { id: '1448', name: '英山县' },
        { id: '1449', name: '团风县' }
      ],
      2980: [
        { id: '23618', name: '侨乡街道开发区' },
        { id: '23619', name: '竟陵街道' },
        { id: '23620', name: '杨林街道' },
        { id: '23621', name: '佛子山镇' },
        { id: '23622', name: '多宝镇' },
        { id: '23623', name: '拖市镇' },
        { id: '23624', name: '张港镇' },
        { id: '23625', name: '蒋场镇' },
        { id: '23626', name: '汪场镇' },
        { id: '23627', name: '渔薪镇' },
        { id: '23628', name: '黄潭镇' },
        { id: '23629', name: '岳口镇' },
        { id: '23630', name: '横林镇' },
        { id: '23631', name: '彭市镇' },
        { id: '23632', name: '麻洋镇' },
        { id: '23633', name: '多祥镇' },
        { id: '23634', name: '干驿镇' },
        { id: '23635', name: '马湾镇' },
        { id: '23636', name: '卢市镇' },
        { id: '23637', name: '小板镇' },
        { id: '23638', name: '九真镇' },
        { id: '23639', name: '皂市镇' },
        { id: '23640', name: '胡市镇' },
        { id: '23641', name: '石河镇' },
        { id: '23642', name: '净潭乡' },
        { id: '23643', name: '蒋湖农场' },
        { id: '23644', name: '白茅湖农场' },
        { id: '23645', name: '沉湖管委会' }
      ],
      2983: [
        { id: '52306', name: '城区' },
        { id: '23649', name: '郑场镇' },
        { id: '23650', name: '毛嘴镇' },
        { id: '23651', name: '豆河镇' },
        { id: '23652', name: '三伏潭镇' },
        { id: '23653', name: '胡场镇' },
        { id: '23654', name: '长埫口镇' },
        { id: '23655', name: '西流河镇' },
        { id: '23656', name: '沙湖镇' },
        { id: '23657', name: '杨林尾镇' },
        { id: '23658', name: '彭场镇' },
        { id: '23659', name: '张沟镇' },
        { id: '23660', name: '郭河镇' },
        { id: '23661', name: '沔城镇' },
        { id: '23662', name: '通海口镇' },
        { id: '23663', name: '陈场镇' },
        { id: '23664', name: '工业园区' },
        { id: '23665', name: '九合垸原种场' },
        { id: '23666', name: '沙湖原种场' },
        { id: '23667', name: '排湖渔场' },
        { id: '23668', name: '五湖渔场' },
        { id: '23669', name: '赵西垸林场' },
        { id: '23670', name: '刘家垸林场' },
        { id: '23671', name: '畜禽良种场' }
      ],
      1458: [
        { id: '43387', name: '咸安区' },
        { id: '43388', name: '赤壁市' },
        { id: '1461', name: '嘉鱼县' },
        { id: '1462', name: '通山县' },
        { id: '1463', name: '崇阳县' },
        { id: '1464', name: '通城县' }
      ],
      1466: [
        { id: '1467', name: '恩施市' },
        { id: '1468', name: '利川市' },
        { id: '1469', name: '建始县' },
        { id: '1470', name: '来凤县' },
        { id: '1471', name: '巴东县' },
        { id: '1472', name: '鹤峰县' },
        { id: '1473', name: '宣恩县' },
        { id: '1474', name: '咸丰县' }
      ],
      1475: [
        { id: '3601', name: '梁子湖区' },
        { id: '3602', name: '华容区' },
        { id: '41907', name: '鄂城区' }
      ],
      1477: [
        { id: '3600', name: '东宝区' },
        { id: '3599', name: '掇刀区' },
        { id: '2973', name: '钟祥市' },
        { id: '1478', name: '京山县' },
        { id: '3055', name: '沙洋县' }
      ],
      1479: [
        { id: '3164', name: '曾都区' },
        { id: '3163', name: '广水市' },
        { id: '7357', name: '随县' }
      ],
      1540: [
        { id: '1541', name: '慈利县' },
        { id: '1542', name: '桑植县' },
        { id: '1543', name: '武陵源区' },
        { id: '3622', name: '永定区' }
      ],
      1544: [
        { id: '1545', name: '资兴市' },
        { id: '1546', name: '宜章县' },
        { id: '1547', name: '安仁县' },
        { id: '1548', name: '汝城县' },
        { id: '1549', name: '嘉禾县' },
        { id: '1550', name: '临武县' },
        { id: '1551', name: '桂东县' },
        { id: '1552', name: '永兴县' },
        { id: '1553', name: '桂阳县' },
        { id: '29465', name: '北湖区' },
        { id: '29466', name: '苏仙区' }
      ],
      1555: [
        { id: '1556', name: '南县' },
        { id: '1557', name: '桃江县' },
        { id: '1558', name: '安化县' },
        { id: '29463', name: '赫山区' },
        { id: '29464', name: '资阳区' },
        { id: '1565', name: '沅江市' }
      ],
      1560: [
        { id: '29454', name: '冷水滩区' },
        { id: '1563', name: '祁阳县' },
        { id: '1564', name: '双牌县' },
        { id: '1566', name: '道县' },
        { id: '1567', name: '江永县' },
        { id: '1568', name: '江华县' },
        { id: '1569', name: '宁远县' },
        { id: '1570', name: '新田县' },
        { id: '1571', name: '蓝山县' },
        { id: '1572', name: '东安县' },
        { id: '1573', name: '零陵区' }
      ],
      1574: [
        { id: '29455', name: '鹤城区' },
        { id: '1575', name: '洪江市' },
        { id: '1576', name: '会同县' },
        { id: '1578', name: '溆浦县' },
        { id: '3626', name: '中方县' },
        { id: '1579', name: '辰溪县' },
        { id: '1580', name: '靖州县' },
        { id: '1581', name: '通道县' },
        { id: '1582', name: '芷江县' },
        { id: '1583', name: '新晃县' },
        { id: '1584', name: '麻阳县' },
        { id: '3070', name: '沅陵县' }
      ],
      1586: [
        { id: '29456', name: '娄星区' },
        { id: '1588', name: '冷水江市' },
        { id: '1589', name: '涟源市' },
        { id: '1590', name: '新化县' },
        { id: '1591', name: '双峰县' }
      ],
      1592: [
        { id: '1593', name: '吉首市' },
        { id: '1594', name: '古丈县' },
        { id: '1595', name: '龙山县' },
        { id: '1596', name: '永顺县' },
        { id: '1597', name: '泸溪县' },
        { id: '1598', name: '凤凰县' },
        { id: '1599', name: '花垣县' },
        { id: '1600', name: '保靖县' }
      ],
      1482: [
        { id: '3606', name: '芙蓉区' },
        { id: '48936', name: '岳麓区' },
        { id: '48937', name: '雨花区' },
        { id: '48938', name: '开福区' },
        { id: '48939', name: '天心区' },
        { id: '48941', name: '浏阳市' },
        { id: '48942', name: '长沙县' },
        { id: '48943', name: '宁乡县' },
        { id: '1485', name: '望城区' }
      ],
      1488: [
        { id: '29444', name: '天元区' },
        { id: '29445', name: '石峰区' },
        { id: '29446', name: '芦淞区' },
        { id: '29447', name: '荷塘区' },
        { id: '1489', name: '醴陵市' },
        { id: '1490', name: '株洲县' },
        { id: '1491', name: '攸县' },
        { id: '1492', name: '茶陵县' },
        { id: '1493', name: '炎陵县' }
      ],
      1495: [
        { id: '29448', name: '雨湖区' },
        { id: '29449', name: '岳塘区' },
        { id: '1496', name: '湘乡市' },
        { id: '1497', name: '湘潭县' },
        { id: '1498', name: '韶山市' }
      ],
      1501: [
        { id: '29450', name: '蒸湘区' },
        { id: '29451', name: '石鼓区' },
        { id: '29452', name: '珠晖区' },
        { id: '29453', name: '雁峰区' },
        { id: '1502', name: '常宁市' },
        { id: '1503', name: '衡阳县' },
        { id: '1504', name: '耒阳市' },
        { id: '1505', name: '衡东县' },
        { id: '1506', name: '衡南县' },
        { id: '1507', name: '衡山县' },
        { id: '1508', name: '祁东县' },
        { id: '1509', name: '南岳区' }
      ],
      1511: [
        { id: '29457', name: '大祥区' },
        { id: '29458', name: '双清区' },
        { id: '29459', name: '北塔区' },
        { id: '1512', name: '武冈市' },
        { id: '1513', name: '邵东县' },
        { id: '1514', name: '洞口县' },
        { id: '1515', name: '新邵县' },
        { id: '1516', name: '绥宁县' },
        { id: '1517', name: '新宁县' },
        { id: '1518', name: '邵阳县' },
        { id: '1519', name: '隆回县' },
        { id: '1520', name: '城步县' }
      ],
      1522: [
        { id: '29460', name: '岳阳楼区' },
        { id: '3619', name: '君山区' },
        { id: '3620', name: '云溪区' },
        { id: '1523', name: '临湘市' },
        { id: '1524', name: '汨罗市' },
        { id: '1525', name: '岳阳县' },
        { id: '1526', name: '湘阴县' },
        { id: '1527', name: '华容县' },
        { id: '1528', name: '平江县' }
      ],
      1530: [
        { id: '1536', name: '汉寿县' },
        { id: '1537', name: '石门县' },
        { id: '1538', name: '安乡县' },
        { id: '29461', name: '鼎城区' },
        { id: '29462', name: '武陵区' },
        { id: '1532', name: '津市市' },
        { id: '1533', name: '澧县' },
        { id: '1534', name: '临澧县' },
        { id: '1535', name: '桃源县' }
      ],
      1601: [
        { id: '3633', name: '天河区' },
        { id: '3634', name: '海珠区' },
        { id: '3635', name: '荔湾区' },
        { id: '3637', name: '越秀区' },
        { id: '36953', name: '番禺区' },
        { id: '50256', name: '花都区' },
        { id: '50258', name: '白云区' },
        { id: '50259', name: '南沙区' },
        { id: '50283', name: '黄埔区' },
        { id: '50284', name: '增城区' },
        { id: '50285', name: '从化区' },
        { id: '51091', name: '广州大学城' }
      ],
      1607: [
        { id: '3638', name: '罗湖区' },
        { id: '3639', name: '福田区' },
        { id: '3155', name: '南山区' },
        { id: '4773', name: '宝安区' },
        { id: '6675', name: '光明新区' },
        { id: '40152', name: '龙岗区' },
        { id: '6736', name: '坪山新区' },
        { id: '47387', name: '盐田区' },
        { id: '47388', name: '龙华新区' },
        { id: '6737', name: '大鹏新区' }
      ],
      1609: [
        { id: '41653', name: '斗门区' },
        { id: '41654', name: '金湾区' },
        { id: '41655', name: '香洲区' }
      ],
      1611: [
        { id: '19916', name: '龙湖区' },
        { id: '19917', name: '金平区' },
        { id: '19918', name: '澄海区' },
        { id: '19919', name: '潮阳区' },
        { id: '19920', name: '潮南区' },
        { id: '19921', name: '濠江区' },
        { id: '1614', name: '南澳县' }
      ],
      1617: [
        { id: '3643', name: '武江区' },
        { id: '3644', name: '浈江区' },
        { id: '1618', name: '南雄市' },
        { id: '1619', name: '乐昌市' },
        { id: '1620', name: '仁化县' },
        { id: '1621', name: '始兴县' },
        { id: '1622', name: '翁源县' },
        { id: '1624', name: '新丰县' },
        { id: '1625', name: '乳源瑶族自治县' },
        { id: '1626', name: '曲江区' }
      ],
      1627: [
        { id: '1628', name: '和平县' },
        { id: '1629', name: '龙川县' },
        { id: '1630', name: '紫金县' },
        { id: '1631', name: '连平县' },
        { id: '37864', name: '源城区' },
        { id: '37865', name: '东源县' }
      ],
      1634: [
        { id: '1642', name: '梅江区' },
        { id: '1635', name: '兴宁市' },
        { id: '1636', name: '梅县' },
        { id: '1637', name: '蕉岭县' },
        { id: '1638', name: '大埔县' },
        { id: '1639', name: '丰顺县' },
        { id: '1640', name: '五华县' },
        { id: '1641', name: '平远县' }
      ],
      1643: [
        { id: '36174', name: '惠阳区' },
        { id: '36175', name: '大亚湾区' },
        { id: '36176', name: '惠城区' },
        { id: '36177', name: '惠东县' },
        { id: '36178', name: '博罗县' },
        { id: '1647', name: '龙门县' }
      ],
      1650: [
        { id: '20051', name: '城区' },
        { id: '20052', name: '陆丰市' },
        { id: '1653', name: '陆河县' },
        { id: '3037', name: '海丰县' }
      ],
      1655: [
        { id: '4760', name: '长安镇' },
        { id: '4255', name: '莞城区' },
        { id: '4256', name: '南城区' },
        { id: '4866', name: '寮步镇' },
        { id: '4871', name: '大岭山镇' },
        { id: '5905', name: '横沥镇' },
        { id: '4886', name: '常平镇' },
        { id: '4910', name: '厚街镇' },
        { id: '4911', name: '万江区' },
        { id: '4932', name: '樟木头镇' },
        { id: '5457', name: '塘厦镇' },
        { id: '5473', name: '凤岗镇' },
        { id: '4980', name: '大朗镇' },
        { id: '3041', name: '东坑镇' },
        { id: '5869', name: '清溪镇' },
        { id: '3105', name: '企石镇' },
        { id: '3171', name: '茶山镇' },
        { id: '36102', name: '东城区' },
        { id: '39462', name: '虎门镇' },
        { id: '39461', name: '黄江镇' },
        { id: '3104', name: '石排镇' },
        { id: '3078', name: '道滘镇' },
        { id: '3097', name: '沙田镇' },
        { id: '3100', name: '高埗镇' },
        { id: '3102', name: '石龙镇' },
        { id: '3111', name: '石碣镇' },
        { id: '3116', name: '洪梅镇' },
        { id: '3120', name: '麻涌镇' },
        { id: '4147', name: '松山湖' },
        { id: '3134', name: '桥头镇' },
        { id: '3151', name: '望牛墩镇' },
        { id: '2950', name: '中堂镇' },
        { id: '4087', name: '谢岗镇' }
      ],
      1657: [
        { id: '52093', name: '城区' },
        { id: '4852', name: '火炬开发区' },
        { id: '2902', name: '小榄镇' },
        { id: '2957', name: '古镇' },
        { id: '3016', name: '三乡镇' },
        { id: '8540', name: '民众镇' },
        { id: '3067', name: '东凤镇' },
        { id: '4102', name: '板芙镇' },
        { id: '4127', name: '神湾镇' },
        { id: '3112', name: '横栏镇' },
        { id: '4141', name: '港口镇' },
        { id: '3143', name: '三角镇' },
        { id: '4190', name: '大涌镇' },
        { id: '3176', name: '南头镇' },
        { id: '3743', name: '沙溪镇' },
        { id: '3001', name: '坦洲镇' },
        { id: '3007', name: '黄圃镇' },
        { id: '4042', name: '五桂山镇' },
        { id: '2777', name: '南朗镇' },
        { id: '39653', name: '沙朗镇' },
        { id: '4076', name: '阜沙镇' },
        { id: '4080', name: '东升镇' }
      ],
      1659: [
        { id: '37258', name: '台山市' },
        { id: '37259', name: '新会区' },
        { id: '37260', name: '鹤山市' },
        { id: '37261', name: '江海区' },
        { id: '37262', name: '蓬江区' },
        { id: '37263', name: '开平市' },
        { id: '37264', name: '恩平市' }
      ],
      1666: [
        { id: '1669', name: '顺德区' },
        { id: '36264', name: '禅城区' },
        { id: '36265', name: '高明区' },
        { id: '36266', name: '三水区' },
        { id: '36267', name: '南海区' }
      ],
      1672: [
        { id: '19827', name: '江城区' },
        { id: '19828', name: '阳东县' },
        { id: '1673', name: '阳春市' },
        { id: '1674', name: '阳西县' }
      ],
      1677: [
        { id: '19377', name: '赤坎区' },
        { id: '19378', name: '霞山区' },
        { id: '19379', name: '经济技术开发区' },
        { id: '19380', name: '麻章区' },
        { id: '19381', name: '遂溪县' },
        { id: '19382', name: '廉江市' },
        { id: '3646', name: '坡头区' },
        { id: '1679', name: '雷州市' },
        { id: '1680', name: '吴川市' },
        { id: '1682', name: '徐闻县' }
      ],
      1684: [
        { id: '19465', name: '茂南区' },
        { id: '19466', name: '电白县' },
        { id: '19467', name: '高州市' },
        { id: '19468', name: '化州市' },
        { id: '19469', name: '茂港区' },
        { id: '1687', name: '信宜市' }
      ],
      1690: [
        { id: '4781', name: '端州区' },
        { id: '39723', name: '四会市' },
        { id: '39725', name: '高要市' },
        { id: '1693', name: '广宁县' },
        { id: '1694', name: '德庆县' },
        { id: '1695', name: '怀集县' },
        { id: '1696', name: '封开县' },
        { id: '1697', name: '鼎湖区' }
      ],
      1698: [
        { id: '19829', name: '云城区' },
        { id: '19830', name: '罗定市' },
        { id: '1700', name: '云安县' },
        { id: '1701', name: '新兴县' },
        { id: '1702', name: '郁南县' }
      ],
      1704: [
        { id: '1795', name: '连州市' },
        { id: '1796', name: '佛冈县' },
        { id: '1797', name: '阳山县' },
        { id: '1798', name: '清新县' },
        { id: '1799', name: '连山县' },
        { id: '1800', name: '连南县' },
        { id: '37734', name: '清城区' },
        { id: '37735', name: '英德市' }
      ],
      1705: [
        { id: '19991', name: '湘桥区' },
        { id: '4238', name: '枫溪区' },
        { id: '19992', name: '潮安区' },
        { id: '1707', name: '饶平县' }
      ],
      1709: [
        { id: '5484', name: '东山区' },
        { id: '5864', name: '普宁市' },
        { id: '20093', name: '榕城区' },
        { id: '20094', name: '揭东县' },
        { id: '1712', name: '揭西县' },
        { id: '1713', name: '惠来县' }
      ],
      1792: [
        { id: '23040', name: '八步区' },
        { id: '1803', name: '钟山县' },
        { id: '1804', name: '昭平县' },
        { id: '1805', name: '富川县' },
        { id: '22850', name: '平桂管理区' }
      ],
      1806: [
        { id: '1807', name: '右江区' },
        { id: '1808', name: '平果县' },
        { id: '1809', name: '乐业县' },
        { id: '1810', name: '田阳县' },
        { id: '1811', name: '西林县' },
        { id: '1812', name: '田林县' },
        { id: '1813', name: '德保县' },
        { id: '1814', name: '靖西县' },
        { id: '1815', name: '田东县' },
        { id: '1816', name: '那坡县' },
        { id: '1817', name: '隆林县' },
        { id: '3678', name: '凌云县' }
      ],
      1818: [
        { id: '1820', name: '宜州市' },
        { id: '1821', name: '天峨县' },
        { id: '1822', name: '凤山县' },
        { id: '1823', name: '南丹县' },
        { id: '1824', name: '东兰县' },
        { id: '1825', name: '巴马县' },
        { id: '1826', name: '环江县' },
        { id: '3152', name: '大化县' },
        { id: '3679', name: '都安县' },
        { id: '3680', name: '金城江区' },
        { id: '2991', name: '罗城县' }
      ],
      3168: [
        { id: '3169', name: '江州区' },
        { id: '3681', name: '凭祥市' },
        { id: '3682', name: '扶绥县' },
        { id: '3683', name: '大新县' },
        { id: '3684', name: '天等县' },
        { id: '3685', name: '宁明县' },
        { id: '3686', name: '龙州县' }
      ],
      1715: [
        { id: '43114', name: '良庆区' },
        { id: '43115', name: '江南区' },
        { id: '43116', name: '兴宁区' },
        { id: '43117', name: '青秀区' },
        { id: '43118', name: '西乡塘区' },
        { id: '3650', name: '横县' },
        { id: '3651', name: '上林县' },
        { id: '3652', name: '隆安县' },
        { id: '3653', name: '马山县' },
        { id: '1716', name: '武鸣区' },
        { id: '1724', name: '邕宁区' },
        { id: '3005', name: '宾阳县' }
      ],
      1720: [
        { id: '3659', name: '融安县' },
        { id: '3660', name: '三江县' },
        { id: '3661', name: '融水县' },
        { id: '22906', name: '鱼峰区' },
        { id: '22907', name: '城中区' },
        { id: '22908', name: '柳南区' },
        { id: '22909', name: '柳北区' },
        { id: '1721', name: '柳江县' },
        { id: '1722', name: '柳城县' },
        { id: '1725', name: '鹿寨县' }
      ],
      1726: [
        { id: '3670', name: '象山区' },
        { id: '3666', name: '恭城县' },
        { id: '22883', name: '秀峰区' },
        { id: '22884', name: '叠彩区' },
        { id: '22885', name: '七星区' },
        { id: '4457', name: '雁山区' },
        { id: '1727', name: '阳朔县' },
        { id: '1728', name: '临桂县' },
        { id: '1729', name: '灵川县' },
        { id: '1730', name: '全州县' },
        { id: '1731', name: '平乐县' },
        { id: '1732', name: '兴安县' },
        { id: '1733', name: '灌阳县' },
        { id: '1734', name: '荔浦县' },
        { id: '1735', name: '资源县' },
        { id: '1736', name: '永福县' },
        { id: '1738', name: '龙胜县' }
      ],
      1740: [
        { id: '53521', name: '龙圩区' },
        { id: '1741', name: '岑溪市' },
        { id: '1742', name: '苍梧县' },
        { id: '1743', name: '藤县' },
        { id: '1744', name: '蒙山县' },
        { id: '23037', name: '万秀区' },
        { id: '23038', name: '蝶山区' },
        { id: '23039', name: '长洲区' }
      ],
      1746: [
        { id: '22851', name: '海城区' },
        { id: '22852', name: '银海区' },
        { id: '1747', name: '合浦县' },
        { id: '1748', name: '铁山港区' }
      ],
      1749: [
        { id: '25190', name: '防城区' },
        { id: '25191', name: '港口区' },
        { id: '1750', name: '东兴市' },
        { id: '1751', name: '上思县' }
      ],
      1753: [
        { id: '25189', name: '钦南区' },
        { id: '2999', name: '钦北区' },
        { id: '1754', name: '浦北县' },
        { id: '1755', name: '灵山县' }
      ],
      1757: [
        { id: '25192', name: '港南区' },
        { id: '25193', name: '港北区' },
        { id: '1758', name: '桂平市' },
        { id: '1759', name: '平南县' },
        { id: '1760', name: '覃塘区' }
      ],
      1761: [
        { id: '25188', name: '玉州区' },
        { id: '1762', name: '北流市' },
        { id: '1763', name: '容县' },
        { id: '1764', name: '博白县' },
        { id: '1765', name: '陆川县' },
        { id: '1766', name: '兴业县' }
      ],
      3044: [
        { id: '3046', name: '兴宾区' },
        { id: '3047', name: '合山市' },
        { id: '3048', name: '忻城县' },
        { id: '3049', name: '武宣县' },
        { id: '3050', name: '象州县' },
        { id: '3051', name: '金秀县' }
      ],
      1827: [
        { id: '3505', name: '青云谱区' },
        { id: '3506', name: '西湖区' },
        { id: '3507', name: '东湖区' },
        { id: '4101', name: '昌北区' },
        { id: '1828', name: '南昌县' },
        { id: '1829', name: '进贤县' },
        { id: '1830', name: '安义县' },
        { id: '40846', name: '青山湖区' },
        { id: '40847', name: '红谷滩新区' },
        { id: '3502', name: '新建县' },
        { id: '3504', name: '湾里区' },
        { id: '4039', name: '高新区' }
      ],
      1832: [
        { id: '3508', name: '珠山区' },
        { id: '1833', name: '乐平市' },
        { id: '1834', name: '浮梁县' },
        { id: '24947', name: '昌江区' }
      ],
      1836: [
        { id: '1837', name: '湘东区' },
        { id: '1838', name: '莲花县' },
        { id: '1839', name: '上栗县' },
        { id: '1840', name: '芦溪县' },
        { id: '18317', name: '安源区' }
      ],
      1842: [
        { id: '1843', name: '分宜县' },
        { id: '26455', name: '渝水区' }
      ],
      1845: [
        { id: '25482', name: '浔阳区' },
        { id: '23679', name: '八里湖新区' },
        { id: '23678', name: '经济技术开发区' },
        { id: '1852', name: '修水县' },
        { id: '1847', name: '瑞昌市' },
        { id: '1850', name: '彭泽县' },
        { id: '1853', name: '湖口县' },
        { id: '4161', name: '共青城市' },
        { id: '1846', name: '九江县' },
        { id: '25481', name: '濂溪区' },
        { id: '1854', name: '德安县' },
        { id: '1855', name: '都昌县' },
        { id: '1851', name: '永修县' },
        { id: '1849', name: '武宁县' },
        { id: '1848', name: '庐山市' },
        { id: '23680', name: '庐山风景名胜区' }
      ],
      1857: [
        { id: '51245', name: '龙虎山风景旅游区' },
        { id: '1858', name: '余江县' },
        { id: '1859', name: '贵溪市' },
        { id: '1860', name: '月湖区' }
      ],
      1861: [
        { id: '1863', name: '德兴市' },
        { id: '1864', name: '广丰县' },
        { id: '1865', name: '鄱阳县' },
        { id: '1866', name: '婺源县' },
        { id: '1867', name: '余干县' },
        { id: '1868', name: '横峰县' },
        { id: '1869', name: '弋阳县' },
        { id: '1870', name: '铅山县' },
        { id: '1871', name: '玉山县' },
        { id: '1872', name: '万年县' },
        { id: '26449', name: '信州区' },
        { id: '26450', name: '上饶县' }
      ],
      1874: [
        { id: '1875', name: '丰城市' },
        { id: '1876', name: '樟树市' },
        { id: '26452', name: '袁州区' },
        { id: '1877', name: '高安市' },
        { id: '1878', name: '铜鼓县' },
        { id: '1879', name: '靖安县' },
        { id: '1880', name: '宜丰县' },
        { id: '1881', name: '奉新县' },
        { id: '1882', name: '万载县' },
        { id: '1883', name: '上高县' }
      ],
      1885: [
        { id: '1887', name: '南丰县' },
        { id: '1888', name: '乐安县' },
        { id: '1889', name: '金溪县' },
        { id: '1890', name: '南城县' },
        { id: '1891', name: '东乡县' },
        { id: '1892', name: '资溪县' },
        { id: '1893', name: '宜黄县' },
        { id: '1894', name: '崇仁县' },
        { id: '1895', name: '黎川县' },
        { id: '1896', name: '广昌县' },
        { id: '24946', name: '临川区' }
      ],
      1898: [
        { id: '26453', name: '青原区' },
        { id: '26454', name: '吉州区' },
        { id: '1899', name: '井冈山市' },
        { id: '1900', name: '吉安县' },
        { id: '1901', name: '永丰县' },
        { id: '1902', name: '永新县' },
        { id: '1903', name: '新干县' },
        { id: '1904', name: '泰和县' },
        { id: '1905', name: '峡江县' },
        { id: '1906', name: '遂川县' },
        { id: '1907', name: '安福县' },
        { id: '1908', name: '吉水县' },
        { id: '1909', name: '万安县' }
      ],
      1911: [
        { id: '26451', name: '章贡区' },
        { id: '1912', name: '南康市' },
        { id: '1913', name: '瑞金市' },
        { id: '1914', name: '石城县' },
        { id: '1915', name: '安远县' },
        { id: '1916', name: '赣县' },
        { id: '1917', name: '宁都县' },
        { id: '1918', name: '寻乌县' },
        { id: '1919', name: '兴国县' },
        { id: '1920', name: '定南县' },
        { id: '1921', name: '上犹县' },
        { id: '1922', name: '于都县' },
        { id: '1923', name: '龙南县' },
        { id: '1924', name: '崇义县' },
        { id: '1925', name: '大余县' },
        { id: '1926', name: '信丰县' },
        { id: '1927', name: '全南县' },
        { id: '1928', name: '会昌县' }
      ],
      2058: [
        { id: '2060', name: '仁寿县' },
        { id: '2061', name: '彭山区' },
        { id: '2062', name: '洪雅县' },
        { id: '2063', name: '丹棱县' },
        { id: '2064', name: '青神县' },
        { id: '41029', name: '东坡区' }
      ],
      2065: [
        { id: '3905', name: '雁江区' },
        { id: '2068', name: '安岳县' },
        { id: '2069', name: '乐至县' },
        { id: '44342', name: '简阳市' }
      ],
      2070: [
        { id: '2071', name: '马尔康县' },
        { id: '2072', name: '九寨沟县' },
        { id: '2073', name: '红原县' },
        { id: '2075', name: '阿坝县' },
        { id: '2076', name: '理县' },
        { id: '2077', name: '若尔盖县' },
        { id: '2078', name: '金川县' },
        { id: '2079', name: '小金县' },
        { id: '2080', name: '黑水县' },
        { id: '2081', name: '松潘县' },
        { id: '2082', name: '壤塘县' },
        { id: '2083', name: '茂县' },
        { id: '27498', name: '汶川县' }
      ],
      2084: [
        { id: '2085', name: '康定县' },
        { id: '2086', name: '泸定县' },
        { id: '2087', name: '九龙县' },
        { id: '2088', name: '丹巴县' },
        { id: '2089', name: '道孚县' },
        { id: '2090', name: '炉霍县' },
        { id: '2091', name: '色达县' },
        { id: '2092', name: '甘孜县' },
        { id: '2093', name: '新龙县' },
        { id: '2094', name: '白玉县' },
        { id: '2095', name: '德格县' },
        { id: '2096', name: '石渠县' },
        { id: '2097', name: '雅江县' },
        { id: '2098', name: '理塘县' },
        { id: '2099', name: '巴塘县' },
        { id: '2100', name: '稻城县' },
        { id: '2101', name: '乡城县' },
        { id: '2102', name: '得荣县' }
      ],
      2103: [
        { id: '2105', name: '美姑县' },
        { id: '2106', name: '昭觉县' },
        { id: '2107', name: '会理县' },
        { id: '2108', name: '会东县' },
        { id: '2109', name: '普格县' },
        { id: '2110', name: '宁南县' },
        { id: '2111', name: '德昌县' },
        { id: '2112', name: '冕宁县' },
        { id: '2113', name: '盐源县' },
        { id: '2114', name: '金阳县' },
        { id: '2115', name: '布拖县' },
        { id: '2116', name: '雷波县' },
        { id: '2117', name: '越西县' },
        { id: '2118', name: '喜德县' },
        { id: '2119', name: '甘洛县' },
        { id: '2120', name: '木里县' },
        { id: '27500', name: '西昌市' }
      ],
      1930: [
        { id: '50947', name: '武侯区' },
        { id: '50946', name: '金牛区' },
        { id: '50944', name: '青羊区' },
        { id: '50948', name: '成华区' },
        { id: '50949', name: '高新区' },
        { id: '50945', name: '锦江区' },
        { id: '49322', name: '郫县' },
        { id: '49324', name: '双流县' },
        { id: '4284', name: '高新西区' },
        { id: '49316', name: '龙泉驿区' },
        { id: '49314', name: '新都区' },
        { id: '49315', name: '温江区' },
        { id: '49321', name: '都江堰市' },
        { id: '49318', name: '彭州市' },
        { id: '49317', name: '青白江区' },
        { id: '49319', name: '崇州市' },
        { id: '49327', name: '金堂县' },
        { id: '49323', name: '新津县' },
        { id: '49320', name: '邛崃市' },
        { id: '49325', name: '大邑县' },
        { id: '49326', name: '蒲江县' }
      ],
      1946: [
        { id: '1949', name: '自流井区' },
        { id: '3895', name: '沿滩区' },
        { id: '1947', name: '荣县' },
        { id: '1948', name: '富顺县' },
        { id: '43224', name: '大安区' },
        { id: '43225', name: '贡井区' }
      ],
      1950: [
        { id: '1953', name: '仁和区' },
        { id: '3896', name: '西区' },
        { id: '27502', name: '东区' },
        { id: '1951', name: '米易县' },
        { id: '1952', name: '盐边县' }
      ],
      1954: [
        { id: '3898', name: '纳溪区' },
        { id: '39014', name: '江阳区' },
        { id: '39015', name: '龙马潭区' },
        { id: '1955', name: '泸县' },
        { id: '1956', name: '合江县' },
        { id: '1957', name: '叙永县' },
        { id: '1958', name: '古蔺县' }
      ],
      1960: [
        { id: '38573', name: '江油市' },
        { id: '38574', name: '涪城区' },
        { id: '38575', name: '游仙区' },
        { id: '38576', name: '高新区' },
        { id: '38577', name: '经开区' },
        { id: '1970', name: '盐亭县' },
        { id: '1971', name: '三台县' },
        { id: '1972', name: '平武县' },
        { id: '1973', name: '北川县' },
        { id: '1974', name: '安县' },
        { id: '1975', name: '梓潼县' }
      ],
      1962: [
        { id: '39010', name: '广汉市' },
        { id: '39011', name: '什邡市' },
        { id: '39012', name: '旌阳区' },
        { id: '39013', name: '绵竹市' },
        { id: '1965', name: '罗江县' },
        { id: '1966', name: '中江县' }
      ],
      1977: [
        { id: '3901', name: '昭化区' },
        { id: '3902', name: '朝天区' },
        { id: '27499', name: '利州区' },
        { id: '1978', name: '青川县' },
        { id: '1979', name: '旺苍县' },
        { id: '1980', name: '剑阁县' },
        { id: '1981', name: '苍溪县' }
      ],
      1983: [
        { id: '4961', name: '船山区' },
        { id: '1984', name: '射洪县' },
        { id: '1985', name: '蓬溪县' },
        { id: '1986', name: '大英县' },
        { id: '1987', name: '安居区' }
      ],
      1988: [
        { id: '3121', name: '东兴区' },
        { id: '1989', name: '资中县' },
        { id: '1990', name: '隆昌县' },
        { id: '1991', name: '威远县' },
        { id: '1992', name: '市中区' }
      ],
      1993: [
        { id: '36983', name: '市中区' },
        { id: '36984', name: '峨眉山市' },
        { id: '1994', name: '五通桥区' },
        { id: '1995', name: '沙湾区' },
        { id: '1996', name: '金口河区' },
        { id: '1998', name: '夹江县' },
        { id: '1999', name: '井研县' },
        { id: '2000', name: '犍为县' },
        { id: '2001', name: '沐川县' },
        { id: '2002', name: '峨边县' },
        { id: '2003', name: '马边县' }
      ],
      2005: [
        { id: '2006', name: '宜宾县' },
        { id: '2007', name: '南溪区' },
        { id: '2008', name: '江安县' },
        { id: '2009', name: '长宁县' },
        { id: '2010', name: '兴文县' },
        { id: '2011', name: '珙县' },
        { id: '36315', name: '翠屏区' },
        { id: '2012', name: '高县' },
        { id: '2013', name: '屏山县' },
        { id: '2015', name: '筠连县' }
      ],
      2016: [
        { id: '52607', name: '前锋区' },
        { id: '2017', name: '岳池县' },
        { id: '2018', name: '武胜县' },
        { id: '2019', name: '邻水县' },
        { id: '2020', name: '广安区' },
        { id: '2021', name: '华蓥市' }
      ],
      2022: [
        { id: '43226', name: '顺庆区' },
        { id: '43227', name: '高坪区' },
        { id: '43228', name: '嘉陵区' },
        { id: '43229', name: '西充县' },
        { id: '43230', name: '阆中市' },
        { id: '36936', name: '南部县' },
        { id: '2028', name: '仪陇县' },
        { id: '2029', name: '蓬安县' },
        { id: '2030', name: '营山县' }
      ],
      2033: [
        { id: '2034', name: '通川区' },
        { id: '2035', name: '达川区' },
        { id: '2036', name: '大竹县' },
        { id: '2037', name: '渠县' },
        { id: '2038', name: '万源市' },
        { id: '2039', name: '宣汉县' },
        { id: '2040', name: '开江县' }
      ],
      2042: [
        { id: '3904', name: '巴州区' },
        { id: '52623', name: '恩阳区' },
        { id: '2044', name: '南江县' },
        { id: '2045', name: '平昌县' },
        { id: '2046', name: '通江县' }
      ],
      2047: [
        { id: '2049', name: '芦山县' },
        { id: '2052', name: '石棉县' },
        { id: '2053', name: '名山区' },
        { id: '2054', name: '天全县' },
        { id: '2055', name: '荥经县' },
        { id: '2056', name: '汉源县' },
        { id: '2057', name: '宝兴县' },
        { id: '41028', name: '雨城区' }
      ],
      3115: [
        { id: '3720', name: '嘉积镇' },
        { id: '3721', name: '万泉镇' },
        { id: '3722', name: '石壁镇' },
        { id: '3723', name: '中原镇' },
        { id: '3724', name: '博鳌镇' },
        { id: '3725', name: '阳江镇' },
        { id: '3727', name: '龙江镇' },
        { id: '3728', name: '潭门镇' },
        { id: '3729', name: '塔洋镇' },
        { id: '3730', name: '长坡镇' },
        { id: '3731', name: '大路镇' },
        { id: '3732', name: '会山镇' },
        { id: '12747', name: '彬村山华侨农场' },
        { id: '12748', name: '东太农场' },
        { id: '12749', name: '东红农场' },
        { id: '12750', name: '东升农场' },
        { id: '12751', name: '南俸农场' }
      ],
      3137: [
        { id: '53111', name: '兴隆镇' },
        { id: '53112', name: '南林农场' },
        { id: '3768', name: '万城镇' },
        { id: '3769', name: '龙滚镇' },
        { id: '3770', name: '和乐镇' },
        { id: '3771', name: '后安镇' },
        { id: '3772', name: '大茂镇' },
        { id: '3773', name: '东澳镇' },
        { id: '3774', name: '礼纪镇' },
        { id: '3775', name: '长丰镇' },
        { id: '3776', name: '山根镇' },
        { id: '3777', name: '北大镇' },
        { id: '3778', name: '南桥镇' },
        { id: '3779', name: '三更罗镇' },
        { id: '12775', name: '六连林场' },
        { id: '12776', name: '东兴农场' },
        { id: '12777', name: '东和农场' },
        { id: '12778', name: '新中农场' },
        { id: '12779', name: '兴隆华侨农场' }
      ],
      2121: [
        { id: '22466', name: '秀英区' },
        { id: '22467', name: '龙华区' },
        { id: '22468', name: '琼山区' },
        { id: '22469', name: '美兰区' }
      ],
      3173: [
        { id: '3780', name: '八所镇' },
        { id: '3781', name: '东河镇' },
        { id: '3782', name: '大田镇' },
        { id: '3783', name: '感城镇' },
        { id: '3784', name: '板桥镇' },
        { id: '3785', name: '三家镇' },
        { id: '3786', name: '四更镇' },
        { id: '3787', name: '新龙镇' },
        { id: '3788', name: '天安乡' },
        { id: '3789', name: '江边乡' },
        { id: '12780', name: '广坝农场' },
        { id: '12781', name: '东方华侨农场' }
      ],
      3690: [
        { id: '4182', name: '崖城镇' },
        { id: '3693', name: '海棠湾镇' },
        { id: '3694', name: '吉阳镇' },
        { id: '3695', name: '凤凰镇' },
        { id: '3696', name: '天涯镇' },
        { id: '3697', name: '育才镇' },
        { id: '22470', name: '河西区' },
        { id: '22471', name: '河东区' },
        { id: '22503', name: '南田农场' },
        { id: '22504', name: '南新农场' },
        { id: '22505', name: '南岛农场' },
        { id: '22506', name: '立才农场' },
        { id: '22507', name: '南滨农场' }
      ],
      3698: [
        { id: '3752', name: '文城镇' },
        { id: '3753', name: '重兴镇' },
        { id: '3754', name: '蓬莱镇' },
        { id: '3755', name: '会文镇' },
        { id: '3756', name: '东路镇' },
        { id: '3757', name: '潭牛镇' },
        { id: '3758', name: '东阁镇' },
        { id: '3759', name: '文教镇' },
        { id: '3760', name: '东郊镇' },
        { id: '3761', name: '龙楼镇' },
        { id: '3762', name: '昌洒镇' },
        { id: '3763', name: '翁田镇' },
        { id: '3764', name: '抱罗镇' },
        { id: '3765', name: '冯坡镇' },
        { id: '3766', name: '锦山镇' },
        { id: '3767', name: '铺前镇' },
        { id: '12762', name: '公坡镇' },
        { id: '12763', name: '迈号镇' },
        { id: '12764', name: '清谰镇' },
        { id: '12765', name: '南阳镇' },
        { id: '12766', name: '新桥镇' },
        { id: '12767', name: '头苑镇' },
        { id: '12768', name: '宝芳乡' },
        { id: '12769', name: '龙马乡' },
        { id: '12770', name: '湖山乡' },
        { id: '12771', name: '东路农场' },
        { id: '12772', name: '南阳农场' },
        { id: '12773', name: '罗豆农场' },
        { id: '12774', name: '橡胶研究所' }
      ],
      3699: [
        { id: '3712', name: '通什镇' },
        { id: '3713', name: '南圣镇' },
        { id: '3714', name: '毛阳镇' },
        { id: '3715', name: '番阳镇' },
        { id: '3716', name: '畅好乡' },
        { id: '3717', name: '毛道乡' },
        { id: '3719', name: '水满乡' },
        { id: '12746', name: '畅好农场' }
      ],
      3701: [
        { id: '39884', name: '城区' },
        { id: '3790', name: '临城镇' },
        { id: '3791', name: '波莲镇' },
        { id: '3792', name: '东英镇' },
        { id: '3793', name: '博厚镇' },
        { id: '3794', name: '皇桐镇' },
        { id: '3795', name: '多文镇' },
        { id: '3796', name: '和舍镇' },
        { id: '3797', name: '南宝镇' },
        { id: '3798', name: '新盈镇' },
        { id: '3799', name: '调楼镇' },
        { id: '3800', name: '加来镇' },
        { id: '12791', name: '红华农场' },
        { id: '12792', name: '加来农场' }
      ],
      3702: [
        { id: '39886', name: '城区' },
        { id: '3801', name: '金江镇' },
        { id: '3802', name: '老城镇' },
        { id: '3803', name: '瑞溪镇' },
        { id: '3804', name: '永发镇' },
        { id: '3805', name: '加乐镇' },
        { id: '3806', name: '文儒镇' },
        { id: '3807', name: '中兴镇' },
        { id: '3808', name: '仁兴镇' },
        { id: '3809', name: '福山镇' },
        { id: '3810', name: '桥头镇' },
        { id: '12787', name: '大丰镇' },
        { id: '12788', name: '红光农场' },
        { id: '12789', name: '西达农场' },
        { id: '12790', name: '金安农场' }
      ],
      3703: [
        { id: '4498', name: '黄竹镇' },
        { id: '39887', name: '城区' },
        { id: '3811', name: '定城镇' },
        { id: '3812', name: '新竹镇' },
        { id: '3813', name: '龙湖镇' },
        { id: '3814', name: '雷鸣镇' },
        { id: '3815', name: '龙门镇' },
        { id: '3816', name: '龙河镇' },
        { id: '3817', name: '岭口镇' },
        { id: '3818', name: '翰林镇' },
        { id: '3819', name: '富文镇' },
        { id: '12782', name: '金鸡岭农场' },
        { id: '12783', name: '中瑞农场' },
        { id: '12784', name: '南海农场' }
      ],
      3704: [
        { id: '39889', name: '县城内' },
        { id: '3820', name: '屯城镇' },
        { id: '3821', name: '新兴镇' },
        { id: '3822', name: '枫木镇' },
        { id: '3823', name: '乌坡镇' },
        { id: '3824', name: '南吕镇' },
        { id: '3825', name: '南坤镇' },
        { id: '12785', name: '中建农场' },
        { id: '3826', name: '坡心镇' },
        { id: '12786', name: '中坤农场' },
        { id: '3827', name: '西昌镇' }
      ],
      3705: [
        { id: '12800', name: '红林农场' },
        { id: '39890', name: '城区' },
        { id: '3828', name: '石碌镇' },
        { id: '3829', name: '叉河镇' },
        { id: '3830', name: '十月田镇' },
        { id: '3831', name: '乌烈镇' },
        { id: '3832', name: '昌化镇' },
        { id: '3833', name: '海尾镇' },
        { id: '12796', name: '七叉镇' },
        { id: '12797', name: '王下乡' },
        { id: '12798', name: '海南矿业公司' },
        { id: '12799', name: '霸王岭林场' }
      ],
      3706: [
        { id: '3840', name: '南开乡' },
        { id: '3841', name: '阜龙乡' },
        { id: '3842', name: '青松乡' },
        { id: '3843', name: '金波乡' },
        { id: '3844', name: '荣邦乡' },
        { id: '39892', name: '城区' },
        { id: '12793', name: '白沙农场' },
        { id: '3834', name: '牙叉镇' },
        { id: '12794', name: '龙江农场' },
        { id: '3835', name: '七坊镇' },
        { id: '12795', name: '邦溪农场' },
        { id: '3836', name: '邦溪镇' },
        { id: '3837', name: '打安镇' },
        { id: '3838', name: '细水乡' },
        { id: '3839', name: '元门乡' }
      ],
      3707: [
        { id: '12813', name: '吊罗山乡' },
        { id: '12814', name: '黎母山林业公司' },
        { id: '12815', name: '阳江农场' },
        { id: '12816', name: '乌石农场' },
        { id: '12817', name: '加钗农场' },
        { id: '12818', name: '长征农场' },
        { id: '3878', name: '营根镇' },
        { id: '3879', name: '湾岭镇' },
        { id: '3880', name: '黎母山镇' },
        { id: '3881', name: '和平镇' },
        { id: '3882', name: '长征镇' },
        { id: '3883', name: '红毛镇' },
        { id: '3884', name: '中平镇' },
        { id: '3885', name: '上安乡' },
        { id: '3886', name: '什运乡' },
        { id: '39893', name: '城区' }
      ],
      3708: [
        { id: '53109', name: '东华镇' },
        { id: '53110', name: '南平镇' },
        { id: '12806', name: '吊罗山林业公司' },
        { id: '12807', name: '岭门农场' },
        { id: '12808', name: '南平农场' },
        { id: '3858', name: '椰林镇' },
        { id: '3859', name: '光坡镇' },
        { id: '3860', name: '三才镇' },
        { id: '3861', name: '英州镇' },
        { id: '3862', name: '隆广镇' },
        { id: '3863', name: '文罗镇' },
        { id: '3864', name: '本号镇' },
        { id: '3865', name: '新村镇' },
        { id: '3866', name: '黎安镇' },
        { id: '3867', name: '提蒙乡' },
        { id: '3868', name: '群英乡' },
        { id: '39895', name: '城区' }
      ],
      3709: [
        { id: '12809', name: '保亭研究所' },
        { id: '12810', name: '新星农场' },
        { id: '12811', name: '金江农场' },
        { id: '12812', name: '三道农场' },
        { id: '3869', name: '保城镇' },
        { id: '3870', name: '什玲镇' },
        { id: '3871', name: '加茂镇' },
        { id: '3872', name: '响水镇' },
        { id: '3873', name: '新政镇' },
        { id: '3874', name: '三道镇' },
        { id: '3875', name: '六弓乡' },
        { id: '3876', name: '南林乡' },
        { id: '3877', name: '毛感乡' }
      ],
      3710: [
        { id: '12801', name: '尖峰岭林业公司' },
        { id: '12802', name: '莺歌海盐场' },
        { id: '12803', name: '山荣农场' },
        { id: '12804', name: '乐光农场' },
        { id: '3845', name: '抱由镇' },
        { id: '12805', name: '保国农场' },
        { id: '3846', name: '万冲镇' },
        { id: '3847', name: '大安镇' },
        { id: '3849', name: '志仲镇' },
        { id: '3851', name: '千家镇' },
        { id: '3852', name: '九所镇' },
        { id: '3853', name: '利国镇' },
        { id: '3854', name: '黄流镇' },
        { id: '3855', name: '佛罗镇' },
        { id: '3856', name: '尖峰镇' },
        { id: '3857', name: '莺歌海镇' },
        { id: '39897', name: '城区' }
      ],
      3711: [
        { id: '12819', name: '中沙群岛' },
        { id: '3887', name: '西沙群岛' },
        { id: '3888', name: '南沙群岛' }
      ],
      3034: [
        { id: '12824', name: '热作学院' },
        { id: '3125', name: '那大镇' },
        { id: '4214', name: '富克镇' },
        { id: '3733', name: '和庆镇' },
        { id: '3734', name: '南丰镇' },
        { id: '3735', name: '大成镇' },
        { id: '3736', name: '雅星镇' },
        { id: '3737', name: '兰洋镇' },
        { id: '3738', name: '光村镇' },
        { id: '3739', name: '木棠镇' },
        { id: '3740', name: '海头镇' },
        { id: '3741', name: '峨蔓镇' },
        { id: '3744', name: '三都镇' },
        { id: '3745', name: '王五镇' },
        { id: '3746', name: '白马井镇' },
        { id: '3747', name: '中和镇' },
        { id: '3748', name: '排浦镇' },
        { id: '3749', name: '东成镇' },
        { id: '3750', name: '新州镇' },
        { id: '3751', name: '洋浦经济开发区' },
        { id: '12752', name: '西培农场' },
        { id: '12753', name: '西联农场' },
        { id: '12754', name: '蓝洋农场' },
        { id: '12755', name: '八一农场' },
        { id: '12756', name: '西华农场' },
        { id: '12757', name: '西庆农场' },
        { id: '12758', name: '西流农场' },
        { id: '12759', name: '新盈农场' },
        { id: '12760', name: '龙山农场' },
        { id: '12761', name: '红岭农场' }
      ],
      2144: [
        { id: '3906', name: '南明区' },
        { id: '21037', name: '云岩区' },
        { id: '21038', name: '花溪区' },
        { id: '21039', name: '小河区' },
        { id: '3909', name: '白云区' },
        { id: '2145', name: '清镇市' },
        { id: '2146', name: '开阳县' },
        { id: '2147', name: '修文县' },
        { id: '2148', name: '息烽县' },
        { id: '2149', name: '乌当区' },
        { id: '24463', name: '观山湖区' }
      ],
      2150: [
        { id: '2151', name: '盘县' },
        { id: '2152', name: '六枝特区' },
        { id: '2153', name: '水城县' },
        { id: '2154', name: '钟山区' }
      ],
      2155: [
        { id: '21035', name: '红花岗区' },
        { id: '21036', name: '汇川区' },
        { id: '2156', name: '赤水市' },
        { id: '2157', name: '仁怀市' },
        { id: '2158', name: '遵义县' },
        { id: '2159', name: '桐梓县' },
        { id: '2160', name: '绥阳县' },
        { id: '2161', name: '习水县' },
        { id: '2162', name: '凤冈县' },
        { id: '2163', name: '正安县' },
        { id: '2164', name: '湄潭县' },
        { id: '2165', name: '余庆县' },
        { id: '2166', name: '道真县' },
        { id: '2167', name: '务川县' }
      ],
      2169: [
        { id: '2170', name: '碧江区' },
        { id: '2171', name: '德江县' },
        { id: '2172', name: '江口县' },
        { id: '2173', name: '思南县' },
        { id: '2174', name: '万山区' },
        { id: '2175', name: '石阡县' },
        { id: '2176', name: '玉屏侗族自治县' },
        { id: '2177', name: '松桃苗族自治县' },
        { id: '2178', name: '印江土家族苗族自治县' },
        { id: '2179', name: '沿河土家族自治县' }
      ],
      2180: [
        { id: '8891', name: '七星关区' },
        { id: '2182', name: '黔西县' },
        { id: '2183', name: '大方县' },
        { id: '2184', name: '织金县' },
        { id: '2185', name: '金沙县' },
        { id: '2186', name: '赫章县' },
        { id: '2187', name: '纳雍县' },
        { id: '2188', name: '威宁彝族回族苗族自治县' }
      ],
      2189: [
        { id: '2190', name: '西秀区' },
        { id: '2191', name: '普定县' },
        { id: '2192', name: '平坝县' },
        { id: '2193', name: '镇宁布依族苗族自治县' },
        { id: '2194', name: '关岭布依族苗族自治县' },
        { id: '2195', name: '紫云苗族布依族自治县' }
      ],
      2196: [
        { id: '2197', name: '兴义市' },
        { id: '2198', name: '望谟县' },
        { id: '2199', name: '兴仁县' },
        { id: '2200', name: '普安县' },
        { id: '2201', name: '册亨县' },
        { id: '2202', name: '晴隆县' },
        { id: '2203', name: '贞丰县' },
        { id: '2204', name: '安龙县' }
      ],
      2205: [
        { id: '2206', name: '凯里市' },
        { id: '2207', name: '施秉市' },
        { id: '2208', name: '从江县' },
        { id: '2209', name: '锦屏县' },
        { id: '2210', name: '镇远县' },
        { id: '2211', name: '麻江县' },
        { id: '2212', name: '台江县' },
        { id: '2213', name: '天柱县' },
        { id: '2214', name: '黄平县' },
        { id: '2215', name: '榕江县' },
        { id: '2216', name: '剑河县' },
        { id: '2217', name: '三穗县' },
        { id: '2218', name: '雷山县' },
        { id: '2219', name: '黎平县' },
        { id: '2220', name: '岑巩县' },
        { id: '2221', name: '丹寨县' }
      ],
      2222: [
        { id: '2223', name: '都匀市' },
        { id: '2224', name: '福泉市' },
        { id: '2225', name: '贵定县' },
        { id: '2226', name: '惠水县' },
        { id: '2227', name: '罗甸县' },
        { id: '2228', name: '瓮安县' },
        { id: '2229', name: '荔波县' },
        { id: '2230', name: '龙里县' },
        { id: '2231', name: '平塘县' },
        { id: '2232', name: '长顺县' },
        { id: '2233', name: '独山县' },
        { id: '2234', name: '三都县' }
      ],
      2304: [
        { id: '2305', name: '玉龙县' },
        { id: '2306', name: '华坪县' },
        { id: '2307', name: '永胜县' },
        { id: '2308', name: '宁蒗县' },
        { id: '21033', name: '古城区' }
      ],
      2309: [
        { id: '2310', name: '文山市' },
        { id: '2311', name: '麻栗坡县' },
        { id: '2312', name: '砚山县' },
        { id: '2313', name: '广南县' },
        { id: '2314', name: '马关县' },
        { id: '2315', name: '富宁县' },
        { id: '2316', name: '西畴县' },
        { id: '2317', name: '丘北县' }
      ],
      4108: [
        { id: '6823', name: '香格里拉县' },
        { id: '6824', name: '德钦县' },
        { id: '6825', name: '维西县' }
      ],
      2318: [
        { id: '2319', name: '个旧市' },
        { id: '2320', name: '开远市' },
        { id: '2321', name: '弥勒县' },
        { id: '2322', name: '红河县' },
        { id: '2323', name: '绿春县' },
        { id: '2324', name: '蒙自市' },
        { id: '2325', name: '泸西县' },
        { id: '2326', name: '建水县' },
        { id: '2327', name: '元阳县' },
        { id: '2328', name: '石屏县' },
        { id: '2329', name: '金平县' },
        { id: '2330', name: '屏边县' },
        { id: '2331', name: '河口县' }
      ],
      2332: [
        { id: '2333', name: '景洪市' },
        { id: '2334', name: '勐海县' },
        { id: '2335', name: '勐腊县' }
      ],
      2336: [
        { id: '2338', name: '元谋县' },
        { id: '2339', name: '南华县' },
        { id: '2340', name: '牟定县' },
        { id: '2341', name: '武定县' },
        { id: '2342', name: '大姚县' },
        { id: '2343', name: '双柏县' },
        { id: '2344', name: '禄丰县' },
        { id: '2345', name: '永仁县' },
        { id: '3917', name: '姚安县' },
        { id: '20817', name: '楚雄市' }
      ],
      2347: [
        { id: '2349', name: '剑川县' },
        { id: '2350', name: '弥渡县' },
        { id: '2351', name: '云龙县' },
        { id: '2352', name: '洱源县' },
        { id: '2353', name: '鹤庆县' },
        { id: '2354', name: '宾川县' },
        { id: '2355', name: '祥云县' },
        { id: '2356', name: '永平县' },
        { id: '2357', name: '巍山县' },
        { id: '2358', name: '漾濞县' },
        { id: '2359', name: '南涧县' },
        { id: '20818', name: '大理市' }
      ],
      2360: [
        { id: '2361', name: '芒市' },
        { id: '2362', name: '瑞丽市' },
        { id: '2363', name: '盈江县' },
        { id: '2364', name: '梁河县' },
        { id: '2365', name: '陇川县' }
      ],
      2366: [
        { id: '2367', name: '泸水县' },
        { id: '2368', name: '福贡县' },
        { id: '2369', name: '兰坪县' },
        { id: '2370', name: '贡山县' }
      ],
      2235: [
        { id: '2246', name: '盘龙区' },
        { id: '3912', name: '五华区' },
        { id: '3914', name: '西山区' },
        { id: '3913', name: '官渡区' },
        { id: '27497', name: '呈贡区' },
        { id: '2236', name: '东川区' },
        { id: '2237', name: '安宁市' },
        { id: '2238', name: '富民县' },
        { id: '2239', name: '嵩明县' },
        { id: '2241', name: '晋宁县' },
        { id: '2242', name: '宜良县' },
        { id: '2243', name: '禄劝县' },
        { id: '2244', name: '石林县' },
        { id: '2245', name: '寻甸县' }
      ],
      2247: [
        { id: '21034', name: '麒麟区' },
        { id: '2249', name: '马龙县' },
        { id: '2250', name: '宣威市' },
        { id: '2251', name: '富源县' },
        { id: '2252', name: '会泽县' },
        { id: '2253', name: '陆良县' },
        { id: '2254', name: '师宗县' },
        { id: '2255', name: '罗平县' },
        { id: '2256', name: '沾益县' }
      ],
      2258: [
        { id: '2259', name: '红塔区' },
        { id: '2260', name: '华宁县' },
        { id: '2261', name: '澄江县' },
        { id: '2262', name: '易门县' },
        { id: '2263', name: '通海县' },
        { id: '2264', name: '江川县' },
        { id: '2265', name: '元江县' },
        { id: '2266', name: '新平县' },
        { id: '2267', name: '峨山县' }
      ],
      2270: [
        { id: '3002', name: '鲁甸县' },
        { id: '3003', name: '绥江县' },
        { id: '2271', name: '昭阳区' },
        { id: '2272', name: '镇雄县' },
        { id: '2273', name: '永善县' },
        { id: '2274', name: '大关县' },
        { id: '2275', name: '盐津县' },
        { id: '2276', name: '彝良县' },
        { id: '2277', name: '水富县' },
        { id: '2278', name: '巧家县' },
        { id: '2279', name: '威信县' }
      ],
      2281: [
        { id: '2958', name: '孟连县' },
        { id: '2282', name: '思茅区' },
        { id: '2283', name: '宁洱县' },
        { id: '2284', name: '景东县' },
        { id: '2285', name: '镇沅县' },
        { id: '2286', name: '景谷县' },
        { id: '2287', name: '墨江县' },
        { id: '2288', name: '澜沧县' },
        { id: '2289', name: '西盟县' },
        { id: '2290', name: '江城县' }
      ],
      2291: [
        { id: '3915', name: '双江县' },
        { id: '3916', name: '沧源县' },
        { id: '2292', name: '临翔区' },
        { id: '2293', name: '镇康县' },
        { id: '2294', name: '凤庆县' },
        { id: '2295', name: '云县' },
        { id: '2296', name: '永德县' },
        { id: '2297', name: '耿马县' }
      ],
      2298: [
        { id: '2299', name: '隆阳区' },
        { id: '2300', name: '施甸县' },
        { id: '2301', name: '昌宁县' },
        { id: '2302', name: '龙陵县' },
        { id: '2303', name: '腾冲县' }
      ],
      3107: [
        { id: '53091', name: '双湖县' },
        { id: '3108', name: '索县' },
        { id: '3961', name: '那曲县' },
        { id: '3962', name: '嘉黎县' },
        { id: '3963', name: '比如县' },
        { id: '3964', name: '聂荣县' },
        { id: '3965', name: '安多县' },
        { id: '3966', name: '申扎县' },
        { id: '3967', name: '班戈县' },
        { id: '3968', name: '巴青县' },
        { id: '3969', name: '尼玛县' }
      ],
      3129: [
        { id: '3130', name: '贡嘎县' },
        { id: '3934', name: '扎囊县' },
        { id: '3935', name: '乃东县' },
        { id: '3936', name: '桑日县' },
        { id: '3937', name: '琼结县' },
        { id: '3938', name: '曲松县' },
        { id: '3939', name: '措美县' },
        { id: '3940', name: '洛扎县' },
        { id: '3941', name: '加查县' },
        { id: '3942', name: '隆子县' },
        { id: '3943', name: '错那县' },
        { id: '3944', name: '浪卡子县' }
      ],
      3138: [
        { id: '3139', name: '昌都县' },
        { id: '3924', name: '江达县' },
        { id: '3925', name: '贡觉县' },
        { id: '3926', name: '类乌齐县' },
        { id: '3927', name: '丁青县' },
        { id: '3928', name: '察雅县' },
        { id: '3929', name: '八宿县' },
        { id: '3930', name: '左贡县' },
        { id: '3931', name: '芒康县' },
        { id: '3932', name: '洛隆县' },
        { id: '3933', name: '边坝县' }
      ],
      3144: [
        { id: '3160', name: '聂拉木县' },
        { id: '3166', name: '昂仁县' },
        { id: '3945', name: '日喀则市' },
        { id: '3946', name: '南木林县' },
        { id: '3947', name: '江孜县' },
        { id: '3948', name: '定日县' },
        { id: '3949', name: '萨迦县　' },
        { id: '3950', name: '拉孜县' },
        { id: '3951', name: '谢通门县' },
        { id: '3952', name: '白朗县' },
        { id: '3953', name: '仁布县' },
        { id: '3954', name: '康马县' },
        { id: '3955', name: '定结县' },
        { id: '3956', name: '仲巴县' },
        { id: '3957', name: '亚东县' },
        { id: '3958', name: '吉隆县' },
        { id: '3959', name: '萨嘎县' },
        { id: '3960', name: '岗巴县' }
      ],
      3970: [
        { id: '3972', name: '噶尔县' },
        { id: '3973', name: '普兰县' },
        { id: '3974', name: '札达县　' },
        { id: '3975', name: '日土县' },
        { id: '3976', name: '革吉县' },
        { id: '3977', name: '改则县' },
        { id: '3978', name: '措勤县' }
      ],
      3971: [
        { id: '3979', name: '林芝县' },
        { id: '3980', name: '工布江达县' },
        { id: '3981', name: '米林县' },
        { id: '3982', name: '墨脱县' },
        { id: '3983', name: '波密县' },
        { id: '3984', name: '察隅县' },
        { id: '3985', name: '朗县' }
      ],
      2951: [
        { id: '2952', name: '城关区' },
        { id: '3123', name: '林周县' },
        { id: '3918', name: '当雄县' },
        { id: '3919', name: '尼木县' },
        { id: '3920', name: '曲水县' },
        { id: '3921', name: '堆龙德庆县' },
        { id: '3922', name: '达孜县' },
        { id: '3923', name: '墨竹工卡县' }
      ],
      2376: [
        { id: '51881', name: '新城区' },
        { id: '4343', name: '雁塔区' },
        { id: '50230', name: '未央区' },
        { id: '50231', name: '长安区' },
        { id: '50232', name: '灞桥区' },
        { id: '50233', name: '碑林区' },
        { id: '50235', name: '莲湖区' },
        { id: '50236', name: '临潼区' },
        { id: '50237', name: '阎良区' },
        { id: '52075', name: '西安武警工程学院' },
        { id: '2380', name: '高陵县' },
        { id: '2381', name: '蓝田县' },
        { id: '2382', name: '户县' },
        { id: '2383', name: '周至县' }
      ],
      2386: [
        { id: '2387', name: '印台区' },
        { id: '2388', name: '宜君县' },
        { id: '2389', name: '王益区' },
        { id: '3989', name: '耀州区' }
      ],
      2390: [
        { id: '2401', name: '渭滨区' },
        { id: '3990', name: '金台区' },
        { id: '2392', name: '岐山县' },
        { id: '2393', name: '太白县' },
        { id: '2394', name: '凤翔县' },
        { id: '2395', name: '陇县' },
        { id: '2396', name: '麟游县' },
        { id: '2397', name: '千阳县' },
        { id: '2398', name: '扶风县' },
        { id: '2399', name: '凤县' },
        { id: '2400', name: '眉县' },
        { id: '40650', name: '陈仓区' }
      ],
      2402: [
        { id: '44320', name: '秦都区' },
        { id: '44321', name: '渭城区' },
        { id: '2403', name: '兴平市' },
        { id: '2404', name: '礼泉县' },
        { id: '2405', name: '泾阳县' },
        { id: '2406', name: '永寿县' },
        { id: '2407', name: '三原县' },
        { id: '2408', name: '彬县' },
        { id: '2409', name: '旬邑县' },
        { id: '2411', name: '长武县' },
        { id: '2412', name: '乾县' },
        { id: '2413', name: '武功县' },
        { id: '2414', name: '淳化县' },
        { id: '44514', name: '杨陵区' }
      ],
      2416: [
        { id: '2417', name: '韩城市' },
        { id: '2418', name: '华阴市' },
        { id: '2419', name: '蒲城县' },
        { id: '2420', name: '华县' },
        { id: '2421', name: '潼关县' },
        { id: '2422', name: '大荔县' },
        { id: '2423', name: '澄城县' },
        { id: '2424', name: '合阳县' },
        { id: '2425', name: '白水县' },
        { id: '2426', name: '富平县' },
        { id: '38094', name: '临渭区' }
      ],
      2428: [
        { id: '31523', name: '宝塔区' },
        { id: '2429', name: '安塞县' },
        { id: '2430', name: '洛川县' },
        { id: '2431', name: '子长县' },
        { id: '2432', name: '黄陵县' },
        { id: '2433', name: '延长县' },
        { id: '2434', name: '宜川县' },
        { id: '2435', name: '延川县' },
        { id: '2436', name: '甘泉县' },
        { id: '2437', name: '富县' },
        { id: '2438', name: '志丹县' },
        { id: '2439', name: '黄龙县' },
        { id: '2440', name: '吴起县' }
      ],
      2442: [
        { id: '53107', name: '经济开发区南区' },
        { id: '31864', name: '汉台区' },
        { id: '2443', name: '南郑县' },
        { id: '2444', name: '城固县' },
        { id: '2445', name: '洋县' },
        { id: '2446', name: '佛坪县' },
        { id: '2447', name: '留坝县' },
        { id: '2448', name: '镇巴县' },
        { id: '2449', name: '西乡县' },
        { id: '2450', name: '勉县' },
        { id: '2451', name: '略阳县' },
        { id: '2452', name: '宁强县' }
      ],
      2454: [
        { id: '2456', name: '清涧县' },
        { id: '2457', name: '绥德县' },
        { id: '2459', name: '佳县' },
        { id: '2460', name: '神木县' },
        { id: '2461', name: '府谷县' },
        { id: '2462', name: '子洲县' },
        { id: '2464', name: '横山县' },
        { id: '2465', name: '米脂县' },
        { id: '2466', name: '吴堡县' },
        { id: '2467', name: '定边县' },
        { id: '31680', name: '榆阳区' },
        { id: '4081', name: '靖边县' }
      ],
      2468: [
        { id: '2469', name: '商州区' },
        { id: '2470', name: '镇安县' },
        { id: '2471', name: '山阳县' },
        { id: '2472', name: '洛南县' },
        { id: '2473', name: '商南县' },
        { id: '2474', name: '丹凤县' },
        { id: '2475', name: '柞水县' }
      ],
      2476: [
        { id: '3993', name: '汉滨区' },
        { id: '2478', name: '紫阳县' },
        { id: '2479', name: '岚皋县' },
        { id: '2480', name: '旬阳县' },
        { id: '2481', name: '镇坪县' },
        { id: '2482', name: '平利县' },
        { id: '2483', name: '宁陕县' },
        { id: '2484', name: '汉阴县' },
        { id: '2485', name: '石泉县' },
        { id: '2486', name: '白河县' }
      ],
      2564: [
        { id: '2565', name: '合作市' },
        { id: '2566', name: '夏河县' },
        { id: '2567', name: '碌曲县' },
        { id: '2568', name: '舟曲县' },
        { id: '2569', name: '玛曲县' },
        { id: '2570', name: '迭部县' },
        { id: '2571', name: '临潭县' },
        { id: '2572', name: '卓尼县' }
      ],
      3080: [
        { id: '3081', name: '岷县' },
        { id: '4002', name: '安定区' },
        { id: '4003', name: '通渭县' },
        { id: '4004', name: '临洮县' },
        { id: '4005', name: '漳县' },
        { id: '4006', name: '渭源县' },
        { id: '4007', name: '陇西县' }
      ],
      2573: [
        { id: '2574', name: '临夏县' },
        { id: '2575', name: '康乐县' },
        { id: '2576', name: '永靖县' },
        { id: '2577', name: '和政县' },
        { id: '2578', name: '东乡族自治县' },
        { id: '2579', name: '积石山县' },
        { id: '3175', name: '临夏市' },
        { id: '4008', name: '广河县' }
      ],
      2487: [
        { id: '21646', name: '七里河区' },
        { id: '21647', name: '安宁区' },
        { id: '21648', name: '城关区' },
        { id: '3995', name: '西固区' },
        { id: '3997', name: '红古区' },
        { id: '2488', name: '永登县' },
        { id: '2489', name: '榆中县' },
        { id: '2490', name: '皋兰县' }
      ],
      2492: [
        { id: '2493', name: '永昌县' },
        { id: '2494', name: '金川区' }
      ],
      2495: [
        { id: '2496', name: '白银区' },
        { id: '2497', name: '平川区' },
        { id: '2498', name: '靖远县' },
        { id: '2499', name: '景泰县' },
        { id: '2500', name: '会宁县' }
      ],
      2501: [
        { id: '21644', name: '麦积区' },
        { id: '21645', name: '秦州区' },
        { id: '2504', name: '甘谷县' },
        { id: '2505', name: '武山县' },
        { id: '2506', name: '清水县' },
        { id: '2507', name: '秦安县' },
        { id: '2508', name: '张家川县' }
      ],
      2509: [
        { id: '16899', name: '长城区' },
        { id: '16923', name: '镜铁区' },
        { id: '2970', name: '雄关区' }
      ],
      2518: [
        { id: '3998', name: '静宁县' },
        { id: '3023', name: '崆峒区' },
        { id: '2519', name: '华亭县' },
        { id: '2520', name: '崇信县' },
        { id: '2521', name: '泾川县' },
        { id: '2522', name: '灵台县' },
        { id: '2524', name: '庄浪县' }
      ],
      2525: [
        { id: '4001', name: '庆城县' },
        { id: '2526', name: '西峰区' },
        { id: '2528', name: '镇原县' },
        { id: '2529', name: '合水县' },
        { id: '2530', name: '华池县' },
        { id: '2531', name: '环县' },
        { id: '2532', name: '宁县' },
        { id: '2533', name: '正宁县' }
      ],
      2534: [
        { id: '2535', name: '成县' },
        { id: '2536', name: '礼县' },
        { id: '2537', name: '康县' },
        { id: '2538', name: '武都区' },
        { id: '2539', name: '文县' },
        { id: '2540', name: '两当县' },
        { id: '2541', name: '徽县' },
        { id: '2542', name: '宕昌县' },
        { id: '2543', name: '西和县' }
      ],
      2544: [
        { id: '2545', name: '凉州区' },
        { id: '2546', name: '古浪县' },
        { id: '2547', name: '天祝县' },
        { id: '2548', name: '民勤县' }
      ],
      2549: [
        { id: '2550', name: '甘州区' },
        { id: '2551', name: '山丹县' },
        { id: '2552', name: '临泽县' },
        { id: '2553', name: '高台县' },
        { id: '2554', name: '肃南县' },
        { id: '2555', name: '民乐县' }
      ],
      2556: [
        { id: '2560', name: '金塔县' },
        { id: '2562', name: '阿克塞县' },
        { id: '2563', name: '肃北县' },
        { id: '3999', name: '瓜州县' },
        { id: '4000', name: '肃州区' },
        { id: '2558', name: '玉门市' },
        { id: '2559', name: '敦煌市' }
      ],
      2580: [
        { id: '2581', name: '湟中县' },
        { id: '2582', name: '湟源县' },
        { id: '2583', name: '大通县' },
        { id: '21652', name: '城中区' },
        { id: '21653', name: '城东区' },
        { id: '21654', name: '城西区' },
        { id: '21655', name: '城北区' }
      ],
      2585: [
        { id: '2586', name: '平安县' },
        { id: '2587', name: '乐都县' },
        { id: '2588', name: '民和县' },
        { id: '2589', name: '互助县' },
        { id: '2590', name: '化隆县' },
        { id: '2591', name: '循化县' }
      ],
      2592: [
        { id: '2593', name: '海晏县' },
        { id: '2594', name: '祁连县' },
        { id: '2595', name: '刚察县' },
        { id: '2596', name: '门源县' }
      ],
      2597: [
        { id: '2598', name: '尖扎县' },
        { id: '2599', name: '同仁县' },
        { id: '2600', name: '泽库县' },
        { id: '2602', name: '河南县' }
      ],
      2603: [
        { id: '4012', name: '共和县' },
        { id: '4013', name: '同德县' },
        { id: '4014', name: '贵德县' },
        { id: '4015', name: '兴海县' },
        { id: '4016', name: '贵南县' }
      ],
      2605: [
        { id: '2606', name: '玛沁县' },
        { id: '2607', name: '甘德县' },
        { id: '2608', name: '达日县' },
        { id: '2609', name: '班玛县' },
        { id: '2610', name: '久治县' },
        { id: '2611', name: '玛多县' }
      ],
      2612: [
        { id: '2613', name: '玉树县' },
        { id: '2614', name: '称多县' },
        { id: '2615', name: '囊谦县' },
        { id: '2616', name: '杂多县' },
        { id: '2617', name: '治多县' },
        { id: '2618', name: '曲麻莱县' }
      ],
      2620: [
        { id: '2621', name: '德令哈市' },
        { id: '2622', name: '乌兰县' },
        { id: '2623', name: '天峻县' },
        { id: '2624', name: '都兰县' },
        { id: '2625', name: '大柴旦行委' },
        { id: '2626', name: '冷湖行委' },
        { id: '2627', name: '茫崖行委' },
        { id: '3021', name: '格尔木市' }
      ],
      2628: [
        { id: '2629', name: '灵武市' },
        { id: '2630', name: '永宁县' },
        { id: '2631', name: '贺兰县' },
        { id: '21649', name: '兴庆区' },
        { id: '21650', name: '金凤区' },
        { id: '21651', name: '西夏区' }
      ],
      2632: [
        { id: '2633', name: '平罗县' },
        { id: '2635', name: '惠农区' },
        { id: '2636', name: '大武口区' }
      ],
      2637: [
        { id: '2638', name: '青铜峡市' },
        { id: '2641', name: '同心县' },
        { id: '2642', name: '盐池县' },
        { id: '2643', name: '红寺堡开发区' },
        { id: '2966', name: '利通区' }
      ],
      2644: [
        { id: '2647', name: '西吉县' },
        { id: '2648', name: '隆德县' },
        { id: '2649', name: '泾源县' },
        { id: '2650', name: '彭阳县' },
        { id: '2651', name: '原州区' }
      ],
      3071: [
        { id: '3072', name: '中宁县' },
        { id: '3148', name: '海原县' },
        { id: '4020', name: '沙坡头区' }
      ],
      4110: [{ id: '4122', name: '五家渠市' }],
      15945: [{ id: '15948', name: '阿拉尔市' }],
      15946: [{ id: '15947', name: '图木舒克市' }],
      2652: [
        { id: '36684', name: '天山区' },
        { id: '4024', name: '头屯河区' },
        { id: '4025', name: '达坂城区' },
        { id: '4026', name: '米东区' },
        { id: '36685', name: '新市区' },
        { id: '36686', name: '沙依巴克区' },
        { id: '36687', name: '水磨沟区' },
        { id: '2653', name: '乌鲁木齐县' }
      ],
      2654: [
        { id: '2655', name: '克拉玛依区' },
        { id: '2930', name: '独山子区' },
        { id: '4027', name: '乌尔禾区' },
        { id: '3006', name: '白碱滩区' }
      ],
      2656: [{ id: '2657', name: '石河子市' }],
      2658: [
        { id: '2659', name: '吐鲁番市' },
        { id: '2660', name: '托克逊县' },
        { id: '2661', name: '鄯善县' }
      ],
      53090: [{ id: '53108', name: '铁门关市' }],
      2662: [
        { id: '2663', name: '哈密市' },
        { id: '2664', name: '巴里坤县' },
        { id: '2665', name: '伊吾县' }
      ],
      2666: [
        { id: '14848', name: '和田县' },
        { id: '2667', name: '和田市' },
        { id: '2669', name: '墨玉县' },
        { id: '2670', name: '洛浦县' },
        { id: '2671', name: '策勒县' },
        { id: '2672', name: '于田县' },
        { id: '2673', name: '民丰县' },
        { id: '2674', name: '皮山县' }
      ],
      2675: [
        { id: '2676', name: '阿克苏市' },
        { id: '2678', name: '温宿县' },
        { id: '2679', name: '沙雅县' },
        { id: '2680', name: '拜城县' },
        { id: '2681', name: '阿瓦提县' },
        { id: '2682', name: '库车县' },
        { id: '2683', name: '柯坪县' },
        { id: '2684', name: '新和县' },
        { id: '2685', name: '乌什县' }
      ],
      2686: [
        { id: '2687', name: '喀什市' },
        { id: '2688', name: '巴楚县' },
        { id: '2689', name: '泽普县' },
        { id: '2690', name: '伽师县' },
        { id: '2691', name: '叶城县' },
        { id: '2692', name: '岳普湖县' },
        { id: '2693', name: '疏附县' },
        { id: '2694', name: '疏勒县' },
        { id: '2695', name: '英吉沙县' },
        { id: '2696', name: '麦盖提县' },
        { id: '2697', name: '莎车县' },
        { id: '2698', name: '塔什库尔干县' }
      ],
      2699: [
        { id: '2700', name: '阿图什市' },
        { id: '2701', name: '阿合奇县' },
        { id: '2702', name: '乌恰县' },
        { id: '2703', name: '阿克陶县' }
      ],
      2704: [
        { id: '2705', name: '库尔勒市' },
        { id: '2706', name: '尉犁县' },
        { id: '2707', name: '和静县' },
        { id: '2708', name: '博湖县' },
        { id: '2709', name: '和硕县' },
        { id: '2710', name: '轮台县' },
        { id: '2711', name: '若羌县' },
        { id: '2712', name: '且末县' },
        { id: '2713', name: '焉耆县' }
      ],
      2714: [
        { id: '2715', name: '昌吉市' },
        { id: '2716', name: '阜康市' },
        { id: '2718', name: '奇台县' },
        { id: '2719', name: '玛纳斯县' },
        { id: '2720', name: '吉木萨尔县' },
        { id: '2721', name: '呼图壁县' },
        { id: '2722', name: '木垒县' }
      ],
      2723: [
        { id: '52790', name: '阿拉山口市' },
        { id: '2724', name: '博乐市' },
        { id: '2725', name: '精河县' },
        { id: '2726', name: '温泉县' }
      ],
      2727: [
        { id: '4499', name: '伊宁县' },
        { id: '2728', name: '伊宁市' },
        { id: '2729', name: '特克斯县' },
        { id: '2730', name: '尼勒克县' },
        { id: '2731', name: '昭苏县' },
        { id: '2732', name: '新源县' },
        { id: '2733', name: '霍城县' },
        { id: '2734', name: '察布查尔县' },
        { id: '2735', name: '巩留县' },
        { id: '4028', name: '奎屯市' }
      ],
      2736: [
        { id: '2737', name: '塔城市' },
        { id: '2738', name: '乌苏市' },
        { id: '2739', name: '额敏县' },
        { id: '2740', name: '裕民县' },
        { id: '2741', name: '沙湾县' },
        { id: '2742', name: '托里县' },
        { id: '2743', name: '和布克赛尔县' }
      ],
      2744: [
        { id: '6822', name: '北屯市' },
        { id: '2745', name: '阿勒泰市' },
        { id: '2746', name: '富蕴县' },
        { id: '2747', name: '青河县' },
        { id: '2748', name: '吉木乃县' },
        { id: '2749', name: '布尔津县' },
        { id: '2750', name: '福海县' },
        { id: '2751', name: '哈巴河县' }
      ],
      2768: [
        { id: '53504', name: '金门' },
        { id: '53505', name: '连江' },
        { id: '53506', name: '苗栗' },
        { id: '53507', name: '南投' },
        { id: '53508', name: '澎湖' },
        { id: '53509', name: '屏东' },
        { id: '53510', name: '台东' },
        { id: '53511', name: '台中' },
        { id: '53512', name: '台南' },
        { id: '53513', name: '台北' },
        { id: '53514', name: '桃园' },
        { id: '53515', name: '云林' },
        { id: '53516', name: '新北' },
        { id: '53497', name: '彰化' },
        { id: '53498', name: '嘉义' },
        { id: '53499', name: '新竹' },
        { id: '53500', name: '花莲' },
        { id: '53501', name: '宜兰' },
        { id: '53502', name: '高雄' },
        { id: '53503', name: '基隆' }
      ],
      1310: [
        { id: '53263', name: '钓鱼岛县1' },
        { id: '53281', name: '钓鱼岛全区' },
        { id: '53262', name: '钓鱼岛县' }
      ],
      52994: [
        { id: '52996', name: '中西区' },
        { id: '52997', name: '东区' },
        { id: '52998', name: '九龙城区' },
        { id: '52999', name: '观塘区' },
        { id: '53000', name: '深水埗区' },
        { id: '53001', name: '湾仔区' },
        { id: '53002', name: '黄大仙区' },
        { id: '53003', name: '油尖旺区' },
        { id: '53004', name: '离岛区' },
        { id: '53005', name: '葵青区' },
        { id: '53006', name: '北区' },
        { id: '53007', name: '西贡区' },
        { id: '53008', name: '沙田区' },
        { id: '53009', name: '屯门区' },
        { id: '53010', name: '大埔区' },
        { id: '53011', name: '荃湾区' },
        { id: '53012', name: '元朗区' },
        { id: '53013', name: '香港' },
        { id: '53014', name: '九龙' },
        { id: '53015', name: '新界' }
      ],
      52995: [
        { id: '53016', name: '澳门特别行政区' },
        { id: '53017', name: '澳门半岛' },
        { id: '53018', name: '凼仔' },
        { id: '53019', name: '路凼城' },
        { id: '53020', name: '路环' }
      ]
    }

    const navData = ref(props.parentData)
    const nowData = ref({})
    const isHover = ref(false)
    // 显示选择地址框
    const showAddress = () => {
      navData.value = []
      nowData.value = { idx: 1, data: provinceData }
      isHover.value = true
    }

    const chooseAddress = (val, key, idx) => {
      navData.value.push({ name: val, key: key })
      let data = {}
      if (idx === 1) { data = cityData[key] } else if (idx === 2) {
        data = distData[key]
      } else {
        context.emit('getAddress', navData.value)
        isHover.value = false
      }
      nowData.value = { idx: idx + 1, data: data }
    }
    return {
      showAddress,
      chooseAddress,
      navData,
      nowData,
      isHover
    }
  }
}
</script>

<style lang="scss" scoped>
.area {
  height: 36px;
  background-color: #fff;
  border: 1px solid #ccc;
  position: relative;
  display: flex;
  align-items: center;
  color: #ccc;
}
.areatext {
  height: 26px;
  line-height: 26px;
  padding: 0 4px;
  cursor: pointer;
}
.hoverarea {
  margin-top: 170px;
  margin-left: -48px;
  width: 400px;
  height: 200px;
  background-color: #fff;
  //   border: 1px solid #ccc;
  border-bottom: 1px solid #ccc;
  border-left: 1px solid #ccc;
  border-right: 1px solid #ccc;
  display: flex;
  flex-direction: column;
}
.hoverarea .navtab {
  display: flex;

  margin: 4px 10px;
  border-bottom: 2px solid #e4a846;
}
.hoverarea .navtab .nav {
  margin-right: 10px;
  padding: 4px 20px;
  border-top: 1px solid #ccc;
  border-left: 1px solid #ccc;
  border-right: 1px solid #ccc;
  cursor: pointer;
}
.hoverarea .list {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  overflow-y: scroll;
}
.hoverarea .list .areaitem {
  padding: 4px 16px;
  height: 20px;
  cursor: pointer;
  color: #005ea7;
}
.hoverarea .areaitem:hover {
  color: #e4a846;
}
/* .hoverarea::after{
    position: absolute;
    content: "";
    top: 24px;
    left: -1px;
    width: 400px;
    height: 200px;;
    background-color: #fff;
    border: 1px solid #ccc;

} */
</style>
